
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
/*
MIT License

Copyright (c) 2017 Pavel Dobryakov

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.
*/ // Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
// This will be treated as a bit flag in the future, so we keep it using power-of-two values.
/** Specifies a specific HTTP transport type. */ var $dfd8c9cbca816579$export$789ba40ee1a75f0;
(function(HttpTransportType) {
    /** Specifies no transport preference. */ HttpTransportType[HttpTransportType["None"] = 0] = "None";
    /** Specifies the WebSockets transport. */ HttpTransportType[HttpTransportType["WebSockets"] = 1] = "WebSockets";
    /** Specifies the Server-Sent Events transport. */ HttpTransportType[HttpTransportType["ServerSentEvents"] = 2] = "ServerSentEvents";
    /** Specifies the Long Polling transport. */ HttpTransportType[HttpTransportType["LongPolling"] = 4] = "LongPolling";
})($dfd8c9cbca816579$export$789ba40ee1a75f0 || ($dfd8c9cbca816579$export$789ba40ee1a75f0 = {}));
var $dfd8c9cbca816579$export$f29afaa8e8d2989a;
(function(TransferFormat) {
    /** Specifies that only text data will be transmitted over the connection. */ TransferFormat[TransferFormat["Text"] = 1] = "Text";
    /** Specifies that binary data will be transmitted over the connection. */ TransferFormat[TransferFormat["Binary"] = 2] = "Binary";
})($dfd8c9cbca816579$export$f29afaa8e8d2989a || ($dfd8c9cbca816579$export$f29afaa8e8d2989a = {}));

// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
// 0, 2, 10, 30 second delays before reconnect attempts.
const $a70d4a2704acd148$var$DEFAULT_RETRY_DELAYS_IN_MILLISECONDS = [
    0,
    2000,
    10000,
    30000,
    null
];
class $a70d4a2704acd148$export$97bc471d6a059e6e {
    constructor(retryDelays){
        this._retryDelays = retryDelays !== undefined ? [
            ...retryDelays,
            null
        ] : $a70d4a2704acd148$var$DEFAULT_RETRY_DELAYS_IN_MILLISECONDS;
    }
    nextRetryDelayInMilliseconds(retryContext) {
        return this._retryDelays[retryContext.previousRetryCount];
    }
}


// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
class $2b7cf72ed2755a15$export$28d77f87efed1d88 {
}
$2b7cf72ed2755a15$export$28d77f87efed1d88.Authorization = "Authorization";
$2b7cf72ed2755a15$export$28d77f87efed1d88.Cookie = "Cookie";


// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
/** Represents an HTTP response. */ class $25eb580f65a5de55$export$1d94dfe0d9d1f1e7 {
    constructor(statusCode, statusText, content){
        this.statusCode = statusCode;
        this.statusText = statusText;
        this.content = content;
    }
}
class $25eb580f65a5de55$export$8c6ee871e681f0f4 {
    get(url, options) {
        return this.send({
            ...options,
            method: "GET",
            url: url
        });
    }
    post(url, options) {
        return this.send({
            ...options,
            method: "POST",
            url: url
        });
    }
    delete(url, options) {
        return this.send({
            ...options,
            method: "DELETE",
            url: url
        });
    }
    /** Gets all cookies that apply to the specified URL.
     *
     * @param url The URL that the cookies are valid for.
     * @returns {string} A string containing all the key-value cookie pairs for the specified URL.
     */ // @ts-ignore
    getCookieString(url) {
        return "";
    }
}


class $3017bfe8a565980c$export$981ab95414418dd3 extends (0, $25eb580f65a5de55$export$8c6ee871e681f0f4) {
    constructor(innerClient, accessTokenFactory){
        super();
        this._innerClient = innerClient;
        this._accessTokenFactory = accessTokenFactory;
    }
    async send(request) {
        let allowRetry = true;
        if (this._accessTokenFactory && (!this._accessToken || request.url && request.url.indexOf("/negotiate?") > 0)) {
            // don't retry if the request is a negotiate or if we just got a potentially new token from the access token factory
            allowRetry = false;
            this._accessToken = await this._accessTokenFactory();
        }
        this._setAuthorizationHeader(request);
        const response = await this._innerClient.send(request);
        if (allowRetry && response.statusCode === 401 && this._accessTokenFactory) {
            this._accessToken = await this._accessTokenFactory();
            this._setAuthorizationHeader(request);
            return await this._innerClient.send(request);
        }
        return response;
    }
    _setAuthorizationHeader(request) {
        if (!request.headers) request.headers = {};
        if (this._accessToken) request.headers[(0, $2b7cf72ed2755a15$export$28d77f87efed1d88).Authorization] = `Bearer ${this._accessToken}`;
        else if (this._accessTokenFactory) {
            if (request.headers[(0, $2b7cf72ed2755a15$export$28d77f87efed1d88).Authorization]) delete request.headers[(0, $2b7cf72ed2755a15$export$28d77f87efed1d88).Authorization];
        }
    }
    getCookieString(url) {
        return this._innerClient.getCookieString(url);
    }
}


// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
/** Error thrown when an HTTP request fails. */ class $9862e2597169e2d4$export$65bd6083489bd8bb extends Error {
    /** Constructs a new instance of {@link @microsoft/signalr.HttpError}.
     *
     * @param {string} errorMessage A descriptive error message.
     * @param {number} statusCode The HTTP status code represented by this error.
     */ constructor(errorMessage, statusCode){
        const trueProto = new.target.prototype;
        super(`${errorMessage}: Status code '${statusCode}'`);
        this.statusCode = statusCode;
        // Workaround issue in Typescript compiler
        // https://github.com/Microsoft/TypeScript/issues/13965#issuecomment-278570200
        this.__proto__ = trueProto;
    }
}
class $9862e2597169e2d4$export$66d311bf29d5c89c extends Error {
    /** Constructs a new instance of {@link @microsoft/signalr.TimeoutError}.
     *
     * @param {string} errorMessage A descriptive error message.
     */ constructor(errorMessage = "A timeout occurred."){
        const trueProto = new.target.prototype;
        super(errorMessage);
        // Workaround issue in Typescript compiler
        // https://github.com/Microsoft/TypeScript/issues/13965#issuecomment-278570200
        this.__proto__ = trueProto;
    }
}
class $9862e2597169e2d4$export$18b052ffd8c84d7 extends Error {
    /** Constructs a new instance of {@link AbortError}.
     *
     * @param {string} errorMessage A descriptive error message.
     */ constructor(errorMessage = "An abort occurred."){
        const trueProto = new.target.prototype;
        super(errorMessage);
        // Workaround issue in Typescript compiler
        // https://github.com/Microsoft/TypeScript/issues/13965#issuecomment-278570200
        this.__proto__ = trueProto;
    }
}
class $9862e2597169e2d4$export$c7cbd7482d8bece8 extends Error {
    /** Constructs a new instance of {@link @microsoft/signalr.UnsupportedTransportError}.
     *
     * @param {string} message A descriptive error message.
     * @param {HttpTransportType} transport The {@link @microsoft/signalr.HttpTransportType} this error occurred on.
     */ constructor(message, transport){
        const trueProto = new.target.prototype;
        super(message);
        this.transport = transport;
        this.errorType = 'UnsupportedTransportError';
        // Workaround issue in Typescript compiler
        // https://github.com/Microsoft/TypeScript/issues/13965#issuecomment-278570200
        this.__proto__ = trueProto;
    }
}
class $9862e2597169e2d4$export$764b8cd64449c5b0 extends Error {
    /** Constructs a new instance of {@link @microsoft/signalr.DisabledTransportError}.
     *
     * @param {string} message A descriptive error message.
     * @param {HttpTransportType} transport The {@link @microsoft/signalr.HttpTransportType} this error occurred on.
     */ constructor(message, transport){
        const trueProto = new.target.prototype;
        super(message);
        this.transport = transport;
        this.errorType = 'DisabledTransportError';
        // Workaround issue in Typescript compiler
        // https://github.com/Microsoft/TypeScript/issues/13965#issuecomment-278570200
        this.__proto__ = trueProto;
    }
}
class $9862e2597169e2d4$export$264839a6ea29f91a extends Error {
    /** Constructs a new instance of {@link @microsoft/signalr.FailedToStartTransportError}.
     *
     * @param {string} message A descriptive error message.
     * @param {HttpTransportType} transport The {@link @microsoft/signalr.HttpTransportType} this error occurred on.
     */ constructor(message, transport){
        const trueProto = new.target.prototype;
        super(message);
        this.transport = transport;
        this.errorType = 'FailedToStartTransportError';
        // Workaround issue in Typescript compiler
        // https://github.com/Microsoft/TypeScript/issues/13965#issuecomment-278570200
        this.__proto__ = trueProto;
    }
}
class $9862e2597169e2d4$export$b4f59905103de78d extends Error {
    /** Constructs a new instance of {@link @microsoft/signalr.FailedToNegotiateWithServerError}.
     *
     * @param {string} message A descriptive error message.
     */ constructor(message){
        const trueProto = new.target.prototype;
        super(message);
        this.errorType = 'FailedToNegotiateWithServerError';
        // Workaround issue in Typescript compiler
        // https://github.com/Microsoft/TypeScript/issues/13965#issuecomment-278570200
        this.__proto__ = trueProto;
    }
}
class $9862e2597169e2d4$export$9341e26d19ed3783 extends Error {
    /** Constructs a new instance of {@link @microsoft/signalr.AggregateErrors}.
     *
     * @param {string} message A descriptive error message.
     * @param {Error[]} innerErrors The collection of errors this error is aggregating.
     */ constructor(message, innerErrors){
        const trueProto = new.target.prototype;
        super(message);
        this.innerErrors = innerErrors;
        // Workaround issue in Typescript compiler
        // https://github.com/Microsoft/TypeScript/issues/13965#issuecomment-278570200
        this.__proto__ = trueProto;
    }
}


// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.


// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
// These values are designed to match the ASP.NET Log Levels since that's the pattern we're emulating here.
/** Indicates the severity of a log message.
 *
 * Log Levels are ordered in increasing severity. So `Debug` is more severe than `Trace`, etc.
 */ var $5f3832d7be2e7d2f$export$243e62d78d3b544d;
(function(LogLevel) {
    /** Log level for very low severity diagnostic messages. */ LogLevel[LogLevel["Trace"] = 0] = "Trace";
    /** Log level for low severity diagnostic messages. */ LogLevel[LogLevel["Debug"] = 1] = "Debug";
    /** Log level for informational diagnostic messages. */ LogLevel[LogLevel["Information"] = 2] = "Information";
    /** Log level for diagnostic messages that indicate a non-fatal problem. */ LogLevel[LogLevel["Warning"] = 3] = "Warning";
    /** Log level for diagnostic messages that indicate a failure in the current operation. */ LogLevel[LogLevel["Error"] = 4] = "Error";
    /** Log level for diagnostic messages that indicate a failure that will terminate the entire application. */ LogLevel[LogLevel["Critical"] = 5] = "Critical";
    /** The highest possible log level. Used when configuring logging to indicate that no log messages should be emitted. */ LogLevel[LogLevel["None"] = 6] = "None";
})($5f3832d7be2e7d2f$export$243e62d78d3b544d || ($5f3832d7be2e7d2f$export$243e62d78d3b544d = {}));


// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.

// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
/** A logger that does nothing when log messages are sent to it. */ class $b632327c1843227b$export$17ac58a1138ded46 {
    constructor(){}
    /** @inheritDoc */ // eslint-disable-next-line
    log(_logLevel, _message) {}
}
/** The singleton instance of the {@link @microsoft/signalr.NullLogger}. */ $b632327c1843227b$export$17ac58a1138ded46.instance = new $b632327c1843227b$export$17ac58a1138ded46();


const $3c61bc8cbb9065de$export$a4ad2735b021c132 = '10.0.0';


var $cfae44f0dfdf62c0$exports = {};
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = $cfae44f0dfdf62c0$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = 'browser';
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ''; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return '/';
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};


class $32bb29965a07731e$export$83f0753fc4347e43 {
    static isRequired(val, name) {
        if (val === null || val === undefined) throw new Error(`The '${name}' argument is required.`);
    }
    static isNotEmpty(val, name) {
        if (!val || val.match(/^\s*$/)) throw new Error(`The '${name}' argument should not be empty.`);
    }
    static isIn(val, values, name) {
        // TypeScript enums have keys for **both** the name and the value of each enum member on the type itself.
        if (!(val in values)) throw new Error(`Unknown ${name} value: ${val}.`);
    }
}
class $32bb29965a07731e$export$2dffd0b5373a4389 {
    // react-native has a window but no document so we should check both
    static get isBrowser() {
        return !$32bb29965a07731e$export$2dffd0b5373a4389.isNode && typeof window === "object" && typeof window.document === "object";
    }
    // WebWorkers don't have a window object so the isBrowser check would fail
    static get isWebWorker() {
        return !$32bb29965a07731e$export$2dffd0b5373a4389.isNode && typeof self === "object" && "importScripts" in self;
    }
    // react-native has a window but no document
    static get isReactNative() {
        return !$32bb29965a07731e$export$2dffd0b5373a4389.isNode && typeof window === "object" && typeof window.document === "undefined";
    }
    // Node apps shouldn't have a window object, but WebWorkers don't either
    // so we need to check for both WebWorker and window
    static get isNode() {
        return false;
    }
}
function $32bb29965a07731e$export$a688b91586df8fd9(data, includeContent) {
    let detail = "";
    if ($32bb29965a07731e$export$9dd3754ae86f0017(data)) {
        detail = `Binary data of length ${data.byteLength}`;
        if (includeContent) detail += `. Content: '${$32bb29965a07731e$export$3ddcef0d22959f49(data)}'`;
    } else if (typeof data === "string") {
        detail = `String data of length ${data.length}`;
        if (includeContent) detail += `. Content: '${data}'`;
    }
    return detail;
}
function $32bb29965a07731e$export$3ddcef0d22959f49(data) {
    const view = new Uint8Array(data);
    // Uint8Array.map only supports returning another Uint8Array?
    let str = "";
    view.forEach((num)=>{
        const pad = num < 16 ? "0" : "";
        str += `0x${pad}${num.toString(16)} `;
    });
    // Trim of trailing space.
    return str.substring(0, str.length - 1);
}
function $32bb29965a07731e$export$9dd3754ae86f0017(val) {
    return val && typeof ArrayBuffer !== "undefined" && (val instanceof ArrayBuffer || // Sometimes we get an ArrayBuffer that doesn't satisfy instanceof
    val.constructor && val.constructor.name === "ArrayBuffer");
}
async function $32bb29965a07731e$export$465cb47180de50f0(logger, transportName, httpClient, url, content, options) {
    const headers = {};
    const [name, value] = $32bb29965a07731e$export$56c7340f89ca57c5();
    headers[name] = value;
    logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Trace, `(${transportName} transport) sending data. ${$32bb29965a07731e$export$a688b91586df8fd9(content, options.logMessageContent)}.`);
    const responseType = $32bb29965a07731e$export$9dd3754ae86f0017(content) ? "arraybuffer" : "text";
    const response = await httpClient.post(url, {
        content: content,
        headers: {
            ...headers,
            ...options.headers
        },
        responseType: responseType,
        timeout: options.timeout,
        withCredentials: options.withCredentials
    });
    logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Trace, `(${transportName} transport) request complete. Response status: ${response.statusCode}.`);
}
function $32bb29965a07731e$export$fe2e61603b61130d(logger) {
    if (logger === undefined) return new $32bb29965a07731e$export$ba6a9c7ac8291f7f((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Information);
    if (logger === null) return (0, $b632327c1843227b$export$17ac58a1138ded46).instance;
    if (logger.log !== undefined) return logger;
    return new $32bb29965a07731e$export$ba6a9c7ac8291f7f(logger);
}
class $32bb29965a07731e$export$b7a41f2bfb5c60c3 {
    constructor(subject, observer){
        this._subject = subject;
        this._observer = observer;
    }
    dispose() {
        const index = this._subject.observers.indexOf(this._observer);
        if (index > -1) this._subject.observers.splice(index, 1);
        if (this._subject.observers.length === 0 && this._subject.cancelCallback) this._subject.cancelCallback().catch((_)=>{});
    }
}
class $32bb29965a07731e$export$ba6a9c7ac8291f7f {
    constructor(minimumLogLevel){
        this._minLevel = minimumLogLevel;
        this.out = console;
    }
    log(logLevel, message) {
        if (logLevel >= this._minLevel) {
            const msg = `[${new Date().toISOString()}] ${(0, $5f3832d7be2e7d2f$export$243e62d78d3b544d)[logLevel]}: ${message}`;
            switch(logLevel){
                case (0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Critical:
                case (0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Error:
                    this.out.error(msg);
                    break;
                case (0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Warning:
                    this.out.warn(msg);
                    break;
                case (0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Information:
                    this.out.info(msg);
                    break;
                default:
                    // console.debug only goes to attached debuggers in Node, so we use console.log for Trace and Debug
                    this.out.log(msg);
                    break;
            }
        }
    }
}
function $32bb29965a07731e$export$56c7340f89ca57c5() {
    let userAgentHeaderName = "X-SignalR-User-Agent";
    if ($32bb29965a07731e$export$2dffd0b5373a4389.isNode) userAgentHeaderName = "User-Agent";
    return [
        userAgentHeaderName,
        $32bb29965a07731e$export$1feb51270b0ce71b((0, $3c61bc8cbb9065de$export$a4ad2735b021c132), $32bb29965a07731e$var$getOsName(), $32bb29965a07731e$var$getRuntime(), $32bb29965a07731e$var$getRuntimeVersion())
    ];
}
function $32bb29965a07731e$export$1feb51270b0ce71b(version, os, runtime, runtimeVersion) {
    // Microsoft SignalR/[Version] ([Detailed Version]; [Operating System]; [Runtime]; [Runtime Version])
    let userAgent = "Microsoft SignalR/";
    const majorAndMinor = version.split(".");
    userAgent += `${majorAndMinor[0]}.${majorAndMinor[1]}`;
    userAgent += ` (${version}; `;
    if (os && os !== "") userAgent += `${os}; `;
    else userAgent += "Unknown OS; ";
    userAgent += `${runtime}`;
    if (runtimeVersion) userAgent += `; ${runtimeVersion}`;
    else userAgent += "; Unknown Runtime Version";
    userAgent += ")";
    return userAgent;
}
// eslint-disable-next-line spaced-comment
/*#__PURE__*/ function $32bb29965a07731e$var$getOsName() {
    if ($32bb29965a07731e$export$2dffd0b5373a4389.isNode) switch($cfae44f0dfdf62c0$exports.platform){
        case "win32":
            return "Windows NT";
        case "darwin":
            return "macOS";
        case "linux":
            return "Linux";
        default:
            return $cfae44f0dfdf62c0$exports.platform;
    }
    else return "";
}
// eslint-disable-next-line spaced-comment
/*#__PURE__*/ function $32bb29965a07731e$var$getRuntimeVersion() {
    if ($32bb29965a07731e$export$2dffd0b5373a4389.isNode) return $cfae44f0dfdf62c0$exports.versions.node;
    return undefined;
}
function $32bb29965a07731e$var$getRuntime() {
    if ($32bb29965a07731e$export$2dffd0b5373a4389.isNode) return "NodeJS";
    else return "Browser";
}
function $32bb29965a07731e$export$375b49718dbd9ced(e) {
    if (e.stack) return e.stack;
    else if (e.message) return e.message;
    return `${e}`;
}
function $32bb29965a07731e$export$ff5f2eeb11fc7e14() {
    // globalThis is semi-new and not available in Node until v12
    if (typeof globalThis !== "undefined") return globalThis;
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw new Error("could not find global");
}


class $a898fbbbb5189898$export$1b51ed6f7c8f947b extends (0, $25eb580f65a5de55$export$8c6ee871e681f0f4) {
    constructor(logger){
        super();
        this._logger = logger;
        // Node added a fetch implementation to the global scope starting in v18.
        // We need to add a cookie jar in node to be able to share cookies with WebSocket
        if (typeof fetch === "undefined" || (0, $32bb29965a07731e$export$2dffd0b5373a4389).isNode) {
            // In order to ignore the dynamic require in webpack builds we need to do this magic
            // @ts-ignore: TS doesn't know about these names
            const requireFunc = typeof __webpack_require__ === "function" ? __non_webpack_require__ : undefined;
            // Cookies aren't automatically handled in Node so we need to add a CookieJar to preserve cookies across requests
            this._jar = new (requireFunc("tough-cookie")).CookieJar();
            if (typeof fetch === "undefined") this._fetchType = requireFunc("node-fetch");
            else // Use fetch from Node if available
            this._fetchType = fetch;
            // node-fetch doesn't have a nice API for getting and setting cookies
            // fetch-cookie will wrap a fetch implementation with a default CookieJar or a provided one
            this._fetchType = requireFunc("fetch-cookie")(this._fetchType, this._jar);
        } else this._fetchType = fetch.bind((0, $32bb29965a07731e$export$ff5f2eeb11fc7e14)());
        if (typeof AbortController === "undefined") {
            // In order to ignore the dynamic require in webpack builds we need to do this magic
            // @ts-ignore: TS doesn't know about these names
            const requireFunc = typeof __webpack_require__ === "function" ? __non_webpack_require__ : undefined;
            // Node needs EventListener methods on AbortController which our custom polyfill doesn't provide
            this._abortControllerType = requireFunc("abort-controller");
        } else this._abortControllerType = AbortController;
    }
    /** @inheritDoc */ async send(request) {
        // Check that abort was not signaled before calling send
        if (request.abortSignal && request.abortSignal.aborted) throw new (0, $9862e2597169e2d4$export$18b052ffd8c84d7)();
        if (!request.method) throw new Error("No method defined.");
        if (!request.url) throw new Error("No url defined.");
        const abortController = new this._abortControllerType();
        let error;
        // Hook our abortSignal into the abort controller
        if (request.abortSignal) request.abortSignal.onabort = ()=>{
            abortController.abort();
            error = new (0, $9862e2597169e2d4$export$18b052ffd8c84d7)();
        };
        // If a timeout has been passed in, setup a timeout to call abort
        // Type needs to be any to fit window.setTimeout and NodeJS.setTimeout
        let timeoutId = null;
        if (request.timeout) {
            const msTimeout = request.timeout;
            timeoutId = setTimeout(()=>{
                abortController.abort();
                this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Warning, `Timeout from HTTP request.`);
                error = new (0, $9862e2597169e2d4$export$66d311bf29d5c89c)();
            }, msTimeout);
        }
        if (request.content === "") request.content = undefined;
        if (request.content) {
            // Explicitly setting the Content-Type header for React Native on Android platform.
            request.headers = request.headers || {};
            if ((0, $32bb29965a07731e$export$9dd3754ae86f0017)(request.content)) request.headers["Content-Type"] = "application/octet-stream";
            else request.headers["Content-Type"] = "text/plain;charset=UTF-8";
        }
        let response;
        try {
            response = await this._fetchType(request.url, {
                body: request.content,
                cache: "no-cache",
                credentials: request.withCredentials === true ? "include" : "same-origin",
                headers: {
                    "X-Requested-With": "XMLHttpRequest",
                    ...request.headers
                },
                method: request.method,
                mode: "cors",
                redirect: "follow",
                signal: abortController.signal
            });
        } catch (e) {
            if (error) throw error;
            this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Warning, `Error from HTTP request. ${e}.`);
            throw e;
        } finally{
            if (timeoutId) clearTimeout(timeoutId);
            if (request.abortSignal) request.abortSignal.onabort = null;
        }
        if (!response.ok) {
            const errorMessage = await $a898fbbbb5189898$var$deserializeContent(response, "text");
            throw new (0, $9862e2597169e2d4$export$65bd6083489bd8bb)(errorMessage || response.statusText, response.status);
        }
        const content = $a898fbbbb5189898$var$deserializeContent(response, request.responseType);
        const payload = await content;
        return new (0, $25eb580f65a5de55$export$1d94dfe0d9d1f1e7)(response.status, response.statusText, payload);
    }
    getCookieString(url) {
        let cookies = "";
        if ((0, $32bb29965a07731e$export$2dffd0b5373a4389).isNode && this._jar) // @ts-ignore: unused variable
        this._jar.getCookies(url, (e, c)=>cookies = c.join("; "));
        return cookies;
    }
}
function $a898fbbbb5189898$var$deserializeContent(response, responseType) {
    let content;
    switch(responseType){
        case "arraybuffer":
            content = response.arrayBuffer();
            break;
        case "text":
            content = response.text();
            break;
        case "blob":
        case "document":
        case "json":
            throw new Error(`${responseType} is not supported.`);
        default:
            content = response.text();
            break;
    }
    return content;
}




// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.




class $e584b8a3345de0d8$export$33b9ed1bd07561aa extends (0, $25eb580f65a5de55$export$8c6ee871e681f0f4) {
    constructor(logger){
        super();
        this._logger = logger;
    }
    /** @inheritDoc */ send(request) {
        // Check that abort was not signaled before calling send
        if (request.abortSignal && request.abortSignal.aborted) return Promise.reject(new (0, $9862e2597169e2d4$export$18b052ffd8c84d7)());
        if (!request.method) return Promise.reject(new Error("No method defined."));
        if (!request.url) return Promise.reject(new Error("No url defined."));
        return new Promise((resolve, reject)=>{
            const xhr = new XMLHttpRequest();
            xhr.open(request.method, request.url, true);
            xhr.withCredentials = request.withCredentials === undefined ? true : request.withCredentials;
            xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
            if (request.content === "") request.content = undefined;
            if (request.content) {
                // Explicitly setting the Content-Type header for React Native on Android platform.
                if ((0, $32bb29965a07731e$export$9dd3754ae86f0017)(request.content)) xhr.setRequestHeader("Content-Type", "application/octet-stream");
                else xhr.setRequestHeader("Content-Type", "text/plain;charset=UTF-8");
            }
            const headers = request.headers;
            if (headers) Object.keys(headers).forEach((header)=>{
                xhr.setRequestHeader(header, headers[header]);
            });
            if (request.responseType) xhr.responseType = request.responseType;
            if (request.abortSignal) request.abortSignal.onabort = ()=>{
                xhr.abort();
                reject(new (0, $9862e2597169e2d4$export$18b052ffd8c84d7)());
            };
            if (request.timeout) xhr.timeout = request.timeout;
            xhr.onload = ()=>{
                if (request.abortSignal) request.abortSignal.onabort = null;
                if (xhr.status >= 200 && xhr.status < 300) resolve(new (0, $25eb580f65a5de55$export$1d94dfe0d9d1f1e7)(xhr.status, xhr.statusText, xhr.response || xhr.responseText));
                else reject(new (0, $9862e2597169e2d4$export$65bd6083489bd8bb)(xhr.response || xhr.responseText || xhr.statusText, xhr.status));
            };
            xhr.onerror = ()=>{
                this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Warning, `Error from HTTP request. ${xhr.status}: ${xhr.statusText}.`);
                reject(new (0, $9862e2597169e2d4$export$65bd6083489bd8bb)(xhr.statusText, xhr.status));
            };
            xhr.ontimeout = ()=>{
                this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Warning, `Timeout from HTTP request.`);
                reject(new (0, $9862e2597169e2d4$export$66d311bf29d5c89c)());
            };
            xhr.send(request.content);
        });
    }
}


class $c9ca2928589aa40c$export$4f11ab3560c519e5 extends (0, $25eb580f65a5de55$export$8c6ee871e681f0f4) {
    /** Creates a new instance of the {@link @microsoft/signalr.DefaultHttpClient}, using the provided {@link @microsoft/signalr.ILogger} to log messages. */ constructor(logger){
        super();
        if (typeof fetch !== "undefined" || (0, $32bb29965a07731e$export$2dffd0b5373a4389).isNode) this._httpClient = new (0, $a898fbbbb5189898$export$1b51ed6f7c8f947b)(logger);
        else if (typeof XMLHttpRequest !== "undefined") this._httpClient = new (0, $e584b8a3345de0d8$export$33b9ed1bd07561aa)(logger);
        else throw new Error("No usable HttpClient found.");
    }
    /** @inheritDoc */ send(request) {
        // Check that abort was not signaled before calling send
        if (request.abortSignal && request.abortSignal.aborted) return Promise.reject(new (0, $9862e2597169e2d4$export$18b052ffd8c84d7)());
        if (!request.method) return Promise.reject(new Error("No method defined."));
        if (!request.url) return Promise.reject(new Error("No url defined."));
        return this._httpClient.send(request);
    }
    getCookieString(url) {
        return this._httpClient.getCookieString(url);
    }
}





// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
// Rough polyfill of https://developer.mozilla.org/en-US/docs/Web/API/AbortController
// We don't actually ever use the API being polyfilled, we always use the polyfill because
// it's a very new API right now.
// Not exported from index.
/** @private */ class $45591c3c8a133c1f$export$48f7e099c149af88 {
    constructor(){
        this._isAborted = false;
        this.onabort = null;
    }
    abort() {
        if (!this._isAborted) {
            this._isAborted = true;
            if (this.onabort) this.onabort();
        }
    }
    get signal() {
        return this;
    }
    get aborted() {
        return this._isAborted;
    }
}






class $68d775930ce5466a$export$fbd8c90d2cca1300 {
    // This is an internal type, not exported from 'index' so this is really just internal.
    get pollAborted() {
        return this._pollAbort.aborted;
    }
    constructor(httpClient, logger, options){
        this._httpClient = httpClient;
        this._logger = logger;
        this._pollAbort = new (0, $45591c3c8a133c1f$export$48f7e099c149af88)();
        this._options = options;
        this._running = false;
        this.onreceive = null;
        this.onclose = null;
    }
    async connect(url, transferFormat) {
        (0, $32bb29965a07731e$export$83f0753fc4347e43).isRequired(url, "url");
        (0, $32bb29965a07731e$export$83f0753fc4347e43).isRequired(transferFormat, "transferFormat");
        (0, $32bb29965a07731e$export$83f0753fc4347e43).isIn(transferFormat, (0, $dfd8c9cbca816579$export$f29afaa8e8d2989a), "transferFormat");
        this._url = url;
        this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Trace, "(LongPolling transport) Connecting.");
        // Allow binary format on Node and Browsers that support binary content (indicated by the presence of responseType property)
        if (transferFormat === (0, $dfd8c9cbca816579$export$f29afaa8e8d2989a).Binary && typeof XMLHttpRequest !== "undefined" && typeof new XMLHttpRequest().responseType !== "string") throw new Error("Binary protocols over XmlHttpRequest not implementing advanced features are not supported.");
        const [name, value] = (0, $32bb29965a07731e$export$56c7340f89ca57c5)();
        const headers = {
            [name]: value,
            ...this._options.headers
        };
        const pollOptions = {
            abortSignal: this._pollAbort.signal,
            headers: headers,
            timeout: 100000,
            withCredentials: this._options.withCredentials
        };
        if (transferFormat === (0, $dfd8c9cbca816579$export$f29afaa8e8d2989a).Binary) pollOptions.responseType = "arraybuffer";
        // Make initial long polling request
        // Server uses first long polling request to finish initializing connection and it returns without data
        const pollUrl = `${url}&_=${Date.now()}`;
        this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Trace, `(LongPolling transport) polling: ${pollUrl}.`);
        const response = await this._httpClient.get(pollUrl, pollOptions);
        if (response.statusCode !== 200) {
            this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Error, `(LongPolling transport) Unexpected response code: ${response.statusCode}.`);
            // Mark running as false so that the poll immediately ends and runs the close logic
            this._closeError = new (0, $9862e2597169e2d4$export$65bd6083489bd8bb)(response.statusText || "", response.statusCode);
            this._running = false;
        } else this._running = true;
        this._receiving = this._poll(this._url, pollOptions);
    }
    async _poll(url, pollOptions) {
        try {
            while(this._running)try {
                const pollUrl = `${url}&_=${Date.now()}`;
                this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Trace, `(LongPolling transport) polling: ${pollUrl}.`);
                const response = await this._httpClient.get(pollUrl, pollOptions);
                if (response.statusCode === 204) {
                    this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Information, "(LongPolling transport) Poll terminated by server.");
                    this._running = false;
                } else if (response.statusCode !== 200) {
                    this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Error, `(LongPolling transport) Unexpected response code: ${response.statusCode}.`);
                    // Unexpected status code
                    this._closeError = new (0, $9862e2597169e2d4$export$65bd6083489bd8bb)(response.statusText || "", response.statusCode);
                    this._running = false;
                } else // Process the response
                if (response.content) {
                    this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Trace, `(LongPolling transport) data received. ${(0, $32bb29965a07731e$export$a688b91586df8fd9)(response.content, this._options.logMessageContent)}.`);
                    if (this.onreceive) this.onreceive(response.content);
                } else // This is another way timeout manifest.
                this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Trace, "(LongPolling transport) Poll timed out, reissuing.");
            } catch (e) {
                if (!this._running) // Log but disregard errors that occur after stopping
                this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Trace, `(LongPolling transport) Poll errored after shutdown: ${e.message}`);
                else if (e instanceof (0, $9862e2597169e2d4$export$66d311bf29d5c89c)) // Ignore timeouts and reissue the poll.
                this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Trace, "(LongPolling transport) Poll timed out, reissuing.");
                else {
                    // Close the connection with the error as the result.
                    this._closeError = e;
                    this._running = false;
                }
            }
        } finally{
            this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Trace, "(LongPolling transport) Polling complete.");
            // We will reach here with pollAborted==false when the server returned a response causing the transport to stop.
            // If pollAborted==true then client initiated the stop and the stop method will raise the close event after DELETE is sent.
            if (!this.pollAborted) this._raiseOnClose();
        }
    }
    async send(data) {
        if (!this._running) return Promise.reject(new Error("Cannot send until the transport is connected"));
        return (0, $32bb29965a07731e$export$465cb47180de50f0)(this._logger, "LongPolling", this._httpClient, this._url, data, this._options);
    }
    async stop() {
        this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Trace, "(LongPolling transport) Stopping polling.");
        // Tell receiving loop to stop, abort any current request, and then wait for it to finish
        this._running = false;
        this._pollAbort.abort();
        try {
            await this._receiving;
            // Send DELETE to clean up long polling on the server
            this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Trace, `(LongPolling transport) sending DELETE request to ${this._url}.`);
            const headers = {};
            const [name, value] = (0, $32bb29965a07731e$export$56c7340f89ca57c5)();
            headers[name] = value;
            const deleteOptions = {
                headers: {
                    ...headers,
                    ...this._options.headers
                },
                timeout: this._options.timeout,
                withCredentials: this._options.withCredentials
            };
            let error;
            try {
                await this._httpClient.delete(this._url, deleteOptions);
            } catch (err) {
                error = err;
            }
            if (error) {
                if (error instanceof (0, $9862e2597169e2d4$export$65bd6083489bd8bb)) {
                    if (error.statusCode === 404) this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Trace, "(LongPolling transport) A 404 response was returned from sending a DELETE request.");
                    else this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Trace, `(LongPolling transport) Error sending a DELETE request: ${error}`);
                }
            } else this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Trace, "(LongPolling transport) DELETE request accepted.");
        } finally{
            this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Trace, "(LongPolling transport) Stop finished.");
            // Raise close event here instead of in polling
            // It needs to happen after the DELETE request is sent
            this._raiseOnClose();
        }
    }
    _raiseOnClose() {
        if (this.onclose) {
            let logMessage = "(LongPolling transport) Firing onclose event.";
            if (this._closeError) logMessage += " Error: " + this._closeError;
            this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Trace, logMessage);
            this.onclose(this._closeError);
        }
    }
}


// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.



class $812b3bf15307ec8b$export$f0d4dc62ec317948 {
    constructor(httpClient, accessToken, logger, options){
        this._httpClient = httpClient;
        this._accessToken = accessToken;
        this._logger = logger;
        this._options = options;
        this.onreceive = null;
        this.onclose = null;
    }
    async connect(url, transferFormat) {
        (0, $32bb29965a07731e$export$83f0753fc4347e43).isRequired(url, "url");
        (0, $32bb29965a07731e$export$83f0753fc4347e43).isRequired(transferFormat, "transferFormat");
        (0, $32bb29965a07731e$export$83f0753fc4347e43).isIn(transferFormat, (0, $dfd8c9cbca816579$export$f29afaa8e8d2989a), "transferFormat");
        this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Trace, "(SSE transport) Connecting.");
        // set url before accessTokenFactory because this._url is only for send and we set the auth header instead of the query string for send
        this._url = url;
        if (this._accessToken) url += (url.indexOf("?") < 0 ? "?" : "&") + `access_token=${encodeURIComponent(this._accessToken)}`;
        return new Promise((resolve, reject)=>{
            let opened = false;
            if (transferFormat !== (0, $dfd8c9cbca816579$export$f29afaa8e8d2989a).Text) {
                reject(new Error("The Server-Sent Events transport only supports the 'Text' transfer format"));
                return;
            }
            let eventSource;
            if ((0, $32bb29965a07731e$export$2dffd0b5373a4389).isBrowser || (0, $32bb29965a07731e$export$2dffd0b5373a4389).isWebWorker) eventSource = new this._options.EventSource(url, {
                withCredentials: this._options.withCredentials
            });
            else {
                // Non-browser passes cookies via the dictionary
                const cookies = this._httpClient.getCookieString(url);
                const headers = {};
                headers.Cookie = cookies;
                const [name, value] = (0, $32bb29965a07731e$export$56c7340f89ca57c5)();
                headers[name] = value;
                eventSource = new this._options.EventSource(url, {
                    withCredentials: this._options.withCredentials,
                    headers: {
                        ...headers,
                        ...this._options.headers
                    }
                });
            }
            try {
                eventSource.onmessage = (e)=>{
                    if (this.onreceive) try {
                        this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Trace, `(SSE transport) data received. ${(0, $32bb29965a07731e$export$a688b91586df8fd9)(e.data, this._options.logMessageContent)}.`);
                        this.onreceive(e.data);
                    } catch (error) {
                        this._close(error);
                        return;
                    }
                };
                // @ts-ignore: not using event on purpose
                eventSource.onerror = (e)=>{
                    // EventSource doesn't give any useful information about server side closes.
                    if (opened) this._close();
                    else reject(new Error("EventSource failed to connect. The connection could not be found on the server, either the connection ID is not present on the server, or a proxy is refusing/buffering the connection. If you have multiple servers check that sticky sessions are enabled."));
                };
                eventSource.onopen = ()=>{
                    this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Information, `SSE connected to ${this._url}`);
                    this._eventSource = eventSource;
                    opened = true;
                    resolve();
                };
            } catch (e) {
                reject(e);
                return;
            }
        });
    }
    async send(data) {
        if (!this._eventSource) return Promise.reject(new Error("Cannot send until the transport is connected"));
        return (0, $32bb29965a07731e$export$465cb47180de50f0)(this._logger, "SSE", this._httpClient, this._url, data, this._options);
    }
    stop() {
        this._close();
        return Promise.resolve();
    }
    _close(e) {
        if (this._eventSource) {
            this._eventSource.close();
            this._eventSource = undefined;
            if (this.onclose) this.onclose(e);
        }
    }
}



// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.




class $c80131de2ca718fe$export$de21836fc42c6f9c {
    constructor(httpClient, accessTokenFactory, logger, logMessageContent, webSocketConstructor, headers){
        this._logger = logger;
        this._accessTokenFactory = accessTokenFactory;
        this._logMessageContent = logMessageContent;
        this._webSocketConstructor = webSocketConstructor;
        this._httpClient = httpClient;
        this.onreceive = null;
        this.onclose = null;
        this._headers = headers;
    }
    async connect(url, transferFormat) {
        (0, $32bb29965a07731e$export$83f0753fc4347e43).isRequired(url, "url");
        (0, $32bb29965a07731e$export$83f0753fc4347e43).isRequired(transferFormat, "transferFormat");
        (0, $32bb29965a07731e$export$83f0753fc4347e43).isIn(transferFormat, (0, $dfd8c9cbca816579$export$f29afaa8e8d2989a), "transferFormat");
        this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Trace, "(WebSockets transport) Connecting.");
        let token;
        if (this._accessTokenFactory) token = await this._accessTokenFactory();
        return new Promise((resolve, reject)=>{
            url = url.replace(/^http/, "ws");
            let webSocket;
            const cookies = this._httpClient.getCookieString(url);
            let opened = false;
            if ((0, $32bb29965a07731e$export$2dffd0b5373a4389).isNode || (0, $32bb29965a07731e$export$2dffd0b5373a4389).isReactNative) {
                const headers = {};
                const [name, value] = (0, $32bb29965a07731e$export$56c7340f89ca57c5)();
                headers[name] = value;
                if (token) headers[(0, $2b7cf72ed2755a15$export$28d77f87efed1d88).Authorization] = `Bearer ${token}`;
                if (cookies) headers[(0, $2b7cf72ed2755a15$export$28d77f87efed1d88).Cookie] = cookies;
                // Only pass headers when in non-browser environments
                webSocket = new this._webSocketConstructor(url, undefined, {
                    headers: {
                        ...headers,
                        ...this._headers
                    }
                });
            } else if (token) url += (url.indexOf("?") < 0 ? "?" : "&") + `access_token=${encodeURIComponent(token)}`;
            if (!webSocket) // Chrome is not happy with passing 'undefined' as protocol
            webSocket = new this._webSocketConstructor(url);
            if (transferFormat === (0, $dfd8c9cbca816579$export$f29afaa8e8d2989a).Binary) webSocket.binaryType = "arraybuffer";
            webSocket.onopen = (_event)=>{
                this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Information, `WebSocket connected to ${url}.`);
                this._webSocket = webSocket;
                opened = true;
                resolve();
            };
            webSocket.onerror = (event)=>{
                let error = null;
                // ErrorEvent is a browser only type we need to check if the type exists before using it
                if (typeof ErrorEvent !== "undefined" && event instanceof ErrorEvent) error = event.error;
                else error = "There was an error with the transport";
                this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Information, `(WebSockets transport) ${error}.`);
            };
            webSocket.onmessage = (message)=>{
                this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Trace, `(WebSockets transport) data received. ${(0, $32bb29965a07731e$export$a688b91586df8fd9)(message.data, this._logMessageContent)}.`);
                if (this.onreceive) try {
                    this.onreceive(message.data);
                } catch (error) {
                    this._close(error);
                    return;
                }
            };
            webSocket.onclose = (event)=>{
                // Don't call close handler if connection was never established
                // We'll reject the connect call instead
                if (opened) this._close(event);
                else {
                    let error = null;
                    // ErrorEvent is a browser only type we need to check if the type exists before using it
                    if (typeof ErrorEvent !== "undefined" && event instanceof ErrorEvent) error = event.error;
                    else error = "WebSocket failed to connect. The connection could not be found on the server, either the endpoint may not be a SignalR endpoint, the connection ID is not present on the server, or there is a proxy blocking WebSockets. If you have multiple servers check that sticky sessions are enabled.";
                    reject(new Error(error));
                }
            };
        });
    }
    send(data) {
        if (this._webSocket && this._webSocket.readyState === this._webSocketConstructor.OPEN) {
            this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Trace, `(WebSockets transport) sending data. ${(0, $32bb29965a07731e$export$a688b91586df8fd9)(data, this._logMessageContent)}.`);
            this._webSocket.send(data);
            return Promise.resolve();
        }
        return Promise.reject("WebSocket is not in the OPEN state");
    }
    stop() {
        if (this._webSocket) // Manually invoke onclose callback inline so we know the HttpConnection was closed properly before returning
        // This also solves an issue where websocket.onclose could take 18+ seconds to trigger during network disconnects
        this._close(undefined);
        return Promise.resolve();
    }
    _close(event) {
        // webSocket will be null if the transport did not start successfully
        if (this._webSocket) {
            // Clear websocket handlers because we are considering the socket closed now
            this._webSocket.onclose = ()=>{};
            this._webSocket.onmessage = ()=>{};
            this._webSocket.onerror = ()=>{};
            this._webSocket.close();
            this._webSocket = undefined;
        }
        this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Trace, "(WebSockets transport) socket closed.");
        if (this.onclose) {
            if (this._isCloseEvent(event) && (event.wasClean === false || event.code !== 1000)) this.onclose(new Error(`WebSocket closed with status code: ${event.code} (${event.reason || "no reason given"}).`));
            else if (event instanceof Error) this.onclose(event);
            else this.onclose();
        }
    }
    _isCloseEvent(event) {
        return event && typeof event.wasClean === "boolean" && typeof event.code === "number";
    }
}


const $73b6b78c950d1272$var$MAX_REDIRECTS = 100;
class $73b6b78c950d1272$export$13c1f9cf8a283575 {
    constructor(url, options = {}){
        this._stopPromiseResolver = ()=>{};
        this.features = {};
        this._negotiateVersion = 1;
        (0, $32bb29965a07731e$export$83f0753fc4347e43).isRequired(url, "url");
        this._logger = (0, $32bb29965a07731e$export$fe2e61603b61130d)(options.logger);
        this.baseUrl = this._resolveUrl(url);
        options = options || {};
        options.logMessageContent = options.logMessageContent === undefined ? false : options.logMessageContent;
        if (typeof options.withCredentials === "boolean" || options.withCredentials === undefined) options.withCredentials = options.withCredentials === undefined ? true : options.withCredentials;
        else throw new Error("withCredentials option was not a 'boolean' or 'undefined' value");
        options.timeout = options.timeout === undefined ? 100000 : options.timeout;
        let webSocketModule = null;
        let eventSourceModule = null;
        if ((0, $32bb29965a07731e$export$2dffd0b5373a4389).isNode && true) {
            // In order to ignore the dynamic require in webpack builds we need to do this magic
            // @ts-ignore: TS doesn't know about these names
            const requireFunc = typeof __webpack_require__ === "function" ? __non_webpack_require__ : undefined;
            webSocketModule = requireFunc("ws");
            eventSourceModule = requireFunc("eventsource");
        }
        if (!(0, $32bb29965a07731e$export$2dffd0b5373a4389).isNode && typeof WebSocket !== "undefined" && !options.WebSocket) options.WebSocket = WebSocket;
        else if ((0, $32bb29965a07731e$export$2dffd0b5373a4389).isNode && !options.WebSocket) {
            if (webSocketModule) options.WebSocket = webSocketModule;
        }
        if (!(0, $32bb29965a07731e$export$2dffd0b5373a4389).isNode && typeof EventSource !== "undefined" && !options.EventSource) options.EventSource = EventSource;
        else if ((0, $32bb29965a07731e$export$2dffd0b5373a4389).isNode && !options.EventSource) {
            if (typeof eventSourceModule !== "undefined") options.EventSource = eventSourceModule;
        }
        this._httpClient = new (0, $3017bfe8a565980c$export$981ab95414418dd3)(options.httpClient || new (0, $c9ca2928589aa40c$export$4f11ab3560c519e5)(this._logger), options.accessTokenFactory);
        this._connectionState = "Disconnected" /* ConnectionState.Disconnected */ ;
        this._connectionStarted = false;
        this._options = options;
        this.onreceive = null;
        this.onclose = null;
    }
    async start(transferFormat) {
        transferFormat = transferFormat || (0, $dfd8c9cbca816579$export$f29afaa8e8d2989a).Binary;
        (0, $32bb29965a07731e$export$83f0753fc4347e43).isIn(transferFormat, (0, $dfd8c9cbca816579$export$f29afaa8e8d2989a), "transferFormat");
        this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Debug, `Starting connection with transfer format '${(0, $dfd8c9cbca816579$export$f29afaa8e8d2989a)[transferFormat]}'.`);
        if (this._connectionState !== "Disconnected" /* ConnectionState.Disconnected */ ) return Promise.reject(new Error("Cannot start an HttpConnection that is not in the 'Disconnected' state."));
        this._connectionState = "Connecting" /* ConnectionState.Connecting */ ;
        this._startInternalPromise = this._startInternal(transferFormat);
        await this._startInternalPromise;
        // The TypeScript compiler thinks that connectionState must be Connecting here. The TypeScript compiler is wrong.
        if (this._connectionState === "Disconnecting" /* ConnectionState.Disconnecting */ ) {
            // stop() was called and transitioned the client into the Disconnecting state.
            const message = "Failed to start the HttpConnection before stop() was called.";
            this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Error, message);
            // We cannot await stopPromise inside startInternal since stopInternal awaits the startInternalPromise.
            await this._stopPromise;
            return Promise.reject(new (0, $9862e2597169e2d4$export$18b052ffd8c84d7)(message));
        } else if (this._connectionState !== "Connected" /* ConnectionState.Connected */ ) {
            // stop() was called and transitioned the client into the Disconnecting state.
            const message = "HttpConnection.startInternal completed gracefully but didn't enter the connection into the connected state!";
            this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Error, message);
            return Promise.reject(new (0, $9862e2597169e2d4$export$18b052ffd8c84d7)(message));
        }
        this._connectionStarted = true;
    }
    send(data) {
        if (this._connectionState !== "Connected" /* ConnectionState.Connected */ ) return Promise.reject(new Error("Cannot send data if the connection is not in the 'Connected' State."));
        if (!this._sendQueue) this._sendQueue = new $73b6b78c950d1272$export$ff09921d3884e946(this.transport);
        // Transport will not be null if state is connected
        return this._sendQueue.send(data);
    }
    async stop(error) {
        if (this._connectionState === "Disconnected" /* ConnectionState.Disconnected */ ) {
            this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Debug, `Call to HttpConnection.stop(${error}) ignored because the connection is already in the disconnected state.`);
            return Promise.resolve();
        }
        if (this._connectionState === "Disconnecting" /* ConnectionState.Disconnecting */ ) {
            this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Debug, `Call to HttpConnection.stop(${error}) ignored because the connection is already in the disconnecting state.`);
            return this._stopPromise;
        }
        this._connectionState = "Disconnecting" /* ConnectionState.Disconnecting */ ;
        this._stopPromise = new Promise((resolve)=>{
            // Don't complete stop() until stopConnection() completes.
            this._stopPromiseResolver = resolve;
        });
        // stopInternal should never throw so just observe it.
        await this._stopInternal(error);
        await this._stopPromise;
    }
    async _stopInternal(error) {
        // Set error as soon as possible otherwise there is a race between
        // the transport closing and providing an error and the error from a close message
        // We would prefer the close message error.
        this._stopError = error;
        try {
            await this._startInternalPromise;
        } catch (e) {
        // This exception is returned to the user as a rejected Promise from the start method.
        }
        // The transport's onclose will trigger stopConnection which will run our onclose event.
        // The transport should always be set if currently connected. If it wasn't set, it's likely because
        // stop was called during start() and start() failed.
        if (this.transport) {
            try {
                await this.transport.stop();
            } catch (e) {
                this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Error, `HttpConnection.transport.stop() threw error '${e}'.`);
                this._stopConnection();
            }
            this.transport = undefined;
        } else this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Debug, "HttpConnection.transport is undefined in HttpConnection.stop() because start() failed.");
    }
    async _startInternal(transferFormat) {
        // Store the original base url and the access token factory since they may change
        // as part of negotiating
        let url = this.baseUrl;
        this._accessTokenFactory = this._options.accessTokenFactory;
        this._httpClient._accessTokenFactory = this._accessTokenFactory;
        try {
            if (this._options.skipNegotiation) {
                if (this._options.transport === (0, $dfd8c9cbca816579$export$789ba40ee1a75f0).WebSockets) {
                    // No need to add a connection ID in this case
                    this.transport = this._constructTransport((0, $dfd8c9cbca816579$export$789ba40ee1a75f0).WebSockets);
                    // We should just call connect directly in this case.
                    // No fallback or negotiate in this case.
                    await this._startTransport(url, transferFormat);
                } else throw new Error("Negotiation can only be skipped when using the WebSocket transport directly.");
            } else {
                let negotiateResponse = null;
                let redirects = 0;
                do {
                    negotiateResponse = await this._getNegotiationResponse(url);
                    // the user tries to stop the connection when it is being started
                    if (this._connectionState === "Disconnecting" /* ConnectionState.Disconnecting */  || this._connectionState === "Disconnected" /* ConnectionState.Disconnected */ ) throw new (0, $9862e2597169e2d4$export$18b052ffd8c84d7)("The connection was stopped during negotiation.");
                    if (negotiateResponse.error) throw new Error(negotiateResponse.error);
                    if (negotiateResponse.ProtocolVersion) throw new Error("Detected a connection attempt to an ASP.NET SignalR Server. This client only supports connecting to an ASP.NET Core SignalR Server. See https://aka.ms/signalr-core-differences for details.");
                    if (negotiateResponse.url) url = negotiateResponse.url;
                    if (negotiateResponse.accessToken) {
                        // Replace the current access token factory with one that uses
                        // the returned access token
                        const accessToken = negotiateResponse.accessToken;
                        this._accessTokenFactory = ()=>accessToken;
                        // set the factory to undefined so the AccessTokenHttpClient won't retry with the same token, since we know it won't change until a connection restart
                        this._httpClient._accessToken = accessToken;
                        this._httpClient._accessTokenFactory = undefined;
                    }
                    redirects++;
                }while (negotiateResponse.url && redirects < $73b6b78c950d1272$var$MAX_REDIRECTS);
                if (redirects === $73b6b78c950d1272$var$MAX_REDIRECTS && negotiateResponse.url) throw new Error("Negotiate redirection limit exceeded.");
                await this._createTransport(url, this._options.transport, negotiateResponse, transferFormat);
            }
            if (this.transport instanceof (0, $68d775930ce5466a$export$fbd8c90d2cca1300)) this.features.inherentKeepAlive = true;
            if (this._connectionState === "Connecting" /* ConnectionState.Connecting */ ) {
                // Ensure the connection transitions to the connected state prior to completing this.startInternalPromise.
                // start() will handle the case when stop was called and startInternal exits still in the disconnecting state.
                this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Debug, "The HttpConnection connected successfully.");
                this._connectionState = "Connected" /* ConnectionState.Connected */ ;
            }
        // stop() is waiting on us via this.startInternalPromise so keep this.transport around so it can clean up.
        // This is the only case startInternal can exit in neither the connected nor disconnected state because stopConnection()
        // will transition to the disconnected state. start() will wait for the transition using the stopPromise.
        } catch (e) {
            this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Error, "Failed to start the connection: " + e);
            this._connectionState = "Disconnected" /* ConnectionState.Disconnected */ ;
            this.transport = undefined;
            // if start fails, any active calls to stop assume that start will complete the stop promise
            this._stopPromiseResolver();
            return Promise.reject(e);
        }
    }
    async _getNegotiationResponse(url) {
        const headers = {};
        const [name, value] = (0, $32bb29965a07731e$export$56c7340f89ca57c5)();
        headers[name] = value;
        const negotiateUrl = this._resolveNegotiateUrl(url);
        this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Debug, `Sending negotiation request: ${negotiateUrl}.`);
        try {
            const response = await this._httpClient.post(negotiateUrl, {
                content: "",
                headers: {
                    ...headers,
                    ...this._options.headers
                },
                timeout: this._options.timeout,
                withCredentials: this._options.withCredentials
            });
            if (response.statusCode !== 200) return Promise.reject(new Error(`Unexpected status code returned from negotiate '${response.statusCode}'`));
            const negotiateResponse = JSON.parse(response.content);
            if (!negotiateResponse.negotiateVersion || negotiateResponse.negotiateVersion < 1) // Negotiate version 0 doesn't use connectionToken
            // So we set it equal to connectionId so all our logic can use connectionToken without being aware of the negotiate version
            negotiateResponse.connectionToken = negotiateResponse.connectionId;
            if (negotiateResponse.useStatefulReconnect && this._options._useStatefulReconnect !== true) return Promise.reject(new (0, $9862e2597169e2d4$export$b4f59905103de78d)("Client didn't negotiate Stateful Reconnect but the server did."));
            return negotiateResponse;
        } catch (e) {
            let errorMessage = "Failed to complete negotiation with the server: " + e;
            if (e instanceof (0, $9862e2597169e2d4$export$65bd6083489bd8bb)) {
                if (e.statusCode === 404) errorMessage = errorMessage + " Either this is not a SignalR endpoint or there is a proxy blocking the connection.";
            }
            this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Error, errorMessage);
            return Promise.reject(new (0, $9862e2597169e2d4$export$b4f59905103de78d)(errorMessage));
        }
    }
    _createConnectUrl(url, connectionToken) {
        if (!connectionToken) return url;
        return url + (url.indexOf("?") === -1 ? "?" : "&") + `id=${connectionToken}`;
    }
    async _createTransport(url, requestedTransport, negotiateResponse, requestedTransferFormat) {
        let connectUrl = this._createConnectUrl(url, negotiateResponse.connectionToken);
        if (this._isITransport(requestedTransport)) {
            this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Debug, "Connection was provided an instance of ITransport, using that directly.");
            this.transport = requestedTransport;
            await this._startTransport(connectUrl, requestedTransferFormat);
            this.connectionId = negotiateResponse.connectionId;
            return;
        }
        const transportExceptions = [];
        const transports = negotiateResponse.availableTransports || [];
        let negotiate = negotiateResponse;
        for (const endpoint of transports){
            const transportOrError = this._resolveTransportOrError(endpoint, requestedTransport, requestedTransferFormat, (negotiate === null || negotiate === void 0 ? void 0 : negotiate.useStatefulReconnect) === true);
            if (transportOrError instanceof Error) {
                // Store the error and continue, we don't want to cause a re-negotiate in these cases
                transportExceptions.push(`${endpoint.transport} failed:`);
                transportExceptions.push(transportOrError);
            } else if (this._isITransport(transportOrError)) {
                this.transport = transportOrError;
                if (!negotiate) {
                    try {
                        negotiate = await this._getNegotiationResponse(url);
                    } catch (ex) {
                        return Promise.reject(ex);
                    }
                    connectUrl = this._createConnectUrl(url, negotiate.connectionToken);
                }
                try {
                    await this._startTransport(connectUrl, requestedTransferFormat);
                    this.connectionId = negotiate.connectionId;
                    return;
                } catch (ex) {
                    this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Error, `Failed to start the transport '${endpoint.transport}': ${ex}`);
                    negotiate = undefined;
                    transportExceptions.push(new (0, $9862e2597169e2d4$export$264839a6ea29f91a)(`${endpoint.transport} failed: ${ex}`, (0, $dfd8c9cbca816579$export$789ba40ee1a75f0)[endpoint.transport]));
                    if (this._connectionState !== "Connecting" /* ConnectionState.Connecting */ ) {
                        const message = "Failed to select transport before stop() was called.";
                        this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Debug, message);
                        return Promise.reject(new (0, $9862e2597169e2d4$export$18b052ffd8c84d7)(message));
                    }
                }
            }
        }
        if (transportExceptions.length > 0) return Promise.reject(new (0, $9862e2597169e2d4$export$9341e26d19ed3783)(`Unable to connect to the server with any of the available transports. ${transportExceptions.join(" ")}`, transportExceptions));
        return Promise.reject(new Error("None of the transports supported by the client are supported by the server."));
    }
    _constructTransport(transport) {
        switch(transport){
            case (0, $dfd8c9cbca816579$export$789ba40ee1a75f0).WebSockets:
                if (!this._options.WebSocket) throw new Error("'WebSocket' is not supported in your environment.");
                return new (0, $c80131de2ca718fe$export$de21836fc42c6f9c)(this._httpClient, this._accessTokenFactory, this._logger, this._options.logMessageContent, this._options.WebSocket, this._options.headers || {});
            case (0, $dfd8c9cbca816579$export$789ba40ee1a75f0).ServerSentEvents:
                if (!this._options.EventSource) throw new Error("'EventSource' is not supported in your environment.");
                return new (0, $812b3bf15307ec8b$export$f0d4dc62ec317948)(this._httpClient, this._httpClient._accessToken, this._logger, this._options);
            case (0, $dfd8c9cbca816579$export$789ba40ee1a75f0).LongPolling:
                return new (0, $68d775930ce5466a$export$fbd8c90d2cca1300)(this._httpClient, this._logger, this._options);
            default:
                throw new Error(`Unknown transport: ${transport}.`);
        }
    }
    _startTransport(url, transferFormat) {
        this.transport.onreceive = this.onreceive;
        if (this.features.reconnect) this.transport.onclose = async (e)=>{
            let callStop = false;
            if (this.features.reconnect) try {
                this.features.disconnected();
                await this.transport.connect(url, transferFormat);
                await this.features.resend();
            } catch  {
                callStop = true;
            }
            else {
                this._stopConnection(e);
                return;
            }
            if (callStop) this._stopConnection(e);
        };
        else this.transport.onclose = (e)=>this._stopConnection(e);
        return this.transport.connect(url, transferFormat);
    }
    _resolveTransportOrError(endpoint, requestedTransport, requestedTransferFormat, useStatefulReconnect) {
        const transport = (0, $dfd8c9cbca816579$export$789ba40ee1a75f0)[endpoint.transport];
        if (transport === null || transport === undefined) {
            this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Debug, `Skipping transport '${endpoint.transport}' because it is not supported by this client.`);
            return new Error(`Skipping transport '${endpoint.transport}' because it is not supported by this client.`);
        } else if ($73b6b78c950d1272$var$transportMatches(requestedTransport, transport)) {
            const transferFormats = endpoint.transferFormats.map((s)=>(0, $dfd8c9cbca816579$export$f29afaa8e8d2989a)[s]);
            if (transferFormats.indexOf(requestedTransferFormat) >= 0) {
                if (transport === (0, $dfd8c9cbca816579$export$789ba40ee1a75f0).WebSockets && !this._options.WebSocket || transport === (0, $dfd8c9cbca816579$export$789ba40ee1a75f0).ServerSentEvents && !this._options.EventSource) {
                    this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Debug, `Skipping transport '${(0, $dfd8c9cbca816579$export$789ba40ee1a75f0)[transport]}' because it is not supported in your environment.'`);
                    return new (0, $9862e2597169e2d4$export$c7cbd7482d8bece8)(`'${(0, $dfd8c9cbca816579$export$789ba40ee1a75f0)[transport]}' is not supported in your environment.`, transport);
                } else {
                    this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Debug, `Selecting transport '${(0, $dfd8c9cbca816579$export$789ba40ee1a75f0)[transport]}'.`);
                    try {
                        this.features.reconnect = transport === (0, $dfd8c9cbca816579$export$789ba40ee1a75f0).WebSockets ? useStatefulReconnect : undefined;
                        return this._constructTransport(transport);
                    } catch (ex) {
                        return ex;
                    }
                }
            } else {
                this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Debug, `Skipping transport '${(0, $dfd8c9cbca816579$export$789ba40ee1a75f0)[transport]}' because it does not support the requested transfer format '${(0, $dfd8c9cbca816579$export$f29afaa8e8d2989a)[requestedTransferFormat]}'.`);
                return new Error(`'${(0, $dfd8c9cbca816579$export$789ba40ee1a75f0)[transport]}' does not support ${(0, $dfd8c9cbca816579$export$f29afaa8e8d2989a)[requestedTransferFormat]}.`);
            }
        } else {
            this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Debug, `Skipping transport '${(0, $dfd8c9cbca816579$export$789ba40ee1a75f0)[transport]}' because it was disabled by the client.`);
            return new (0, $9862e2597169e2d4$export$764b8cd64449c5b0)(`'${(0, $dfd8c9cbca816579$export$789ba40ee1a75f0)[transport]}' is disabled by the client.`, transport);
        }
    }
    _isITransport(transport) {
        return transport && typeof transport === "object" && "connect" in transport;
    }
    _stopConnection(error) {
        this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Debug, `HttpConnection.stopConnection(${error}) called while in state ${this._connectionState}.`);
        this.transport = undefined;
        // If we have a stopError, it takes precedence over the error from the transport
        error = this._stopError || error;
        this._stopError = undefined;
        if (this._connectionState === "Disconnected" /* ConnectionState.Disconnected */ ) {
            this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Debug, `Call to HttpConnection.stopConnection(${error}) was ignored because the connection is already in the disconnected state.`);
            return;
        }
        if (this._connectionState === "Connecting" /* ConnectionState.Connecting */ ) {
            this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Warning, `Call to HttpConnection.stopConnection(${error}) was ignored because the connection is still in the connecting state.`);
            throw new Error(`HttpConnection.stopConnection(${error}) was called while the connection is still in the connecting state.`);
        }
        if (this._connectionState === "Disconnecting" /* ConnectionState.Disconnecting */ ) // A call to stop() induced this call to stopConnection and needs to be completed.
        // Any stop() awaiters will be scheduled to continue after the onclose callback fires.
        this._stopPromiseResolver();
        if (error) this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Error, `Connection disconnected with error '${error}'.`);
        else this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Information, "Connection disconnected.");
        if (this._sendQueue) {
            this._sendQueue.stop().catch((e)=>{
                this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Error, `TransportSendQueue.stop() threw error '${e}'.`);
            });
            this._sendQueue = undefined;
        }
        this.connectionId = undefined;
        this._connectionState = "Disconnected" /* ConnectionState.Disconnected */ ;
        if (this._connectionStarted) {
            this._connectionStarted = false;
            try {
                if (this.onclose) this.onclose(error);
            } catch (e) {
                this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Error, `HttpConnection.onclose(${error}) threw error '${e}'.`);
            }
        }
    }
    _resolveUrl(url) {
        // startsWith is not supported in IE
        if (url.lastIndexOf("https://", 0) === 0 || url.lastIndexOf("http://", 0) === 0) return url;
        if (!(0, $32bb29965a07731e$export$2dffd0b5373a4389).isBrowser) throw new Error(`Cannot resolve '${url}'.`);
        // Setting the url to the href propery of an anchor tag handles normalization
        // for us. There are 3 main cases.
        // 1. Relative path normalization e.g "b" -> "http://localhost:5000/a/b"
        // 2. Absolute path normalization e.g "/a/b" -> "http://localhost:5000/a/b"
        // 3. Networkpath reference normalization e.g "//localhost:5000/a/b" -> "http://localhost:5000/a/b"
        const aTag = window.document.createElement("a");
        aTag.href = url;
        this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Information, `Normalizing '${url}' to '${aTag.href}'.`);
        return aTag.href;
    }
    _resolveNegotiateUrl(url) {
        const negotiateUrl = new URL(url);
        if (negotiateUrl.pathname.endsWith('/')) negotiateUrl.pathname += "negotiate";
        else negotiateUrl.pathname += "/negotiate";
        const searchParams = new URLSearchParams(negotiateUrl.searchParams);
        if (!searchParams.has("negotiateVersion")) searchParams.append("negotiateVersion", this._negotiateVersion.toString());
        if (searchParams.has("useStatefulReconnect")) {
            if (searchParams.get("useStatefulReconnect") === "true") this._options._useStatefulReconnect = true;
        } else if (this._options._useStatefulReconnect === true) searchParams.append("useStatefulReconnect", "true");
        negotiateUrl.search = searchParams.toString();
        return negotiateUrl.toString();
    }
}
function $73b6b78c950d1272$var$transportMatches(requestedTransport, actualTransport) {
    return !requestedTransport || (actualTransport & requestedTransport) !== 0;
}
class $73b6b78c950d1272$export$ff09921d3884e946 {
    constructor(_transport){
        this._transport = _transport;
        this._buffer = [];
        this._executing = true;
        this._sendBufferedData = new $73b6b78c950d1272$var$PromiseSource();
        this._transportResult = new $73b6b78c950d1272$var$PromiseSource();
        this._sendLoopPromise = this._sendLoop();
    }
    send(data) {
        this._bufferData(data);
        if (!this._transportResult) this._transportResult = new $73b6b78c950d1272$var$PromiseSource();
        return this._transportResult.promise;
    }
    stop() {
        this._executing = false;
        this._sendBufferedData.resolve();
        return this._sendLoopPromise;
    }
    _bufferData(data) {
        if (this._buffer.length && typeof this._buffer[0] !== typeof data) throw new Error(`Expected data to be of type ${typeof this._buffer} but was of type ${typeof data}`);
        this._buffer.push(data);
        this._sendBufferedData.resolve();
    }
    async _sendLoop() {
        while(true){
            await this._sendBufferedData.promise;
            if (!this._executing) {
                if (this._transportResult) this._transportResult.reject("Connection stopped.");
                break;
            }
            this._sendBufferedData = new $73b6b78c950d1272$var$PromiseSource();
            const transportResult = this._transportResult;
            this._transportResult = undefined;
            const data = typeof this._buffer[0] === "string" ? this._buffer.join("") : $73b6b78c950d1272$export$ff09921d3884e946._concatBuffers(this._buffer);
            this._buffer.length = 0;
            try {
                await this._transport.send(data);
                transportResult.resolve();
            } catch (error) {
                transportResult.reject(error);
            }
        }
    }
    static _concatBuffers(arrayBuffers) {
        const totalLength = arrayBuffers.map((b)=>b.byteLength).reduce((a, b)=>a + b);
        const result = new Uint8Array(totalLength);
        let offset = 0;
        for (const item of arrayBuffers){
            result.set(new Uint8Array(item), offset);
            offset += item.byteLength;
        }
        return result.buffer;
    }
}
class $73b6b78c950d1272$var$PromiseSource {
    constructor(){
        this.promise = new Promise((resolve, reject)=>([this._resolver, this._rejecter] = [
                resolve,
                reject
            ]));
    }
    resolve() {
        this._resolver();
    }
    reject(reason) {
        this._rejecter(reason);
    }
}


// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
// Not exported from index
/** @private */ class $5e59b4f8b1f9494d$export$fc2e5d47850f626b {
    static write(output) {
        return `${output}${$5e59b4f8b1f9494d$export$fc2e5d47850f626b.RecordSeparator}`;
    }
    static parse(input) {
        if (input[input.length - 1] !== $5e59b4f8b1f9494d$export$fc2e5d47850f626b.RecordSeparator) throw new Error("Message is incomplete.");
        const messages = input.split($5e59b4f8b1f9494d$export$fc2e5d47850f626b.RecordSeparator);
        messages.pop();
        return messages;
    }
}
$5e59b4f8b1f9494d$export$fc2e5d47850f626b.RecordSeparatorCode = 0x1e;
$5e59b4f8b1f9494d$export$fc2e5d47850f626b.RecordSeparator = String.fromCharCode($5e59b4f8b1f9494d$export$fc2e5d47850f626b.RecordSeparatorCode);



class $60dd2bca4d6878db$export$b23df48528d3f5f4 {
    // Handshake request is always JSON
    writeHandshakeRequest(handshakeRequest) {
        return (0, $5e59b4f8b1f9494d$export$fc2e5d47850f626b).write(JSON.stringify(handshakeRequest));
    }
    parseHandshakeResponse(data) {
        let messageData;
        let remainingData;
        if ((0, $32bb29965a07731e$export$9dd3754ae86f0017)(data)) {
            // Format is binary but still need to read JSON text from handshake response
            const binaryData = new Uint8Array(data);
            const separatorIndex = binaryData.indexOf((0, $5e59b4f8b1f9494d$export$fc2e5d47850f626b).RecordSeparatorCode);
            if (separatorIndex === -1) throw new Error("Message is incomplete.");
            // content before separator is handshake response
            // optional content after is additional messages
            const responseLength = separatorIndex + 1;
            messageData = String.fromCharCode.apply(null, Array.prototype.slice.call(binaryData.slice(0, responseLength)));
            remainingData = binaryData.byteLength > responseLength ? binaryData.slice(responseLength).buffer : null;
        } else {
            const textData = data;
            const separatorIndex = textData.indexOf((0, $5e59b4f8b1f9494d$export$fc2e5d47850f626b).RecordSeparator);
            if (separatorIndex === -1) throw new Error("Message is incomplete.");
            // content before separator is handshake response
            // optional content after is additional messages
            const responseLength = separatorIndex + 1;
            messageData = textData.substring(0, responseLength);
            remainingData = textData.length > responseLength ? textData.substring(responseLength) : null;
        }
        // At this point we should have just the single handshake message
        const messages = (0, $5e59b4f8b1f9494d$export$fc2e5d47850f626b).parse(messageData);
        const response = JSON.parse(messages[0]);
        if (response.type) throw new Error("Expected a handshake response from the server.");
        const responseMessage = response;
        // multiple messages could have arrived with handshake
        // return additional data to be parsed as usual, or null if all parsed
        return [
            remainingData,
            responseMessage
        ];
    }
}



// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
/** Defines the type of a Hub Message. */ var $2e5e85a8c3cc12fd$export$80edbf15fa61a4db;
(function(MessageType) {
    /** Indicates the message is an Invocation message and implements the {@link @microsoft/signalr.InvocationMessage} interface. */ MessageType[MessageType["Invocation"] = 1] = "Invocation";
    /** Indicates the message is a StreamItem message and implements the {@link @microsoft/signalr.StreamItemMessage} interface. */ MessageType[MessageType["StreamItem"] = 2] = "StreamItem";
    /** Indicates the message is a Completion message and implements the {@link @microsoft/signalr.CompletionMessage} interface. */ MessageType[MessageType["Completion"] = 3] = "Completion";
    /** Indicates the message is a Stream Invocation message and implements the {@link @microsoft/signalr.StreamInvocationMessage} interface. */ MessageType[MessageType["StreamInvocation"] = 4] = "StreamInvocation";
    /** Indicates the message is a Cancel Invocation message and implements the {@link @microsoft/signalr.CancelInvocationMessage} interface. */ MessageType[MessageType["CancelInvocation"] = 5] = "CancelInvocation";
    /** Indicates the message is a Ping message and implements the {@link @microsoft/signalr.PingMessage} interface. */ MessageType[MessageType["Ping"] = 6] = "Ping";
    /** Indicates the message is a Close message and implements the {@link @microsoft/signalr.CloseMessage} interface. */ MessageType[MessageType["Close"] = 7] = "Close";
    MessageType[MessageType["Ack"] = 8] = "Ack";
    MessageType[MessageType["Sequence"] = 9] = "Sequence";
})($2e5e85a8c3cc12fd$export$80edbf15fa61a4db || ($2e5e85a8c3cc12fd$export$80edbf15fa61a4db = {}));



// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.

class $82e59eaf686a40c1$export$b6bbab5a9b109038 {
    constructor(){
        this.observers = [];
    }
    next(item) {
        for (const observer of this.observers)observer.next(item);
    }
    error(err) {
        for (const observer of this.observers)if (observer.error) observer.error(err);
    }
    complete() {
        for (const observer of this.observers)if (observer.complete) observer.complete();
    }
    subscribe(observer) {
        this.observers.push(observer);
        return new (0, $32bb29965a07731e$export$b7a41f2bfb5c60c3)(this, observer);
    }
}



// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.


class $b8f262c250af9dbb$export$9d24a0f7b61acd07 {
    constructor(protocol, connection, bufferSize){
        this._bufferSize = 100000;
        this._messages = [];
        this._totalMessageCount = 0;
        this._waitForSequenceMessage = false;
        // Message IDs start at 1 and always increment by 1
        this._nextReceivingSequenceId = 1;
        this._latestReceivedSequenceId = 0;
        this._bufferedByteCount = 0;
        this._reconnectInProgress = false;
        this._protocol = protocol;
        this._connection = connection;
        this._bufferSize = bufferSize;
    }
    async _send(message) {
        const serializedMessage = this._protocol.writeMessage(message);
        let backpressurePromise = Promise.resolve();
        // Only count invocation messages. Acks, pings, etc. don't need to be resent on reconnect
        if (this._isInvocationMessage(message)) {
            this._totalMessageCount++;
            let backpressurePromiseResolver = ()=>{};
            let backpressurePromiseRejector = ()=>{};
            if ((0, $32bb29965a07731e$export$9dd3754ae86f0017)(serializedMessage)) this._bufferedByteCount += serializedMessage.byteLength;
            else this._bufferedByteCount += serializedMessage.length;
            if (this._bufferedByteCount >= this._bufferSize) backpressurePromise = new Promise((resolve, reject)=>{
                backpressurePromiseResolver = resolve;
                backpressurePromiseRejector = reject;
            });
            this._messages.push(new $b8f262c250af9dbb$var$BufferedItem(serializedMessage, this._totalMessageCount, backpressurePromiseResolver, backpressurePromiseRejector));
        }
        try {
            // If this is set it means we are reconnecting or resending
            // We don't want to send on a disconnected connection
            // And we don't want to send if resend is running since that would mean sending
            // this message twice
            if (!this._reconnectInProgress) await this._connection.send(serializedMessage);
        } catch  {
            this._disconnected();
        }
        await backpressurePromise;
    }
    _ack(ackMessage) {
        let newestAckedMessage = -1;
        // Find index of newest message being acked
        for(let index = 0; index < this._messages.length; index++){
            const element = this._messages[index];
            if (element._id <= ackMessage.sequenceId) {
                newestAckedMessage = index;
                if ((0, $32bb29965a07731e$export$9dd3754ae86f0017)(element._message)) this._bufferedByteCount -= element._message.byteLength;
                else this._bufferedByteCount -= element._message.length;
                // resolve items that have already been sent and acked
                element._resolver();
            } else if (this._bufferedByteCount < this._bufferSize) // resolve items that now fall under the buffer limit but haven't been acked
            element._resolver();
            else break;
        }
        if (newestAckedMessage !== -1) // We're removing everything including the message pointed to, so add 1
        this._messages = this._messages.slice(newestAckedMessage + 1);
    }
    _shouldProcessMessage(message) {
        if (this._waitForSequenceMessage) {
            if (message.type !== (0, $2e5e85a8c3cc12fd$export$80edbf15fa61a4db).Sequence) return false;
            else {
                this._waitForSequenceMessage = false;
                return true;
            }
        }
        // No special processing for acks, pings, etc.
        if (!this._isInvocationMessage(message)) return true;
        const currentId = this._nextReceivingSequenceId;
        this._nextReceivingSequenceId++;
        if (currentId <= this._latestReceivedSequenceId) {
            if (currentId === this._latestReceivedSequenceId) // Should only hit this if we just reconnected and the server is sending
            // Messages it has buffered, which would mean it hasn't seen an Ack for these messages
            this._ackTimer();
            // Ignore, this is a duplicate message
            return false;
        }
        this._latestReceivedSequenceId = currentId;
        // Only start the timer for sending an Ack message when we have a message to ack. This also conveniently solves
        // timer throttling by not having a recursive timer, and by starting the timer via a network call (recv)
        this._ackTimer();
        return true;
    }
    _resetSequence(message) {
        if (message.sequenceId > this._nextReceivingSequenceId) {
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this._connection.stop(new Error("Sequence ID greater than amount of messages we've received."));
            return;
        }
        this._nextReceivingSequenceId = message.sequenceId;
    }
    _disconnected() {
        this._reconnectInProgress = true;
        this._waitForSequenceMessage = true;
    }
    async _resend() {
        const sequenceId = this._messages.length !== 0 ? this._messages[0]._id : this._totalMessageCount + 1;
        await this._connection.send(this._protocol.writeMessage({
            type: (0, $2e5e85a8c3cc12fd$export$80edbf15fa61a4db).Sequence,
            sequenceId: sequenceId
        }));
        // Get a local variable to the _messages, just in case messages are acked while resending
        // Which would slice the _messages array (which creates a new copy)
        const messages = this._messages;
        for (const element of messages)await this._connection.send(element._message);
        this._reconnectInProgress = false;
    }
    _dispose(error) {
        error !== null && error !== void 0 ? error : error = new Error("Unable to reconnect to server.");
        // Unblock backpressure if any
        for (const element of this._messages)element._rejector(error);
    }
    _isInvocationMessage(message) {
        // There is no way to check if something implements an interface.
        // So we individually check the messages in a switch statement.
        // To make sure we don't miss any message types we rely on the compiler
        // seeing the function returns a value and it will do the
        // exhaustive check for us on the switch statement, since we don't use 'case default'
        switch(message.type){
            case (0, $2e5e85a8c3cc12fd$export$80edbf15fa61a4db).Invocation:
            case (0, $2e5e85a8c3cc12fd$export$80edbf15fa61a4db).StreamItem:
            case (0, $2e5e85a8c3cc12fd$export$80edbf15fa61a4db).Completion:
            case (0, $2e5e85a8c3cc12fd$export$80edbf15fa61a4db).StreamInvocation:
            case (0, $2e5e85a8c3cc12fd$export$80edbf15fa61a4db).CancelInvocation:
                return true;
            case (0, $2e5e85a8c3cc12fd$export$80edbf15fa61a4db).Close:
            case (0, $2e5e85a8c3cc12fd$export$80edbf15fa61a4db).Sequence:
            case (0, $2e5e85a8c3cc12fd$export$80edbf15fa61a4db).Ping:
            case (0, $2e5e85a8c3cc12fd$export$80edbf15fa61a4db).Ack:
                return false;
        }
    }
    _ackTimer() {
        if (this._ackTimerHandle === undefined) this._ackTimerHandle = setTimeout(async ()=>{
            try {
                if (!this._reconnectInProgress) await this._connection.send(this._protocol.writeMessage({
                    type: (0, $2e5e85a8c3cc12fd$export$80edbf15fa61a4db).Ack,
                    sequenceId: this._latestReceivedSequenceId
                }));
            // Ignore errors, that means the connection is closed and we don't care about the Ack message anymore.
            } catch  {}
            clearTimeout(this._ackTimerHandle);
            this._ackTimerHandle = undefined;
        // 1 second delay so we don't spam Ack messages if there are many messages being received at once.
        }, 1000);
    }
}
class $b8f262c250af9dbb$var$BufferedItem {
    constructor(message, id, resolver, rejector){
        this._message = message;
        this._id = id;
        this._resolver = resolver;
        this._rejector = rejector;
    }
}


const $abdc410ed994728b$var$DEFAULT_TIMEOUT_IN_MS = 30000;
const $abdc410ed994728b$var$DEFAULT_PING_INTERVAL_IN_MS = 15000;
const $abdc410ed994728b$var$DEFAULT_STATEFUL_RECONNECT_BUFFER_SIZE = 100000;
var $abdc410ed994728b$export$b8b4168ab851a6c3;
(function(HubConnectionState) {
    /** The hub connection is disconnected. */ HubConnectionState["Disconnected"] = "Disconnected";
    /** The hub connection is connecting. */ HubConnectionState["Connecting"] = "Connecting";
    /** The hub connection is connected. */ HubConnectionState["Connected"] = "Connected";
    /** The hub connection is disconnecting. */ HubConnectionState["Disconnecting"] = "Disconnecting";
    /** The hub connection is reconnecting. */ HubConnectionState["Reconnecting"] = "Reconnecting";
})($abdc410ed994728b$export$b8b4168ab851a6c3 || ($abdc410ed994728b$export$b8b4168ab851a6c3 = {}));
class $abdc410ed994728b$export$e5dbe756ed73e8c8 {
    /** @internal */ // Using a public static factory method means we can have a private constructor and an _internal_
    // create method that can be used by HubConnectionBuilder. An "internal" constructor would just
    // be stripped away and the '.d.ts' file would have no constructor, which is interpreted as a
    // public parameter-less constructor.
    static create(connection, logger, protocol, reconnectPolicy, serverTimeoutInMilliseconds, keepAliveIntervalInMilliseconds, statefulReconnectBufferSize) {
        return new $abdc410ed994728b$export$e5dbe756ed73e8c8(connection, logger, protocol, reconnectPolicy, serverTimeoutInMilliseconds, keepAliveIntervalInMilliseconds, statefulReconnectBufferSize);
    }
    constructor(connection, logger, protocol, reconnectPolicy, serverTimeoutInMilliseconds, keepAliveIntervalInMilliseconds, statefulReconnectBufferSize){
        this._nextKeepAlive = 0;
        this._freezeEventListener = ()=>{
            this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Warning, "The page is being frozen, this will likely lead to the connection being closed and messages being lost. For more information see the docs at https://learn.microsoft.com/aspnet/core/signalr/javascript-client#bsleep");
        };
        (0, $32bb29965a07731e$export$83f0753fc4347e43).isRequired(connection, "connection");
        (0, $32bb29965a07731e$export$83f0753fc4347e43).isRequired(logger, "logger");
        (0, $32bb29965a07731e$export$83f0753fc4347e43).isRequired(protocol, "protocol");
        this.serverTimeoutInMilliseconds = serverTimeoutInMilliseconds !== null && serverTimeoutInMilliseconds !== void 0 ? serverTimeoutInMilliseconds : $abdc410ed994728b$var$DEFAULT_TIMEOUT_IN_MS;
        this.keepAliveIntervalInMilliseconds = keepAliveIntervalInMilliseconds !== null && keepAliveIntervalInMilliseconds !== void 0 ? keepAliveIntervalInMilliseconds : $abdc410ed994728b$var$DEFAULT_PING_INTERVAL_IN_MS;
        this._statefulReconnectBufferSize = statefulReconnectBufferSize !== null && statefulReconnectBufferSize !== void 0 ? statefulReconnectBufferSize : $abdc410ed994728b$var$DEFAULT_STATEFUL_RECONNECT_BUFFER_SIZE;
        this._logger = logger;
        this._protocol = protocol;
        this.connection = connection;
        this._reconnectPolicy = reconnectPolicy;
        this._handshakeProtocol = new (0, $60dd2bca4d6878db$export$b23df48528d3f5f4)();
        this.connection.onreceive = (data)=>this._processIncomingData(data);
        this.connection.onclose = (error)=>this._connectionClosed(error);
        this._callbacks = {};
        this._methods = {};
        this._closedCallbacks = [];
        this._reconnectingCallbacks = [];
        this._reconnectedCallbacks = [];
        this._invocationId = 0;
        this._receivedHandshakeResponse = false;
        this._connectionState = $abdc410ed994728b$export$b8b4168ab851a6c3.Disconnected;
        this._connectionStarted = false;
        this._cachedPingMessage = this._protocol.writeMessage({
            type: (0, $2e5e85a8c3cc12fd$export$80edbf15fa61a4db).Ping
        });
    }
    /** Indicates the state of the {@link HubConnection} to the server. */ get state() {
        return this._connectionState;
    }
    /** Represents the connection id of the {@link HubConnection} on the server. The connection id will be null when the connection is either
     *  in the disconnected state or if the negotiation step was skipped.
     */ get connectionId() {
        return this.connection ? this.connection.connectionId || null : null;
    }
    /** Indicates the url of the {@link HubConnection} to the server. */ get baseUrl() {
        return this.connection.baseUrl || "";
    }
    /**
     * Sets a new url for the HubConnection. Note that the url can only be changed when the connection is in either the Disconnected or
     * Reconnecting states.
     * @param {string} url The url to connect to.
     */ set baseUrl(url) {
        if (this._connectionState !== $abdc410ed994728b$export$b8b4168ab851a6c3.Disconnected && this._connectionState !== $abdc410ed994728b$export$b8b4168ab851a6c3.Reconnecting) throw new Error("The HubConnection must be in the Disconnected or Reconnecting state to change the url.");
        if (!url) throw new Error("The HubConnection url must be a valid url.");
        this.connection.baseUrl = url;
    }
    /** Starts the connection.
     *
     * @returns {Promise<void>} A Promise that resolves when the connection has been successfully established, or rejects with an error.
     */ start() {
        this._startPromise = this._startWithStateTransitions();
        return this._startPromise;
    }
    async _startWithStateTransitions() {
        if (this._connectionState !== $abdc410ed994728b$export$b8b4168ab851a6c3.Disconnected) return Promise.reject(new Error("Cannot start a HubConnection that is not in the 'Disconnected' state."));
        this._connectionState = $abdc410ed994728b$export$b8b4168ab851a6c3.Connecting;
        this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Debug, "Starting HubConnection.");
        try {
            await this._startInternal();
            if ((0, $32bb29965a07731e$export$2dffd0b5373a4389).isBrowser) // Log when the browser freezes the tab so users know why their connection unexpectedly stopped working
            window.document.addEventListener("freeze", this._freezeEventListener);
            this._connectionState = $abdc410ed994728b$export$b8b4168ab851a6c3.Connected;
            this._connectionStarted = true;
            this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Debug, "HubConnection connected successfully.");
        } catch (e) {
            this._connectionState = $abdc410ed994728b$export$b8b4168ab851a6c3.Disconnected;
            this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Debug, `HubConnection failed to start successfully because of error '${e}'.`);
            return Promise.reject(e);
        }
    }
    async _startInternal() {
        this._stopDuringStartError = undefined;
        this._receivedHandshakeResponse = false;
        // Set up the promise before any connection is (re)started otherwise it could race with received messages
        const handshakePromise = new Promise((resolve, reject)=>{
            this._handshakeResolver = resolve;
            this._handshakeRejecter = reject;
        });
        await this.connection.start(this._protocol.transferFormat);
        try {
            let version = this._protocol.version;
            if (!this.connection.features.reconnect) // Stateful Reconnect starts with HubProtocol version 2, newer clients connecting to older servers will fail to connect due to
            // the handshake only supporting version 1, so we will try to send version 1 during the handshake to keep old servers working.
            version = 1;
            const handshakeRequest = {
                protocol: this._protocol.name,
                version: version
            };
            this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Debug, "Sending handshake request.");
            await this._sendMessage(this._handshakeProtocol.writeHandshakeRequest(handshakeRequest));
            this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Information, `Using HubProtocol '${this._protocol.name}'.`);
            // defensively cleanup timeout in case we receive a message from the server before we finish start
            this._cleanupTimeout();
            this._resetTimeoutPeriod();
            this._resetKeepAliveInterval();
            await handshakePromise;
            // It's important to check the stopDuringStartError instead of just relying on the handshakePromise
            // being rejected on close, because this continuation can run after both the handshake completed successfully
            // and the connection was closed.
            if (this._stopDuringStartError) // It's important to throw instead of returning a rejected promise, because we don't want to allow any state
            // transitions to occur between now and the calling code observing the exceptions. Returning a rejected promise
            // will cause the calling continuation to get scheduled to run later.
            // eslint-disable-next-line @typescript-eslint/no-throw-literal
            throw this._stopDuringStartError;
            const useStatefulReconnect = this.connection.features.reconnect || false;
            if (useStatefulReconnect) {
                this._messageBuffer = new (0, $b8f262c250af9dbb$export$9d24a0f7b61acd07)(this._protocol, this.connection, this._statefulReconnectBufferSize);
                this.connection.features.disconnected = this._messageBuffer._disconnected.bind(this._messageBuffer);
                this.connection.features.resend = ()=>{
                    if (this._messageBuffer) return this._messageBuffer._resend();
                };
            }
            if (!this.connection.features.inherentKeepAlive) await this._sendMessage(this._cachedPingMessage);
        } catch (e) {
            this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Debug, `Hub handshake failed with error '${e}' during start(). Stopping HubConnection.`);
            this._cleanupTimeout();
            this._cleanupPingTimer();
            // HttpConnection.stop() should not complete until after the onclose callback is invoked.
            // This will transition the HubConnection to the disconnected state before HttpConnection.stop() completes.
            await this.connection.stop(e);
            throw e;
        }
    }
    /** Stops the connection.
     *
     * @returns {Promise<void>} A Promise that resolves when the connection has been successfully terminated, or rejects with an error.
     */ async stop() {
        // Capture the start promise before the connection might be restarted in an onclose callback.
        const startPromise = this._startPromise;
        this.connection.features.reconnect = false;
        this._stopPromise = this._stopInternal();
        await this._stopPromise;
        try {
            // Awaiting undefined continues immediately
            await startPromise;
        } catch (e) {
        // This exception is returned to the user as a rejected Promise from the start method.
        }
    }
    _stopInternal(error) {
        if (this._connectionState === $abdc410ed994728b$export$b8b4168ab851a6c3.Disconnected) {
            this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Debug, `Call to HubConnection.stop(${error}) ignored because it is already in the disconnected state.`);
            return Promise.resolve();
        }
        if (this._connectionState === $abdc410ed994728b$export$b8b4168ab851a6c3.Disconnecting) {
            this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Debug, `Call to HttpConnection.stop(${error}) ignored because the connection is already in the disconnecting state.`);
            return this._stopPromise;
        }
        const state = this._connectionState;
        this._connectionState = $abdc410ed994728b$export$b8b4168ab851a6c3.Disconnecting;
        this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Debug, "Stopping HubConnection.");
        if (this._reconnectDelayHandle) {
            // We're in a reconnect delay which means the underlying connection is currently already stopped.
            // Just clear the handle to stop the reconnect loop (which no one is waiting on thankfully) and
            // fire the onclose callbacks.
            this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Debug, "Connection stopped during reconnect delay. Done reconnecting.");
            clearTimeout(this._reconnectDelayHandle);
            this._reconnectDelayHandle = undefined;
            this._completeClose();
            return Promise.resolve();
        }
        if (state === $abdc410ed994728b$export$b8b4168ab851a6c3.Connected) // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendCloseMessage();
        this._cleanupTimeout();
        this._cleanupPingTimer();
        this._stopDuringStartError = error || new (0, $9862e2597169e2d4$export$18b052ffd8c84d7)("The connection was stopped before the hub handshake could complete.");
        // HttpConnection.stop() should not complete until after either HttpConnection.start() fails
        // or the onclose callback is invoked. The onclose callback will transition the HubConnection
        // to the disconnected state if need be before HttpConnection.stop() completes.
        return this.connection.stop(error);
    }
    async _sendCloseMessage() {
        try {
            await this._sendWithProtocol(this._createCloseMessage());
        } catch  {
        // Ignore, this is a best effort attempt to let the server know the client closed gracefully.
        }
    }
    /** Invokes a streaming hub method on the server using the specified name and arguments.
     *
     * @typeparam T The type of the items returned by the server.
     * @param {string} methodName The name of the server method to invoke.
     * @param {any[]} args The arguments used to invoke the server method.
     * @returns {IStreamResult<T>} An object that yields results from the server as they are received.
     */ stream(methodName, ...args) {
        const [streams, streamIds] = this._replaceStreamingParams(args);
        const invocationDescriptor = this._createStreamInvocation(methodName, args, streamIds);
        // eslint-disable-next-line prefer-const
        let promiseQueue;
        const subject = new (0, $82e59eaf686a40c1$export$b6bbab5a9b109038)();
        subject.cancelCallback = ()=>{
            const cancelInvocation = this._createCancelInvocation(invocationDescriptor.invocationId);
            delete this._callbacks[invocationDescriptor.invocationId];
            return promiseQueue.then(()=>{
                return this._sendWithProtocol(cancelInvocation);
            });
        };
        this._callbacks[invocationDescriptor.invocationId] = (invocationEvent, error)=>{
            if (error) {
                subject.error(error);
                return;
            } else if (invocationEvent) {
                // invocationEvent will not be null when an error is not passed to the callback
                if (invocationEvent.type === (0, $2e5e85a8c3cc12fd$export$80edbf15fa61a4db).Completion) {
                    if (invocationEvent.error) subject.error(new Error(invocationEvent.error));
                    else subject.complete();
                } else subject.next(invocationEvent.item);
            }
        };
        promiseQueue = this._sendWithProtocol(invocationDescriptor).catch((e)=>{
            subject.error(e);
            delete this._callbacks[invocationDescriptor.invocationId];
        });
        this._launchStreams(streams, promiseQueue);
        return subject;
    }
    _sendMessage(message) {
        this._resetKeepAliveInterval();
        return this.connection.send(message);
    }
    /**
     * Sends a js object to the server.
     * @param message The js object to serialize and send.
     */ _sendWithProtocol(message) {
        if (this._messageBuffer) return this._messageBuffer._send(message);
        else return this._sendMessage(this._protocol.writeMessage(message));
    }
    /** Invokes a hub method on the server using the specified name and arguments. Does not wait for a response from the receiver.
     *
     * The Promise returned by this method resolves when the client has sent the invocation to the server. The server may still
     * be processing the invocation.
     *
     * @param {string} methodName The name of the server method to invoke.
     * @param {any[]} args The arguments used to invoke the server method.
     * @returns {Promise<void>} A Promise that resolves when the invocation has been successfully sent, or rejects with an error.
     */ send(methodName, ...args) {
        const [streams, streamIds] = this._replaceStreamingParams(args);
        const sendPromise = this._sendWithProtocol(this._createInvocation(methodName, args, true, streamIds));
        this._launchStreams(streams, sendPromise);
        return sendPromise;
    }
    /** Invokes a hub method on the server using the specified name and arguments.
     *
     * The Promise returned by this method resolves when the server indicates it has finished invoking the method. When the promise
     * resolves, the server has finished invoking the method. If the server method returns a result, it is produced as the result of
     * resolving the Promise.
     *
     * @typeparam T The expected return type.
     * @param {string} methodName The name of the server method to invoke.
     * @param {any[]} args The arguments used to invoke the server method.
     * @returns {Promise<T>} A Promise that resolves with the result of the server method (if any), or rejects with an error.
     */ invoke(methodName, ...args) {
        const [streams, streamIds] = this._replaceStreamingParams(args);
        const invocationDescriptor = this._createInvocation(methodName, args, false, streamIds);
        const p = new Promise((resolve, reject)=>{
            // invocationId will always have a value for a non-blocking invocation
            this._callbacks[invocationDescriptor.invocationId] = (invocationEvent, error)=>{
                if (error) {
                    reject(error);
                    return;
                } else if (invocationEvent) {
                    // invocationEvent will not be null when an error is not passed to the callback
                    if (invocationEvent.type === (0, $2e5e85a8c3cc12fd$export$80edbf15fa61a4db).Completion) {
                        if (invocationEvent.error) reject(new Error(invocationEvent.error));
                        else resolve(invocationEvent.result);
                    } else reject(new Error(`Unexpected message type: ${invocationEvent.type}`));
                }
            };
            const promiseQueue = this._sendWithProtocol(invocationDescriptor).catch((e)=>{
                reject(e);
                // invocationId will always have a value for a non-blocking invocation
                delete this._callbacks[invocationDescriptor.invocationId];
            });
            this._launchStreams(streams, promiseQueue);
        });
        return p;
    }
    on(methodName, newMethod) {
        if (!methodName || !newMethod) return;
        methodName = methodName.toLowerCase();
        if (!this._methods[methodName]) this._methods[methodName] = [];
        // Preventing adding the same handler multiple times.
        if (this._methods[methodName].indexOf(newMethod) !== -1) return;
        this._methods[methodName].push(newMethod);
    }
    off(methodName, method) {
        if (!methodName) return;
        methodName = methodName.toLowerCase();
        const handlers = this._methods[methodName];
        if (!handlers) return;
        if (method) {
            const removeIdx = handlers.indexOf(method);
            if (removeIdx !== -1) {
                handlers.splice(removeIdx, 1);
                if (handlers.length === 0) delete this._methods[methodName];
            }
        } else delete this._methods[methodName];
    }
    /** Registers a handler that will be invoked when the connection is closed.
     *
     * @param {Function} callback The handler that will be invoked when the connection is closed. Optionally receives a single argument containing the error that caused the connection to close (if any).
     */ onclose(callback) {
        if (callback) this._closedCallbacks.push(callback);
    }
    /** Registers a handler that will be invoked when the connection starts reconnecting.
     *
     * @param {Function} callback The handler that will be invoked when the connection starts reconnecting. Optionally receives a single argument containing the error that caused the connection to start reconnecting (if any).
     */ onreconnecting(callback) {
        if (callback) this._reconnectingCallbacks.push(callback);
    }
    /** Registers a handler that will be invoked when the connection successfully reconnects.
     *
     * @param {Function} callback The handler that will be invoked when the connection successfully reconnects.
     */ onreconnected(callback) {
        if (callback) this._reconnectedCallbacks.push(callback);
    }
    _processIncomingData(data) {
        this._cleanupTimeout();
        if (!this._receivedHandshakeResponse) {
            data = this._processHandshakeResponse(data);
            this._receivedHandshakeResponse = true;
        }
        // Data may have all been read when processing handshake response
        if (data) {
            // Parse the messages
            const messages = this._protocol.parseMessages(data, this._logger);
            for (const message of messages){
                if (this._messageBuffer && !this._messageBuffer._shouldProcessMessage(message)) continue;
                switch(message.type){
                    case (0, $2e5e85a8c3cc12fd$export$80edbf15fa61a4db).Invocation:
                        this._invokeClientMethod(message).catch((e)=>{
                            this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Error, `Invoke client method threw error: ${(0, $32bb29965a07731e$export$375b49718dbd9ced)(e)}`);
                        });
                        break;
                    case (0, $2e5e85a8c3cc12fd$export$80edbf15fa61a4db).StreamItem:
                    case (0, $2e5e85a8c3cc12fd$export$80edbf15fa61a4db).Completion:
                        {
                            const callback = this._callbacks[message.invocationId];
                            if (callback) {
                                if (message.type === (0, $2e5e85a8c3cc12fd$export$80edbf15fa61a4db).Completion) delete this._callbacks[message.invocationId];
                                try {
                                    callback(message);
                                } catch (e) {
                                    this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Error, `Stream callback threw error: ${(0, $32bb29965a07731e$export$375b49718dbd9ced)(e)}`);
                                }
                            }
                            break;
                        }
                    case (0, $2e5e85a8c3cc12fd$export$80edbf15fa61a4db).Ping:
                        break;
                    case (0, $2e5e85a8c3cc12fd$export$80edbf15fa61a4db).Close:
                        {
                            this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Information, "Close message received from server.");
                            const error = message.error ? new Error("Server returned an error on close: " + message.error) : undefined;
                            if (message.allowReconnect === true) // It feels wrong not to await connection.stop() here, but processIncomingData is called as part of an onreceive callback which is not async,
                            // this is already the behavior for serverTimeout(), and HttpConnection.Stop() should catch and log all possible exceptions.
                            // eslint-disable-next-line @typescript-eslint/no-floating-promises
                            this.connection.stop(error);
                            else // We cannot await stopInternal() here, but subsequent calls to stop() will await this if stopInternal() is still ongoing.
                            this._stopPromise = this._stopInternal(error);
                            break;
                        }
                    case (0, $2e5e85a8c3cc12fd$export$80edbf15fa61a4db).Ack:
                        if (this._messageBuffer) this._messageBuffer._ack(message);
                        break;
                    case (0, $2e5e85a8c3cc12fd$export$80edbf15fa61a4db).Sequence:
                        if (this._messageBuffer) this._messageBuffer._resetSequence(message);
                        break;
                    default:
                        this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Warning, `Invalid message type: ${message.type}.`);
                        break;
                }
            }
        }
        this._resetTimeoutPeriod();
    }
    _processHandshakeResponse(data) {
        let responseMessage;
        let remainingData;
        try {
            [remainingData, responseMessage] = this._handshakeProtocol.parseHandshakeResponse(data);
        } catch (e) {
            const message = "Error parsing handshake response: " + e;
            this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Error, message);
            const error = new Error(message);
            this._handshakeRejecter(error);
            throw error;
        }
        if (responseMessage.error) {
            const message = "Server returned handshake error: " + responseMessage.error;
            this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Error, message);
            const error = new Error(message);
            this._handshakeRejecter(error);
            throw error;
        } else this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Debug, "Server handshake complete.");
        this._handshakeResolver();
        return remainingData;
    }
    _resetKeepAliveInterval() {
        if (this.connection.features.inherentKeepAlive) return;
        // Set the time we want the next keep alive to be sent
        // Timer will be setup on next message receive
        this._nextKeepAlive = new Date().getTime() + this.keepAliveIntervalInMilliseconds;
        this._cleanupPingTimer();
    }
    _resetTimeoutPeriod() {
        if (!this.connection.features || !this.connection.features.inherentKeepAlive) {
            // Set the timeout timer
            this._timeoutHandle = setTimeout(()=>this.serverTimeout(), this.serverTimeoutInMilliseconds);
            // Immediately fire Keep-Alive ping if nextPing is overdue to avoid dependency on JS timers
            let nextPing = this._nextKeepAlive - new Date().getTime();
            if (nextPing < 0) {
                if (this._connectionState === $abdc410ed994728b$export$b8b4168ab851a6c3.Connected) // eslint-disable-next-line @typescript-eslint/no-floating-promises
                this._trySendPingMessage();
                return;
            }
            // Set keepAlive timer if there isn't one
            if (this._pingServerHandle === undefined) {
                if (nextPing < 0) nextPing = 0;
                // The timer needs to be set from a networking callback to avoid Chrome timer throttling from causing timers to run once a minute
                this._pingServerHandle = setTimeout(async ()=>{
                    if (this._connectionState === $abdc410ed994728b$export$b8b4168ab851a6c3.Connected) await this._trySendPingMessage();
                }, nextPing);
            }
        }
    }
    // eslint-disable-next-line @typescript-eslint/naming-convention
    serverTimeout() {
        // The server hasn't talked to us in a while. It doesn't like us anymore ... :(
        // Terminate the connection, but we don't need to wait on the promise. This could trigger reconnecting.
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.connection.stop(new Error("Server timeout elapsed without receiving a message from the server."));
    }
    async _invokeClientMethod(invocationMessage) {
        const methodName = invocationMessage.target.toLowerCase();
        const methods = this._methods[methodName];
        if (!methods) {
            this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Warning, `No client method with the name '${methodName}' found.`);
            // No handlers provided by client but the server is expecting a response still, so we send an error
            if (invocationMessage.invocationId) {
                this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Warning, `No result given for '${methodName}' method and invocation ID '${invocationMessage.invocationId}'.`);
                await this._sendWithProtocol(this._createCompletionMessage(invocationMessage.invocationId, "Client didn't provide a result.", null));
            }
            return;
        }
        // Avoid issues with handlers removing themselves thus modifying the list while iterating through it
        const methodsCopy = methods.slice();
        // Server expects a response
        const expectsResponse = invocationMessage.invocationId ? true : false;
        // We preserve the last result or exception but still call all handlers
        let res;
        let exception;
        let completionMessage;
        for (const m of methodsCopy)try {
            const prevRes = res;
            res = await m.apply(this, invocationMessage.arguments);
            if (expectsResponse && res && prevRes) {
                this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Error, `Multiple results provided for '${methodName}'. Sending error to server.`);
                completionMessage = this._createCompletionMessage(invocationMessage.invocationId, `Client provided multiple results.`, null);
            }
            // Ignore exception if we got a result after, the exception will be logged
            exception = undefined;
        } catch (e) {
            exception = e;
            this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Error, `A callback for the method '${methodName}' threw error '${e}'.`);
        }
        if (completionMessage) await this._sendWithProtocol(completionMessage);
        else if (expectsResponse) {
            // If there is an exception that means either no result was given or a handler after a result threw
            if (exception) completionMessage = this._createCompletionMessage(invocationMessage.invocationId, `${exception}`, null);
            else if (res !== undefined) completionMessage = this._createCompletionMessage(invocationMessage.invocationId, null, res);
            else {
                this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Warning, `No result given for '${methodName}' method and invocation ID '${invocationMessage.invocationId}'.`);
                // Client didn't provide a result or throw from a handler, server expects a response so we send an error
                completionMessage = this._createCompletionMessage(invocationMessage.invocationId, "Client didn't provide a result.", null);
            }
            await this._sendWithProtocol(completionMessage);
        } else if (res) this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Error, `Result given for '${methodName}' method but server is not expecting a result.`);
    }
    _connectionClosed(error) {
        this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Debug, `HubConnection.connectionClosed(${error}) called while in state ${this._connectionState}.`);
        // Triggering this.handshakeRejecter is insufficient because it could already be resolved without the continuation having run yet.
        this._stopDuringStartError = this._stopDuringStartError || error || new (0, $9862e2597169e2d4$export$18b052ffd8c84d7)("The underlying connection was closed before the hub handshake could complete.");
        // If the handshake is in progress, start will be waiting for the handshake promise, so we complete it.
        // If it has already completed, this should just noop.
        if (this._handshakeResolver) this._handshakeResolver();
        this._cancelCallbacksWithError(error || new Error("Invocation canceled due to the underlying connection being closed."));
        this._cleanupTimeout();
        this._cleanupPingTimer();
        if (this._connectionState === $abdc410ed994728b$export$b8b4168ab851a6c3.Disconnecting) this._completeClose(error);
        else if (this._connectionState === $abdc410ed994728b$export$b8b4168ab851a6c3.Connected && this._reconnectPolicy) // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._reconnect(error);
        else if (this._connectionState === $abdc410ed994728b$export$b8b4168ab851a6c3.Connected) this._completeClose(error);
    // If none of the above if conditions were true were called the HubConnection must be in either:
    // 1. The Connecting state in which case the handshakeResolver will complete it and stopDuringStartError will fail it.
    // 2. The Reconnecting state in which case the handshakeResolver will complete it and stopDuringStartError will fail the current reconnect attempt
    //    and potentially continue the reconnect() loop.
    // 3. The Disconnected state in which case we're already done.
    }
    _completeClose(error) {
        if (this._connectionStarted) {
            this._connectionState = $abdc410ed994728b$export$b8b4168ab851a6c3.Disconnected;
            this._connectionStarted = false;
            if (this._messageBuffer) {
                this._messageBuffer._dispose(error !== null && error !== void 0 ? error : new Error("Connection closed."));
                this._messageBuffer = undefined;
            }
            if ((0, $32bb29965a07731e$export$2dffd0b5373a4389).isBrowser) window.document.removeEventListener("freeze", this._freezeEventListener);
            try {
                this._closedCallbacks.forEach((c)=>c.apply(this, [
                        error
                    ]));
            } catch (e) {
                this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Error, `An onclose callback called with error '${error}' threw error '${e}'.`);
            }
        }
    }
    async _reconnect(error) {
        const reconnectStartTime = Date.now();
        let previousReconnectAttempts = 0;
        let retryError = error !== undefined ? error : new Error("Attempting to reconnect due to a unknown error.");
        let nextRetryDelay = this._getNextRetryDelay(previousReconnectAttempts, 0, retryError);
        if (nextRetryDelay === null) {
            this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Debug, "Connection not reconnecting because the IRetryPolicy returned null on the first reconnect attempt.");
            this._completeClose(error);
            return;
        }
        this._connectionState = $abdc410ed994728b$export$b8b4168ab851a6c3.Reconnecting;
        if (error) this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Information, `Connection reconnecting because of error '${error}'.`);
        else this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Information, "Connection reconnecting.");
        if (this._reconnectingCallbacks.length !== 0) {
            try {
                this._reconnectingCallbacks.forEach((c)=>c.apply(this, [
                        error
                    ]));
            } catch (e) {
                this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Error, `An onreconnecting callback called with error '${error}' threw error '${e}'.`);
            }
            // Exit early if an onreconnecting callback called connection.stop().
            if (this._connectionState !== $abdc410ed994728b$export$b8b4168ab851a6c3.Reconnecting) {
                this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Debug, "Connection left the reconnecting state in onreconnecting callback. Done reconnecting.");
                return;
            }
        }
        while(nextRetryDelay !== null){
            this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Information, `Reconnect attempt number ${previousReconnectAttempts + 1} will start in ${nextRetryDelay} ms.`);
            await new Promise((resolve)=>{
                this._reconnectDelayHandle = setTimeout(resolve, nextRetryDelay);
            });
            this._reconnectDelayHandle = undefined;
            if (this._connectionState !== $abdc410ed994728b$export$b8b4168ab851a6c3.Reconnecting) {
                this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Debug, "Connection left the reconnecting state during reconnect delay. Done reconnecting.");
                return;
            }
            try {
                await this._startInternal();
                this._connectionState = $abdc410ed994728b$export$b8b4168ab851a6c3.Connected;
                this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Information, "HubConnection reconnected successfully.");
                if (this._reconnectedCallbacks.length !== 0) try {
                    this._reconnectedCallbacks.forEach((c)=>c.apply(this, [
                            this.connection.connectionId
                        ]));
                } catch (e) {
                    this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Error, `An onreconnected callback called with connectionId '${this.connection.connectionId}; threw error '${e}'.`);
                }
                return;
            } catch (e) {
                this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Information, `Reconnect attempt failed because of error '${e}'.`);
                if (this._connectionState !== $abdc410ed994728b$export$b8b4168ab851a6c3.Reconnecting) {
                    this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Debug, `Connection moved to the '${this._connectionState}' from the reconnecting state during reconnect attempt. Done reconnecting.`);
                    // The TypeScript compiler thinks that connectionState must be Connected here. The TypeScript compiler is wrong.
                    if (this._connectionState === $abdc410ed994728b$export$b8b4168ab851a6c3.Disconnecting) this._completeClose();
                    return;
                }
                previousReconnectAttempts++;
                retryError = e instanceof Error ? e : new Error(e.toString());
                nextRetryDelay = this._getNextRetryDelay(previousReconnectAttempts, Date.now() - reconnectStartTime, retryError);
            }
        }
        this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Information, `Reconnect retries have been exhausted after ${Date.now() - reconnectStartTime} ms and ${previousReconnectAttempts} failed attempts. Connection disconnecting.`);
        this._completeClose();
    }
    _getNextRetryDelay(previousRetryCount, elapsedMilliseconds, retryReason) {
        try {
            return this._reconnectPolicy.nextRetryDelayInMilliseconds({
                elapsedMilliseconds: elapsedMilliseconds,
                previousRetryCount: previousRetryCount,
                retryReason: retryReason
            });
        } catch (e) {
            this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Error, `IRetryPolicy.nextRetryDelayInMilliseconds(${previousRetryCount}, ${elapsedMilliseconds}) threw error '${e}'.`);
            return null;
        }
    }
    _cancelCallbacksWithError(error) {
        const callbacks = this._callbacks;
        this._callbacks = {};
        Object.keys(callbacks).forEach((key)=>{
            const callback = callbacks[key];
            try {
                callback(null, error);
            } catch (e) {
                this._logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Error, `Stream 'error' callback called with '${error}' threw error: ${(0, $32bb29965a07731e$export$375b49718dbd9ced)(e)}`);
            }
        });
    }
    _cleanupPingTimer() {
        if (this._pingServerHandle) {
            clearTimeout(this._pingServerHandle);
            this._pingServerHandle = undefined;
        }
    }
    _cleanupTimeout() {
        if (this._timeoutHandle) clearTimeout(this._timeoutHandle);
    }
    _createInvocation(methodName, args, nonblocking, streamIds) {
        if (nonblocking) {
            if (streamIds.length !== 0) return {
                target: methodName,
                arguments: args,
                streamIds: streamIds,
                type: (0, $2e5e85a8c3cc12fd$export$80edbf15fa61a4db).Invocation
            };
            else return {
                target: methodName,
                arguments: args,
                type: (0, $2e5e85a8c3cc12fd$export$80edbf15fa61a4db).Invocation
            };
        } else {
            const invocationId = this._invocationId;
            this._invocationId++;
            if (streamIds.length !== 0) return {
                target: methodName,
                arguments: args,
                invocationId: invocationId.toString(),
                streamIds: streamIds,
                type: (0, $2e5e85a8c3cc12fd$export$80edbf15fa61a4db).Invocation
            };
            else return {
                target: methodName,
                arguments: args,
                invocationId: invocationId.toString(),
                type: (0, $2e5e85a8c3cc12fd$export$80edbf15fa61a4db).Invocation
            };
        }
    }
    _launchStreams(streams, promiseQueue) {
        if (streams.length === 0) return;
        // Synchronize stream data so they arrive in-order on the server
        if (!promiseQueue) promiseQueue = Promise.resolve();
        // We want to iterate over the keys, since the keys are the stream ids
        // eslint-disable-next-line guard-for-in
        for(const streamId in streams)streams[streamId].subscribe({
            complete: ()=>{
                promiseQueue = promiseQueue.then(()=>this._sendWithProtocol(this._createCompletionMessage(streamId)));
            },
            error: (err)=>{
                let message;
                if (err instanceof Error) message = err.message;
                else if (err && err.toString) message = err.toString();
                else message = "Unknown error";
                promiseQueue = promiseQueue.then(()=>this._sendWithProtocol(this._createCompletionMessage(streamId, message)));
            },
            next: (item)=>{
                promiseQueue = promiseQueue.then(()=>this._sendWithProtocol(this._createStreamItemMessage(streamId, item)));
            }
        });
    }
    _replaceStreamingParams(args) {
        const streams = [];
        const streamIds = [];
        for(let i = 0; i < args.length; i++){
            const argument = args[i];
            if (this._isObservable(argument)) {
                const streamId = this._invocationId;
                this._invocationId++;
                // Store the stream for later use
                streams[streamId] = argument;
                streamIds.push(streamId.toString());
                // remove stream from args
                args.splice(i, 1);
            }
        }
        return [
            streams,
            streamIds
        ];
    }
    _isObservable(arg) {
        // This allows other stream implementations to just work (like rxjs)
        return arg && arg.subscribe && typeof arg.subscribe === "function";
    }
    _createStreamInvocation(methodName, args, streamIds) {
        const invocationId = this._invocationId;
        this._invocationId++;
        if (streamIds.length !== 0) return {
            target: methodName,
            arguments: args,
            invocationId: invocationId.toString(),
            streamIds: streamIds,
            type: (0, $2e5e85a8c3cc12fd$export$80edbf15fa61a4db).StreamInvocation
        };
        else return {
            target: methodName,
            arguments: args,
            invocationId: invocationId.toString(),
            type: (0, $2e5e85a8c3cc12fd$export$80edbf15fa61a4db).StreamInvocation
        };
    }
    _createCancelInvocation(id) {
        return {
            invocationId: id,
            type: (0, $2e5e85a8c3cc12fd$export$80edbf15fa61a4db).CancelInvocation
        };
    }
    _createStreamItemMessage(id, item) {
        return {
            invocationId: id,
            item: item,
            type: (0, $2e5e85a8c3cc12fd$export$80edbf15fa61a4db).StreamItem
        };
    }
    _createCompletionMessage(id, error, result) {
        if (error) return {
            error: error,
            invocationId: id,
            type: (0, $2e5e85a8c3cc12fd$export$80edbf15fa61a4db).Completion
        };
        return {
            invocationId: id,
            result: result,
            type: (0, $2e5e85a8c3cc12fd$export$80edbf15fa61a4db).Completion
        };
    }
    _createCloseMessage() {
        return {
            type: (0, $2e5e85a8c3cc12fd$export$80edbf15fa61a4db).Close
        };
    }
    async _trySendPingMessage() {
        try {
            await this._sendMessage(this._cachedPingMessage);
        } catch  {
            // We don't care about the error. It should be seen elsewhere in the client.
            // The connection is probably in a bad or closed state now, cleanup the timer so it stops triggering
            this._cleanupPingTimer();
        }
    }
}



// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.





const $b090a650b4fba31d$var$JSON_HUB_PROTOCOL_NAME = "json";
class $b090a650b4fba31d$export$11f4f8ecec1ad0c8 {
    constructor(){
        /** @inheritDoc */ this.name = $b090a650b4fba31d$var$JSON_HUB_PROTOCOL_NAME;
        /** @inheritDoc */ this.version = 2;
        /** @inheritDoc */ this.transferFormat = (0, $dfd8c9cbca816579$export$f29afaa8e8d2989a).Text;
    }
    /** Creates an array of {@link @microsoft/signalr.HubMessage} objects from the specified serialized representation.
     *
     * @param {string} input A string containing the serialized representation.
     * @param {ILogger} logger A logger that will be used to log messages that occur during parsing.
     */ parseMessages(input, logger) {
        // The interface does allow "ArrayBuffer" to be passed in, but this implementation does not. So let's throw a useful error.
        if (typeof input !== "string") throw new Error("Invalid input for JSON hub protocol. Expected a string.");
        if (!input) return [];
        if (logger === null) logger = (0, $b632327c1843227b$export$17ac58a1138ded46).instance;
        // Parse the messages
        const messages = (0, $5e59b4f8b1f9494d$export$fc2e5d47850f626b).parse(input);
        const hubMessages = [];
        for (const message of messages){
            const parsedMessage = JSON.parse(message);
            if (typeof parsedMessage.type !== "number") throw new Error("Invalid payload.");
            switch(parsedMessage.type){
                case (0, $2e5e85a8c3cc12fd$export$80edbf15fa61a4db).Invocation:
                    this._isInvocationMessage(parsedMessage);
                    break;
                case (0, $2e5e85a8c3cc12fd$export$80edbf15fa61a4db).StreamItem:
                    this._isStreamItemMessage(parsedMessage);
                    break;
                case (0, $2e5e85a8c3cc12fd$export$80edbf15fa61a4db).Completion:
                    this._isCompletionMessage(parsedMessage);
                    break;
                case (0, $2e5e85a8c3cc12fd$export$80edbf15fa61a4db).Ping:
                    break;
                case (0, $2e5e85a8c3cc12fd$export$80edbf15fa61a4db).Close:
                    break;
                case (0, $2e5e85a8c3cc12fd$export$80edbf15fa61a4db).Ack:
                    this._isAckMessage(parsedMessage);
                    break;
                case (0, $2e5e85a8c3cc12fd$export$80edbf15fa61a4db).Sequence:
                    this._isSequenceMessage(parsedMessage);
                    break;
                default:
                    // Future protocol changes can add message types, old clients can ignore them
                    logger.log((0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Information, "Unknown message type '" + parsedMessage.type + "' ignored.");
                    continue;
            }
            hubMessages.push(parsedMessage);
        }
        return hubMessages;
    }
    /** Writes the specified {@link @microsoft/signalr.HubMessage} to a string and returns it.
     *
     * @param {HubMessage} message The message to write.
     * @returns {string} A string containing the serialized representation of the message.
     */ writeMessage(message) {
        return (0, $5e59b4f8b1f9494d$export$fc2e5d47850f626b).write(JSON.stringify(message));
    }
    _isInvocationMessage(message) {
        this._assertNotEmptyString(message.target, "Invalid payload for Invocation message.");
        if (message.invocationId !== undefined) this._assertNotEmptyString(message.invocationId, "Invalid payload for Invocation message.");
    }
    _isStreamItemMessage(message) {
        this._assertNotEmptyString(message.invocationId, "Invalid payload for StreamItem message.");
        if (message.item === undefined) throw new Error("Invalid payload for StreamItem message.");
    }
    _isCompletionMessage(message) {
        if (message.result && message.error) throw new Error("Invalid payload for Completion message.");
        if (!message.result && message.error) this._assertNotEmptyString(message.error, "Invalid payload for Completion message.");
        this._assertNotEmptyString(message.invocationId, "Invalid payload for Completion message.");
    }
    _isAckMessage(message) {
        if (typeof message.sequenceId !== 'number') throw new Error("Invalid SequenceId for Ack message.");
    }
    _isSequenceMessage(message) {
        if (typeof message.sequenceId !== 'number') throw new Error("Invalid SequenceId for Sequence message.");
    }
    _assertNotEmptyString(value, errorMessage) {
        if (typeof value !== "string" || value === "") throw new Error(errorMessage);
    }
}




const $cccc8edc49e3facc$var$LogLevelNameMapping = {
    trace: (0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Trace,
    debug: (0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Debug,
    info: (0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Information,
    information: (0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Information,
    warn: (0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Warning,
    warning: (0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Warning,
    error: (0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Error,
    critical: (0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).Critical,
    none: (0, $5f3832d7be2e7d2f$export$243e62d78d3b544d).None
};
function $cccc8edc49e3facc$var$parseLogLevel(name) {
    // Case-insensitive matching via lower-casing
    // Yes, I know case-folding is a complicated problem in Unicode, but we only support
    // the ASCII strings defined in LogLevelNameMapping anyway, so it's fine -anurse.
    const mapping = $cccc8edc49e3facc$var$LogLevelNameMapping[name.toLowerCase()];
    if (typeof mapping !== "undefined") return mapping;
    else throw new Error(`Unknown log level: ${name}`);
}
class $cccc8edc49e3facc$export$afccb10c24910b13 {
    configureLogging(logging) {
        (0, $32bb29965a07731e$export$83f0753fc4347e43).isRequired(logging, "logging");
        if ($cccc8edc49e3facc$var$isLogger(logging)) this.logger = logging;
        else if (typeof logging === "string") {
            const logLevel = $cccc8edc49e3facc$var$parseLogLevel(logging);
            this.logger = new (0, $32bb29965a07731e$export$ba6a9c7ac8291f7f)(logLevel);
        } else this.logger = new (0, $32bb29965a07731e$export$ba6a9c7ac8291f7f)(logging);
        return this;
    }
    withUrl(url, transportTypeOrOptions) {
        (0, $32bb29965a07731e$export$83f0753fc4347e43).isRequired(url, "url");
        (0, $32bb29965a07731e$export$83f0753fc4347e43).isNotEmpty(url, "url");
        this.url = url;
        // Flow-typing knows where it's at. Since HttpTransportType is a number and IHttpConnectionOptions is guaranteed
        // to be an object, we know (as does TypeScript) this comparison is all we need to figure out which overload was called.
        if (typeof transportTypeOrOptions === "object") this.httpConnectionOptions = {
            ...this.httpConnectionOptions,
            ...transportTypeOrOptions
        };
        else this.httpConnectionOptions = {
            ...this.httpConnectionOptions,
            transport: transportTypeOrOptions
        };
        return this;
    }
    /** Configures the {@link @microsoft/signalr.HubConnection} to use the specified Hub Protocol.
     *
     * @param {IHubProtocol} protocol The {@link @microsoft/signalr.IHubProtocol} implementation to use.
     */ withHubProtocol(protocol) {
        (0, $32bb29965a07731e$export$83f0753fc4347e43).isRequired(protocol, "protocol");
        this.protocol = protocol;
        return this;
    }
    withAutomaticReconnect(retryDelaysOrReconnectPolicy) {
        if (this.reconnectPolicy) throw new Error("A reconnectPolicy has already been set.");
        if (!retryDelaysOrReconnectPolicy) this.reconnectPolicy = new (0, $a70d4a2704acd148$export$97bc471d6a059e6e)();
        else if (Array.isArray(retryDelaysOrReconnectPolicy)) this.reconnectPolicy = new (0, $a70d4a2704acd148$export$97bc471d6a059e6e)(retryDelaysOrReconnectPolicy);
        else this.reconnectPolicy = retryDelaysOrReconnectPolicy;
        return this;
    }
    /** Configures {@link @microsoft/signalr.HubConnection.serverTimeoutInMilliseconds} for the {@link @microsoft/signalr.HubConnection}.
     *
     * @returns The {@link @microsoft/signalr.HubConnectionBuilder} instance, for chaining.
     */ withServerTimeout(milliseconds) {
        (0, $32bb29965a07731e$export$83f0753fc4347e43).isRequired(milliseconds, "milliseconds");
        this._serverTimeoutInMilliseconds = milliseconds;
        return this;
    }
    /** Configures {@link @microsoft/signalr.HubConnection.keepAliveIntervalInMilliseconds} for the {@link @microsoft/signalr.HubConnection}.
     *
     * @returns The {@link @microsoft/signalr.HubConnectionBuilder} instance, for chaining.
     */ withKeepAliveInterval(milliseconds) {
        (0, $32bb29965a07731e$export$83f0753fc4347e43).isRequired(milliseconds, "milliseconds");
        this._keepAliveIntervalInMilliseconds = milliseconds;
        return this;
    }
    /** Enables and configures options for the Stateful Reconnect feature.
     *
     * @returns The {@link @microsoft/signalr.HubConnectionBuilder} instance, for chaining.
     */ withStatefulReconnect(options) {
        if (this.httpConnectionOptions === undefined) this.httpConnectionOptions = {};
        this.httpConnectionOptions._useStatefulReconnect = true;
        this._statefulReconnectBufferSize = options === null || options === void 0 ? void 0 : options.bufferSize;
        return this;
    }
    /** Creates a {@link @microsoft/signalr.HubConnection} from the configuration options specified in this builder.
     *
     * @returns {HubConnection} The configured {@link @microsoft/signalr.HubConnection}.
     */ build() {
        // If httpConnectionOptions has a logger, use it. Otherwise, override it with the one
        // provided to configureLogger
        const httpConnectionOptions = this.httpConnectionOptions || {};
        // If it's 'null', the user **explicitly** asked for null, don't mess with it.
        if (httpConnectionOptions.logger === undefined) // If our logger is undefined or null, that's OK, the HttpConnection constructor will handle it.
        httpConnectionOptions.logger = this.logger;
        // Now create the connection
        if (!this.url) throw new Error("The 'HubConnectionBuilder.withUrl' method must be called before building the connection.");
        const connection = new (0, $73b6b78c950d1272$export$13c1f9cf8a283575)(this.url, httpConnectionOptions);
        return (0, $abdc410ed994728b$export$e5dbe756ed73e8c8).create(connection, this.logger || (0, $b632327c1843227b$export$17ac58a1138ded46).instance, this.protocol || new (0, $b090a650b4fba31d$export$11f4f8ecec1ad0c8)(), this.reconnectPolicy, this._serverTimeoutInMilliseconds, this._keepAliveIntervalInMilliseconds, this._statefulReconnectBufferSize);
    }
}
function $cccc8edc49e3facc$var$isLogger(logger) {
    return logger.log !== undefined;
}


var $812879cc09ac4815$exports = {};
/*

WebMidi v2.5.3

WebMidi.js helps you tame the Web MIDI API. Send and receive MIDI messages with ease. Control instruments with user-friendly functions (playNote, sendPitchBend, etc.). React to MIDI input with simple event listeners (noteon, pitchbend, controlchange, etc.).
https://github.com/djipco/webmidi


The MIT License (MIT)

Copyright (c) 2015-2019, Jean-Philippe Côté

Permission is hereby granted, free of charge, to any person obtaining a copy of this software and
associated documentation files (the "Software"), to deal in the Software without restriction,
including without limitation the rights to use, copy, modify, merge, publish, distribute,
sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all copies or substantial
portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT
NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES
OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

*/ !function(scope) {
    "use strict";
    function WebMidi() {
        if (WebMidi.prototype._singleton) throw new Error("WebMidi is a singleton, it cannot be instantiated directly.");
        (WebMidi.prototype._singleton = this)._inputs = [], this._outputs = [], this._userHandlers = {}, this._stateChangeQueue = [], this._processingStateChange = !1, this._midiInterfaceEvents = [
            "connected",
            "disconnected"
        ], this._nrpnBuffer = [
            [],
            [],
            [],
            [],
            [],
            [],
            [],
            [],
            [],
            [],
            [],
            [],
            [],
            [],
            [],
            []
        ], this._nrpnEventsEnabled = !0, this._nrpnTypes = [
            "entry",
            "increment",
            "decrement"
        ], this._notes = [
            "C",
            "C#",
            "D",
            "D#",
            "E",
            "F",
            "F#",
            "G",
            "G#",
            "A",
            "A#",
            "B"
        ], this._semitones = {
            C: 0,
            D: 2,
            E: 4,
            F: 5,
            G: 7,
            A: 9,
            B: 11
        }, Object.defineProperties(this, {
            MIDI_SYSTEM_MESSAGES: {
                value: {
                    sysex: 240,
                    timecode: 241,
                    songposition: 242,
                    songselect: 243,
                    tuningrequest: 246,
                    sysexend: 247,
                    clock: 248,
                    start: 250,
                    continue: 251,
                    stop: 252,
                    activesensing: 254,
                    reset: 255,
                    midimessage: 0,
                    unknownsystemmessage: -1
                },
                writable: !1,
                enumerable: !0,
                configurable: !1
            },
            MIDI_CHANNEL_MESSAGES: {
                value: {
                    noteoff: 8,
                    noteon: 9,
                    keyaftertouch: 10,
                    controlchange: 11,
                    channelmode: 11,
                    nrpn: 11,
                    programchange: 12,
                    channelaftertouch: 13,
                    pitchbend: 14
                },
                writable: !1,
                enumerable: !0,
                configurable: !1
            },
            MIDI_REGISTERED_PARAMETER: {
                value: {
                    pitchbendrange: [
                        0,
                        0
                    ],
                    channelfinetuning: [
                        0,
                        1
                    ],
                    channelcoarsetuning: [
                        0,
                        2
                    ],
                    tuningprogram: [
                        0,
                        3
                    ],
                    tuningbank: [
                        0,
                        4
                    ],
                    modulationrange: [
                        0,
                        5
                    ],
                    azimuthangle: [
                        61,
                        0
                    ],
                    elevationangle: [
                        61,
                        1
                    ],
                    gain: [
                        61,
                        2
                    ],
                    distanceratio: [
                        61,
                        3
                    ],
                    maximumdistance: [
                        61,
                        4
                    ],
                    maximumdistancegain: [
                        61,
                        5
                    ],
                    referencedistanceratio: [
                        61,
                        6
                    ],
                    panspreadangle: [
                        61,
                        7
                    ],
                    rollangle: [
                        61,
                        8
                    ]
                },
                writable: !1,
                enumerable: !0,
                configurable: !1
            },
            MIDI_CONTROL_CHANGE_MESSAGES: {
                value: {
                    bankselectcoarse: 0,
                    modulationwheelcoarse: 1,
                    breathcontrollercoarse: 2,
                    footcontrollercoarse: 4,
                    portamentotimecoarse: 5,
                    dataentrycoarse: 6,
                    volumecoarse: 7,
                    balancecoarse: 8,
                    pancoarse: 10,
                    expressioncoarse: 11,
                    effectcontrol1coarse: 12,
                    effectcontrol2coarse: 13,
                    generalpurposeslider1: 16,
                    generalpurposeslider2: 17,
                    generalpurposeslider3: 18,
                    generalpurposeslider4: 19,
                    bankselectfine: 32,
                    modulationwheelfine: 33,
                    breathcontrollerfine: 34,
                    footcontrollerfine: 36,
                    portamentotimefine: 37,
                    dataentryfine: 38,
                    volumefine: 39,
                    balancefine: 40,
                    panfine: 42,
                    expressionfine: 43,
                    effectcontrol1fine: 44,
                    effectcontrol2fine: 45,
                    holdpedal: 64,
                    portamento: 65,
                    sustenutopedal: 66,
                    softpedal: 67,
                    legatopedal: 68,
                    hold2pedal: 69,
                    soundvariation: 70,
                    resonance: 71,
                    soundreleasetime: 72,
                    soundattacktime: 73,
                    brightness: 74,
                    soundcontrol6: 75,
                    soundcontrol7: 76,
                    soundcontrol8: 77,
                    soundcontrol9: 78,
                    soundcontrol10: 79,
                    generalpurposebutton1: 80,
                    generalpurposebutton2: 81,
                    generalpurposebutton3: 82,
                    generalpurposebutton4: 83,
                    reverblevel: 91,
                    tremololevel: 92,
                    choruslevel: 93,
                    celestelevel: 94,
                    phaserlevel: 95,
                    databuttonincrement: 96,
                    databuttondecrement: 97,
                    nonregisteredparametercoarse: 98,
                    nonregisteredparameterfine: 99,
                    registeredparametercoarse: 100,
                    registeredparameterfine: 101
                },
                writable: !1,
                enumerable: !0,
                configurable: !1
            },
            MIDI_NRPN_MESSAGES: {
                value: {
                    entrymsb: 6,
                    entrylsb: 38,
                    increment: 96,
                    decrement: 97,
                    paramlsb: 98,
                    parammsb: 99,
                    nullactiveparameter: 127
                },
                writable: !1,
                enumerable: !0,
                configurable: !1
            },
            MIDI_CHANNEL_MODE_MESSAGES: {
                value: {
                    allsoundoff: 120,
                    resetallcontrollers: 121,
                    localcontrol: 122,
                    allnotesoff: 123,
                    omnimodeoff: 124,
                    omnimodeon: 125,
                    monomodeon: 126,
                    polymodeon: 127
                },
                writable: !1,
                enumerable: !0,
                configurable: !1
            },
            octaveOffset: {
                value: 0,
                writable: !0,
                enumerable: !0,
                configurable: !1
            }
        }), Object.defineProperties(this, {
            supported: {
                enumerable: !0,
                get: function() {
                    return "requestMIDIAccess" in navigator;
                }
            },
            enabled: {
                enumerable: !0,
                get: (function() {
                    return void 0 !== this.interface;
                }).bind(this)
            },
            inputs: {
                enumerable: !0,
                get: (function() {
                    return this._inputs;
                }).bind(this)
            },
            outputs: {
                enumerable: !0,
                get: (function() {
                    return this._outputs;
                }).bind(this)
            },
            sysexEnabled: {
                enumerable: !0,
                get: (function() {
                    return !(!this.interface || !this.interface.sysexEnabled);
                }).bind(this)
            },
            nrpnEventsEnabled: {
                enumerable: !0,
                get: (function() {
                    return !!this._nrpnEventsEnabled;
                }).bind(this),
                set: function(enabled) {
                    return this._nrpnEventsEnabled = enabled, this._nrpnEventsEnabled;
                }
            },
            nrpnTypes: {
                enumerable: !0,
                get: (function() {
                    return this._nrpnTypes;
                }).bind(this)
            },
            time: {
                enumerable: !0,
                get: function() {
                    return performance.now();
                }
            }
        });
    }
    var wm = new WebMidi;
    function Input(midiInput) {
        var that = this;
        this._userHandlers = {
            channel: {},
            system: {}
        }, this._midiInput = midiInput, Object.defineProperties(this, {
            connection: {
                enumerable: !0,
                get: function() {
                    return that._midiInput.connection;
                }
            },
            id: {
                enumerable: !0,
                get: function() {
                    return that._midiInput.id;
                }
            },
            manufacturer: {
                enumerable: !0,
                get: function() {
                    return that._midiInput.manufacturer;
                }
            },
            name: {
                enumerable: !0,
                get: function() {
                    return that._midiInput.name;
                }
            },
            state: {
                enumerable: !0,
                get: function() {
                    return that._midiInput.state;
                }
            },
            type: {
                enumerable: !0,
                get: function() {
                    return that._midiInput.type;
                }
            }
        }), this._initializeUserHandlers(), this._midiInput.onmidimessage = this._onMidiMessage.bind(this);
    }
    function Output(midiOutput) {
        var that = this;
        this._midiOutput = midiOutput, Object.defineProperties(this, {
            connection: {
                enumerable: !0,
                get: function() {
                    return that._midiOutput.connection;
                }
            },
            id: {
                enumerable: !0,
                get: function() {
                    return that._midiOutput.id;
                }
            },
            manufacturer: {
                enumerable: !0,
                get: function() {
                    return that._midiOutput.manufacturer;
                }
            },
            name: {
                enumerable: !0,
                get: function() {
                    return that._midiOutput.name;
                }
            },
            state: {
                enumerable: !0,
                get: function() {
                    return that._midiOutput.state;
                }
            },
            type: {
                enumerable: !0,
                get: function() {
                    return that._midiOutput.type;
                }
            }
        });
    }
    WebMidi.prototype.enable = function(callback, sysex) {
        this.enabled || (this.supported ? navigator.requestMIDIAccess({
            sysex: sysex
        }).then((function(midiAccess) {
            var promiseTimeout, events = [], promises = [];
            this.interface = midiAccess, this._resetInterfaceUserHandlers(), this.interface.onstatechange = function(e) {
                events.push(e);
            };
            for(var inputs = midiAccess.inputs.values(), input = inputs.next(); input && !input.done; input = inputs.next())promises.push(input.value.open());
            for(var outputs = midiAccess.outputs.values(), output = outputs.next(); output && !output.done; output = outputs.next())promises.push(output.value.open());
            function onPortsOpen() {
                clearTimeout(promiseTimeout), this._updateInputsAndOutputs(), this.interface.onstatechange = this._onInterfaceStateChange.bind(this), "function" == typeof callback && callback.call(this), events.forEach((function(event) {
                    this._onInterfaceStateChange(event);
                }).bind(this));
            }
            promiseTimeout = setTimeout(onPortsOpen.bind(this), 200), Promise && Promise.all(promises).catch(function(err) {}).then(onPortsOpen.bind(this));
        }).bind(this), (function(err) {
            "function" == typeof callback && callback.call(this, err);
        }).bind(this)) : "function" == typeof callback && callback(new Error("The Web MIDI API is not supported by your browser.")));
    }, WebMidi.prototype.disable = function() {
        if (!this.supported) throw new Error("The Web MIDI API is not supported by your browser.");
        this.enabled && (this.removeListener(), this.inputs.forEach(function(input) {
            input.removeListener();
        })), this.interface && (this.interface.onstatechange = void 0), this.interface = void 0, this._inputs = [], this._outputs = [], this._nrpnEventsEnabled = !0, this._resetInterfaceUserHandlers();
    }, WebMidi.prototype.addListener = function(type, listener) {
        if (!this.enabled) throw new Error("WebMidi must be enabled before adding event listeners.");
        if ("function" != typeof listener) throw new TypeError("The 'listener' parameter must be a function.");
        if (!(0 <= this._midiInterfaceEvents.indexOf(type))) throw new TypeError("The specified event type is not supported.");
        return this._userHandlers[type].push(listener), this;
    }, WebMidi.prototype.hasListener = function(type, listener) {
        if (!this.enabled) throw new Error("WebMidi must be enabled before checking event listeners.");
        if ("function" != typeof listener) throw new TypeError("The 'listener' parameter must be a function.");
        if (!(0 <= this._midiInterfaceEvents.indexOf(type))) throw new TypeError("The specified event type is not supported.");
        for(var o = 0; o < this._userHandlers[type].length; o++)if (this._userHandlers[type][o] === listener) return !0;
        return !1;
    }, WebMidi.prototype.removeListener = function(type, listener) {
        if (!this.enabled) throw new Error("WebMidi must be enabled before removing event listeners.");
        if (void 0 !== listener && "function" != typeof listener) throw new TypeError("The 'listener' parameter must be a function.");
        if (0 <= this._midiInterfaceEvents.indexOf(type)) {
            if (listener) for(var o = 0; o < this._userHandlers[type].length; o++)this._userHandlers[type][o] === listener && this._userHandlers[type].splice(o, 1);
            else this._userHandlers[type] = [];
        } else {
            if (void 0 !== type) throw new TypeError("The specified event type is not supported.");
            this._resetInterfaceUserHandlers();
        }
        return this;
    }, WebMidi.prototype.toMIDIChannels = function(channel) {
        var channels;
        if ("all" === channel || void 0 === channel) channels = [
            "all"
        ];
        else {
            if ("none" === channel) return channels = [];
            channels = Array.isArray(channel) ? channel : [
                channel
            ];
        }
        return -1 < channels.indexOf("all") && (channels = [
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11,
            12,
            13,
            14,
            15,
            16
        ]), channels.map(function(ch) {
            return parseInt(ch);
        }).filter(function(ch) {
            return 1 <= ch && ch <= 16;
        });
    }, WebMidi.prototype.getInputById = function(id) {
        if (!this.enabled) throw new Error("WebMidi is not enabled.");
        id = String(id);
        for(var i = 0; i < this.inputs.length; i++)if (this.inputs[i].id === id) return this.inputs[i];
        return !1;
    }, WebMidi.prototype.getOutputById = function(id) {
        if (!this.enabled) throw new Error("WebMidi is not enabled.");
        id = String(id);
        for(var i = 0; i < this.outputs.length; i++)if (this.outputs[i].id === id) return this.outputs[i];
        return !1;
    }, WebMidi.prototype.getInputByName = function(name) {
        if (!this.enabled) throw new Error("WebMidi is not enabled.");
        for(var i = 0; i < this.inputs.length; i++)if (~this.inputs[i].name.indexOf(name)) return this.inputs[i];
        return !1;
    }, WebMidi.prototype.getOctave = function(number) {
        if (null != number && 0 <= number && number <= 127) return Math.floor(Math.floor(number) / 12 - 1) + Math.floor(wm.octaveOffset);
    }, WebMidi.prototype.getOutputByName = function(name) {
        if (!this.enabled) throw new Error("WebMidi is not enabled.");
        for(var i = 0; i < this.outputs.length; i++)if (~this.outputs[i].name.indexOf(name)) return this.outputs[i];
        return !1;
    }, WebMidi.prototype.guessNoteNumber = function(input) {
        var output = !1;
        if (input && input.toFixed && 0 <= input && input <= 127 ? output = Math.round(input) : 0 <= parseInt(input) && parseInt(input) <= 127 ? output = parseInt(input) : ("string" == typeof input || input instanceof String) && (output = this.noteNameToNumber(input)), !1 === output) throw new Error("Invalid input value (" + input + ").");
        return output;
    }, WebMidi.prototype.noteNameToNumber = function(name) {
        "string" != typeof name && (name = "");
        var matches = name.match(/([CDEFGAB])(#{0,2}|b{0,2})(-?\d+)/i);
        if (!matches) throw new RangeError("Invalid note name.");
        var semitones = wm._semitones[matches[1].toUpperCase()], result = 12 * (parseInt(matches[3]) + 1 - Math.floor(wm.octaveOffset)) + semitones;
        if (-1 < matches[2].toLowerCase().indexOf("b") ? result -= matches[2].length : -1 < matches[2].toLowerCase().indexOf("#") && (result += matches[2].length), result < 0 || 127 < result) throw new RangeError("Invalid note name or note outside valid range.");
        return result;
    }, WebMidi.prototype._updateInputsAndOutputs = function() {
        this._updateInputs(), this._updateOutputs();
    }, WebMidi.prototype._updateInputs = function() {
        for(var i = 0; i < this._inputs.length; i++){
            for(var remove = !0, updated = this.interface.inputs.values(), input = updated.next(); input && !input.done; input = updated.next())if (this._inputs[i]._midiInput === input.value) {
                remove = !1;
                break;
            }
            remove && this._inputs.splice(i, 1);
        }
        this.interface && this.interface.inputs.forEach((function(nInput) {
            for(var add = !0, j = 0; j < this._inputs.length; j++)this._inputs[j]._midiInput === nInput && (add = !1);
            add && this._inputs.push(new Input(nInput));
        }).bind(this));
    }, WebMidi.prototype._updateOutputs = function() {
        for(var i = 0; i < this._outputs.length; i++){
            for(var remove = !0, updated = this.interface.outputs.values(), output = updated.next(); output && !output.done; output = updated.next())if (this._outputs[i]._midiOutput === output.value) {
                remove = !1;
                break;
            }
            remove && this._outputs.splice(i, 1);
        }
        this.interface && this.interface.outputs.forEach((function(nOutput) {
            for(var add = !0, j = 0; j < this._outputs.length; j++)this._outputs[j]._midiOutput === nOutput && (add = !1);
            add && this._outputs.push(new Output(nOutput));
        }).bind(this));
    }, WebMidi.prototype._onInterfaceStateChange = function(e) {
        this._updateInputsAndOutputs();
        var event = {
            timestamp: e.timeStamp,
            type: e.port.state
        };
        this.interface && "connected" === e.port.state ? "output" === e.port.type ? event.port = this.getOutputById(e.port.id) : "input" === e.port.type && (event.port = this.getInputById(e.port.id)) : event.port = {
            connection: "closed",
            id: e.port.id,
            manufacturer: e.port.manufacturer,
            name: e.port.name,
            state: e.port.state,
            type: e.port.type
        }, this._userHandlers[e.port.state].forEach(function(handler) {
            handler(event);
        });
    }, WebMidi.prototype._resetInterfaceUserHandlers = function() {
        for(var i = 0; i < this._midiInterfaceEvents.length; i++)this._userHandlers[this._midiInterfaceEvents[i]] = [];
    }, Input.prototype.on = Input.prototype.addListener = function(type, channel, listener) {
        var that = this;
        if (void 0 === channel && (channel = "all"), Array.isArray(channel) || (channel = [
            channel
        ]), channel.forEach(function(item) {
            if ("all" !== item && !(1 <= item && item <= 16)) throw new RangeError("The 'channel' parameter is invalid.");
        }), "function" != typeof listener) throw new TypeError("The 'listener' parameter must be a function.");
        if (void 0 !== wm.MIDI_SYSTEM_MESSAGES[type]) this._userHandlers.system[type] || (this._userHandlers.system[type] = []), this._userHandlers.system[type].push(listener);
        else {
            if (void 0 === wm.MIDI_CHANNEL_MESSAGES[type]) throw new TypeError("The specified event type is not supported.");
            if (-1 < channel.indexOf("all")) {
                channel = [];
                for(var j = 1; j <= 16; j++)channel.push(j);
            }
            this._userHandlers.channel[type] || (this._userHandlers.channel[type] = []), channel.forEach(function(ch) {
                that._userHandlers.channel[type][ch] || (that._userHandlers.channel[type][ch] = []), that._userHandlers.channel[type][ch].push(listener);
            });
        }
        return this;
    }, Input.prototype.hasListener = function(type, channel, listener) {
        var that = this;
        if ("function" != typeof listener) throw new TypeError("The 'listener' parameter must be a function.");
        if (void 0 === channel && (channel = "all"), channel.constructor !== Array && (channel = [
            channel
        ]), void 0 !== wm.MIDI_SYSTEM_MESSAGES[type]) {
            for(var o = 0; o < this._userHandlers.system[type].length; o++)if (this._userHandlers.system[type][o] === listener) return !0;
        } else if (void 0 !== wm.MIDI_CHANNEL_MESSAGES[type]) {
            if (-1 < channel.indexOf("all")) {
                channel = [];
                for(var j = 1; j <= 16; j++)channel.push(j);
            }
            return !!this._userHandlers.channel[type] && channel.every(function(chNum) {
                var listeners = that._userHandlers.channel[type][chNum];
                return listeners && -1 < listeners.indexOf(listener);
            });
        }
        return !1;
    }, Input.prototype.removeListener = function(type, channel, listener) {
        var that = this;
        if (void 0 !== listener && "function" != typeof listener) throw new TypeError("The 'listener' parameter must be a function.");
        if (void 0 === channel && (channel = "all"), channel.constructor !== Array && (channel = [
            channel
        ]), void 0 !== wm.MIDI_SYSTEM_MESSAGES[type]) {
            if (void 0 === listener) this._userHandlers.system[type] = [];
            else for(var o = 0; o < this._userHandlers.system[type].length; o++)this._userHandlers.system[type][o] === listener && this._userHandlers.system[type].splice(o, 1);
        } else if (void 0 !== wm.MIDI_CHANNEL_MESSAGES[type]) {
            if (-1 < channel.indexOf("all")) {
                channel = [];
                for(var j = 1; j <= 16; j++)channel.push(j);
            }
            if (!this._userHandlers.channel[type]) return this;
            channel.forEach(function(chNum) {
                var listeners = that._userHandlers.channel[type][chNum];
                if (listeners) {
                    if (void 0 === listener) that._userHandlers.channel[type][chNum] = [];
                    else for(var l = 0; l < listeners.length; l++)listeners[l] === listener && listeners.splice(l, 1);
                }
            });
        } else {
            if (void 0 !== type) throw new TypeError("The specified event type is not supported.");
            this._initializeUserHandlers();
        }
        return this;
    }, Input.prototype._initializeUserHandlers = function() {
        for(var prop1 in wm.MIDI_CHANNEL_MESSAGES)Object.prototype.hasOwnProperty.call(wm.MIDI_CHANNEL_MESSAGES, prop1) && (this._userHandlers.channel[prop1] = {});
        for(var prop2 in wm.MIDI_SYSTEM_MESSAGES)Object.prototype.hasOwnProperty.call(wm.MIDI_SYSTEM_MESSAGES, prop2) && (this._userHandlers.system[prop2] = []);
    }, Input.prototype._onMidiMessage = function(e) {
        if (0 < this._userHandlers.system.midimessage.length) {
            var event = {
                target: this,
                data: e.data,
                timestamp: e.timeStamp,
                type: "midimessage"
            };
            this._userHandlers.system.midimessage.forEach(function(callback) {
                callback(event);
            });
        }
        e.data[0] < 240 ? (this._parseChannelEvent(e), this._parseNrpnEvent(e)) : e.data[0] <= 255 && this._parseSystemEvent(e);
    }, Input.prototype._parseNrpnEvent = function(e) {
        var data1, data2, command = e.data[0] >> 4, channelBufferIndex = 15 & e.data[0], channel = 1 + channelBufferIndex;
        if (1 < e.data.length && (data1 = e.data[1], data2 = 2 < e.data.length ? e.data[2] : void 0), wm.nrpnEventsEnabled && command === wm.MIDI_CHANNEL_MESSAGES.controlchange && (data1 >= wm.MIDI_NRPN_MESSAGES.increment && data1 <= wm.MIDI_NRPN_MESSAGES.parammsb || data1 === wm.MIDI_NRPN_MESSAGES.entrymsb || data1 === wm.MIDI_NRPN_MESSAGES.entrylsb)) {
            var ccEvent = {
                target: this,
                type: "controlchange",
                data: e.data,
                timestamp: e.timeStamp,
                channel: channel,
                controller: {
                    number: data1,
                    name: this.getCcNameByNumber(data1)
                },
                value: data2
            };
            if (ccEvent.controller.number === wm.MIDI_NRPN_MESSAGES.parammsb && ccEvent.value != wm.MIDI_NRPN_MESSAGES.nullactiveparameter) wm._nrpnBuffer[channelBufferIndex] = [], wm._nrpnBuffer[channelBufferIndex][0] = ccEvent;
            else if (1 === wm._nrpnBuffer[channelBufferIndex].length && ccEvent.controller.number === wm.MIDI_NRPN_MESSAGES.paramlsb) wm._nrpnBuffer[channelBufferIndex].push(ccEvent);
            else if (2 !== wm._nrpnBuffer[channelBufferIndex].length || ccEvent.controller.number !== wm.MIDI_NRPN_MESSAGES.increment && ccEvent.controller.number !== wm.MIDI_NRPN_MESSAGES.decrement && ccEvent.controller.number !== wm.MIDI_NRPN_MESSAGES.entrymsb) {
                if (3 === wm._nrpnBuffer[channelBufferIndex].length && wm._nrpnBuffer[channelBufferIndex][2].number === wm.MIDI_NRPN_MESSAGES.entrymsb && ccEvent.controller.number === wm.MIDI_NRPN_MESSAGES.entrylsb) wm._nrpnBuffer[channelBufferIndex].push(ccEvent);
                else if (3 <= wm._nrpnBuffer[channelBufferIndex].length && wm._nrpnBuffer[channelBufferIndex].length <= 4 && ccEvent.controller.number === wm.MIDI_NRPN_MESSAGES.parammsb && ccEvent.value === wm.MIDI_NRPN_MESSAGES.nullactiveparameter) wm._nrpnBuffer[channelBufferIndex].push(ccEvent);
                else if (4 <= wm._nrpnBuffer[channelBufferIndex].length && wm._nrpnBuffer[channelBufferIndex].length <= 5 && ccEvent.controller.number === wm.MIDI_NRPN_MESSAGES.paramlsb && ccEvent.value === wm.MIDI_NRPN_MESSAGES.nullactiveparameter) {
                    wm._nrpnBuffer[channelBufferIndex].push(ccEvent);
                    var rawData = [];
                    wm._nrpnBuffer[channelBufferIndex].forEach(function(ev) {
                        rawData.push(ev.data);
                    });
                    var nrpnNumber = wm._nrpnBuffer[channelBufferIndex][0].value << 7 | wm._nrpnBuffer[channelBufferIndex][1].value, nrpnValue = wm._nrpnBuffer[channelBufferIndex][2].value;
                    6 === wm._nrpnBuffer[channelBufferIndex].length && (nrpnValue = wm._nrpnBuffer[channelBufferIndex][2].value << 7 | wm._nrpnBuffer[channelBufferIndex][3].value);
                    var nrpnControllerType = "";
                    switch(wm._nrpnBuffer[channelBufferIndex][2].controller.number){
                        case wm.MIDI_NRPN_MESSAGES.entrymsb:
                            nrpnControllerType = wm._nrpnTypes[0];
                            break;
                        case wm.MIDI_NRPN_MESSAGES.increment:
                            nrpnControllerType = wm._nrpnTypes[1];
                            break;
                        case wm.MIDI_NRPN_MESSAGES.decrement:
                            nrpnControllerType = wm._nrpnTypes[2];
                            break;
                        default:
                            throw new Error("The NPRN type was unidentifiable.");
                    }
                    var nrpnEvent = {
                        timestamp: ccEvent.timestamp,
                        channel: ccEvent.channel,
                        type: "nrpn",
                        data: rawData,
                        controller: {
                            number: nrpnNumber,
                            type: nrpnControllerType,
                            name: "Non-Registered Parameter " + nrpnNumber
                        },
                        value: nrpnValue
                    };
                    wm._nrpnBuffer[channelBufferIndex] = [], this._userHandlers.channel[nrpnEvent.type] && this._userHandlers.channel[nrpnEvent.type][nrpnEvent.channel] && this._userHandlers.channel[nrpnEvent.type][nrpnEvent.channel].forEach(function(callback) {
                        callback(nrpnEvent);
                    });
                } else wm._nrpnBuffer[channelBufferIndex] = [];
            } else wm._nrpnBuffer[channelBufferIndex].push(ccEvent);
        }
    }, Input.prototype._parseChannelEvent = function(e) {
        var data1, data2, command = e.data[0] >> 4, channel = 1 + (15 & e.data[0]);
        1 < e.data.length && (data1 = e.data[1], data2 = 2 < e.data.length ? e.data[2] : void 0);
        var event = {
            target: this,
            data: e.data,
            timestamp: e.timeStamp,
            channel: channel
        };
        command === wm.MIDI_CHANNEL_MESSAGES.noteoff || command === wm.MIDI_CHANNEL_MESSAGES.noteon && 0 === data2 ? (event.type = "noteoff", event.note = {
            number: data1,
            name: wm._notes[data1 % 12],
            octave: wm.getOctave(data1)
        }, event.velocity = data2 / 127, event.rawVelocity = data2) : command === wm.MIDI_CHANNEL_MESSAGES.noteon ? (event.type = "noteon", event.note = {
            number: data1,
            name: wm._notes[data1 % 12],
            octave: wm.getOctave(data1)
        }, event.velocity = data2 / 127, event.rawVelocity = data2) : command === wm.MIDI_CHANNEL_MESSAGES.keyaftertouch ? (event.type = "keyaftertouch", event.note = {
            number: data1,
            name: wm._notes[data1 % 12],
            octave: wm.getOctave(data1)
        }, event.value = data2 / 127) : command === wm.MIDI_CHANNEL_MESSAGES.controlchange && 0 <= data1 && data1 <= 119 ? (event.type = "controlchange", event.controller = {
            number: data1,
            name: this.getCcNameByNumber(data1)
        }, event.value = data2) : command === wm.MIDI_CHANNEL_MESSAGES.channelmode && 120 <= data1 && data1 <= 127 ? (event.type = "channelmode", event.controller = {
            number: data1,
            name: this.getChannelModeByNumber(data1)
        }, event.value = data2) : command === wm.MIDI_CHANNEL_MESSAGES.programchange ? (event.type = "programchange", event.value = data1) : command === wm.MIDI_CHANNEL_MESSAGES.channelaftertouch ? (event.type = "channelaftertouch", event.value = data1 / 127) : command === wm.MIDI_CHANNEL_MESSAGES.pitchbend ? (event.type = "pitchbend", event.value = ((data2 << 7) + data1 - 8192) / 8192) : event.type = "unknownchannelmessage", this._userHandlers.channel[event.type] && this._userHandlers.channel[event.type][channel] && this._userHandlers.channel[event.type][channel].forEach(function(callback) {
            callback(event);
        });
    }, Input.prototype.getCcNameByNumber = function(number) {
        if (!(0 <= (number = Math.floor(number)) && number <= 119)) throw new RangeError("The control change number must be between 0 and 119.");
        for(var cc in wm.MIDI_CONTROL_CHANGE_MESSAGES)if (Object.prototype.hasOwnProperty.call(wm.MIDI_CONTROL_CHANGE_MESSAGES, cc) && number === wm.MIDI_CONTROL_CHANGE_MESSAGES[cc]) return cc;
    }, Input.prototype.getChannelModeByNumber = function(number) {
        if (!(120 <= (number = Math.floor(number)) && status <= 127)) throw new RangeError("The control change number must be between 120 and 127.");
        for(var cm in wm.MIDI_CHANNEL_MODE_MESSAGES)if (Object.prototype.hasOwnProperty.call(wm.MIDI_CHANNEL_MODE_MESSAGES, cm) && number === wm.MIDI_CHANNEL_MODE_MESSAGES[cm]) return cm;
    }, Input.prototype._parseSystemEvent = function(e) {
        var command = e.data[0], event = {
            target: this,
            data: e.data,
            timestamp: e.timeStamp
        };
        command === wm.MIDI_SYSTEM_MESSAGES.sysex ? event.type = "sysex" : command === wm.MIDI_SYSTEM_MESSAGES.timecode ? event.type = "timecode" : command === wm.MIDI_SYSTEM_MESSAGES.songposition ? event.type = "songposition" : command === wm.MIDI_SYSTEM_MESSAGES.songselect ? (event.type = "songselect", event.song = e.data[1]) : command === wm.MIDI_SYSTEM_MESSAGES.tuningrequest ? event.type = "tuningrequest" : command === wm.MIDI_SYSTEM_MESSAGES.clock ? event.type = "clock" : command === wm.MIDI_SYSTEM_MESSAGES.start ? event.type = "start" : command === wm.MIDI_SYSTEM_MESSAGES.continue ? event.type = "continue" : command === wm.MIDI_SYSTEM_MESSAGES.stop ? event.type = "stop" : command === wm.MIDI_SYSTEM_MESSAGES.activesensing ? event.type = "activesensing" : command === wm.MIDI_SYSTEM_MESSAGES.reset ? event.type = "reset" : event.type = "unknownsystemmessage", this._userHandlers.system[event.type] && this._userHandlers.system[event.type].forEach(function(callback) {
            callback(event);
        });
    }, Output.prototype.send = function(status1, data, timestamp) {
        if (!(128 <= status1 && status1 <= 255)) throw new RangeError("The status byte must be an integer between 128 (0x80) and 255 (0xFF).");
        void 0 === data && (data = []), Array.isArray(data) || (data = [
            data
        ]);
        var message = [];
        return data.forEach(function(item) {
            var parsed = Math.floor(item);
            if (!(0 <= parsed && parsed <= 255)) throw new RangeError("Data bytes must be integers between 0 (0x00) and 255 (0xFF).");
            message.push(parsed);
        }), this._midiOutput.send([
            status1
        ].concat(message), parseFloat(timestamp) || 0), this;
    }, Output.prototype.sendSysex = function(manufacturer, data, options) {
        if (!wm.sysexEnabled) throw new Error("Sysex message support must first be activated.");
        return options = options || {}, manufacturer = [].concat(manufacturer), data.forEach(function(item) {
            if (item < 0 || 127 < item) throw new RangeError("The data bytes of a sysex message must be integers between 0 (0x00) and 127 (0x7F).");
        }), data = manufacturer.concat(data, wm.MIDI_SYSTEM_MESSAGES.sysexend), this.send(wm.MIDI_SYSTEM_MESSAGES.sysex, data, this._parseTimeParameter(options.time)), this;
    }, Output.prototype.sendTimecodeQuarterFrame = function(value, options) {
        return options = options || {}, this.send(wm.MIDI_SYSTEM_MESSAGES.timecode, value, this._parseTimeParameter(options.time)), this;
    }, Output.prototype.sendSongPosition = function(value, options) {
        options = options || {};
        var msb = (value = Math.floor(value) || 0) >> 7 & 127, lsb = 127 & value;
        return this.send(wm.MIDI_SYSTEM_MESSAGES.songposition, [
            msb,
            lsb
        ], this._parseTimeParameter(options.time)), this;
    }, Output.prototype.sendSongSelect = function(value, options) {
        if (options = options || {}, !(0 <= (value = Math.floor(value)) && value <= 127)) throw new RangeError("The song number must be between 0 and 127.");
        return this.send(wm.MIDI_SYSTEM_MESSAGES.songselect, [
            value
        ], this._parseTimeParameter(options.time)), this;
    }, Output.prototype.sendTuningRequest = function(options) {
        return options = options || {}, this.send(wm.MIDI_SYSTEM_MESSAGES.tuningrequest, void 0, this._parseTimeParameter(options.time)), this;
    }, Output.prototype.sendClock = function(options) {
        return options = options || {}, this.send(wm.MIDI_SYSTEM_MESSAGES.clock, void 0, this._parseTimeParameter(options.time)), this;
    }, Output.prototype.sendStart = function(options) {
        return options = options || {}, this.send(wm.MIDI_SYSTEM_MESSAGES.start, void 0, this._parseTimeParameter(options.time)), this;
    }, Output.prototype.sendContinue = function(options) {
        return options = options || {}, this.send(wm.MIDI_SYSTEM_MESSAGES.continue, void 0, this._parseTimeParameter(options.time)), this;
    }, Output.prototype.sendStop = function(options) {
        return options = options || {}, this.send(wm.MIDI_SYSTEM_MESSAGES.stop, void 0, this._parseTimeParameter(options.time)), this;
    }, Output.prototype.sendActiveSensing = function(options) {
        return options = options || {}, this.send(wm.MIDI_SYSTEM_MESSAGES.activesensing, [], this._parseTimeParameter(options.time)), this;
    }, Output.prototype.sendReset = function(options) {
        return options = options || {}, this.send(wm.MIDI_SYSTEM_MESSAGES.reset, void 0, this._parseTimeParameter(options.time)), this;
    }, Output.prototype.stopNote = function(note, channel, options) {
        if ("all" === note) return this.sendChannelMode("allnotesoff", 0, channel, options);
        var nVelocity = 64;
        return (options = options || {}).rawVelocity ? !isNaN(options.velocity) && 0 <= options.velocity && options.velocity <= 127 && (nVelocity = options.velocity) : !isNaN(options.velocity) && 0 <= options.velocity && options.velocity <= 1 && (nVelocity = 127 * options.velocity), this._convertNoteToArray(note).forEach((function(item) {
            wm.toMIDIChannels(channel).forEach((function(ch) {
                this.send((wm.MIDI_CHANNEL_MESSAGES.noteoff << 4) + (ch - 1), [
                    item,
                    Math.round(nVelocity)
                ], this._parseTimeParameter(options.time));
            }).bind(this));
        }).bind(this)), this;
    }, Output.prototype.playNote = function(note, channel, options) {
        var time, nVelocity = 64;
        if ((options = options || {}).rawVelocity ? !isNaN(options.velocity) && 0 <= options.velocity && options.velocity <= 127 && (nVelocity = options.velocity) : !isNaN(options.velocity) && 0 <= options.velocity && options.velocity <= 1 && (nVelocity = 127 * options.velocity), time = this._parseTimeParameter(options.time), this._convertNoteToArray(note).forEach((function(item) {
            wm.toMIDIChannels(channel).forEach((function(ch) {
                this.send((wm.MIDI_CHANNEL_MESSAGES.noteon << 4) + (ch - 1), [
                    item,
                    Math.round(nVelocity)
                ], time);
            }).bind(this));
        }).bind(this)), !isNaN(options.duration)) {
            options.duration <= 0 && (options.duration = 0);
            var nRelease = 64;
            options.rawVelocity ? !isNaN(options.release) && 0 <= options.release && options.release <= 127 && (nRelease = options.release) : !isNaN(options.release) && 0 <= options.release && options.release <= 1 && (nRelease = 127 * options.release), this._convertNoteToArray(note).forEach((function(item) {
                wm.toMIDIChannels(channel).forEach((function(ch) {
                    this.send((wm.MIDI_CHANNEL_MESSAGES.noteoff << 4) + (ch - 1), [
                        item,
                        Math.round(nRelease)
                    ], (time || wm.time) + options.duration);
                }).bind(this));
            }).bind(this));
        }
        return this;
    }, Output.prototype.sendKeyAftertouch = function(note, channel, pressure, options) {
        var that = this;
        if (options = options || {}, channel < 1 || 16 < channel) throw new RangeError("The channel must be between 1 and 16.");
        (isNaN(pressure) || pressure < 0 || 1 < pressure) && (pressure = .5);
        var nPressure = Math.round(127 * pressure);
        return this._convertNoteToArray(note).forEach(function(item) {
            wm.toMIDIChannels(channel).forEach(function(ch) {
                that.send((wm.MIDI_CHANNEL_MESSAGES.keyaftertouch << 4) + (ch - 1), [
                    item,
                    nPressure
                ], that._parseTimeParameter(options.time));
            });
        }), this;
    }, Output.prototype.sendControlChange = function(controller, value, channel, options) {
        if (options = options || {}, "string" == typeof controller) {
            if (void 0 === (controller = wm.MIDI_CONTROL_CHANGE_MESSAGES[controller])) throw new TypeError("Invalid controller name.");
        } else if (!(0 <= (controller = Math.floor(controller)) && controller <= 119)) throw new RangeError("Controller numbers must be between 0 and 119.");
        if (!(0 <= (value = Math.floor(value) || 0) && value <= 127)) throw new RangeError("Controller value must be between 0 and 127.");
        return wm.toMIDIChannels(channel).forEach((function(ch) {
            this.send((wm.MIDI_CHANNEL_MESSAGES.controlchange << 4) + (ch - 1), [
                controller,
                value
            ], this._parseTimeParameter(options.time));
        }).bind(this)), this;
    }, Output.prototype._selectRegisteredParameter = function(parameter, channel, time) {
        var that = this;
        if (parameter[0] = Math.floor(parameter[0]), !(0 <= parameter[0] && parameter[0] <= 127)) throw new RangeError("The control65 value must be between 0 and 127");
        if (parameter[1] = Math.floor(parameter[1]), !(0 <= parameter[1] && parameter[1] <= 127)) throw new RangeError("The control64 value must be between 0 and 127");
        return wm.toMIDIChannels(channel).forEach(function() {
            that.sendControlChange(101, parameter[0], channel, {
                time: time
            }), that.sendControlChange(100, parameter[1], channel, {
                time: time
            });
        }), this;
    }, Output.prototype._selectNonRegisteredParameter = function(parameter, channel, time) {
        var that = this;
        if (parameter[0] = Math.floor(parameter[0]), !(0 <= parameter[0] && parameter[0] <= 127)) throw new RangeError("The control63 value must be between 0 and 127");
        if (parameter[1] = Math.floor(parameter[1]), !(0 <= parameter[1] && parameter[1] <= 127)) throw new RangeError("The control62 value must be between 0 and 127");
        return wm.toMIDIChannels(channel).forEach(function() {
            that.sendControlChange(99, parameter[0], channel, {
                time: time
            }), that.sendControlChange(98, parameter[1], channel, {
                time: time
            });
        }), this;
    }, Output.prototype._setCurrentRegisteredParameter = function(data, channel, time) {
        var that = this;
        if ((data = [].concat(data))[0] = Math.floor(data[0]), !(0 <= data[0] && data[0] <= 127)) throw new RangeError("The msb value must be between 0 and 127");
        return wm.toMIDIChannels(channel).forEach(function() {
            that.sendControlChange(6, data[0], channel, {
                time: time
            });
        }), data[1] = Math.floor(data[1]), 0 <= data[1] && data[1] <= 127 && wm.toMIDIChannels(channel).forEach(function() {
            that.sendControlChange(38, data[1], channel, {
                time: time
            });
        }), this;
    }, Output.prototype._deselectRegisteredParameter = function(channel, time) {
        var that = this;
        return wm.toMIDIChannels(channel).forEach(function() {
            that.sendControlChange(101, 127, channel, {
                time: time
            }), that.sendControlChange(100, 127, channel, {
                time: time
            });
        }), this;
    }, Output.prototype.setRegisteredParameter = function(parameter, data, channel, options) {
        var that = this;
        if (options = options || {}, !Array.isArray(parameter)) {
            if (!wm.MIDI_REGISTERED_PARAMETER[parameter]) throw new Error("The specified parameter is not available.");
            parameter = wm.MIDI_REGISTERED_PARAMETER[parameter];
        }
        return wm.toMIDIChannels(channel).forEach(function() {
            that._selectRegisteredParameter(parameter, channel, options.time), that._setCurrentRegisteredParameter(data, channel, options.time), that._deselectRegisteredParameter(channel, options.time);
        }), this;
    }, Output.prototype.setNonRegisteredParameter = function(parameter, data, channel, options) {
        var that = this;
        if (options = options || {}, !(0 <= parameter[0] && parameter[0] <= 127 && 0 <= parameter[1] && parameter[1] <= 127)) throw new Error("Position 0 and 1 of the 2-position parameter array must both be between 0 and 127.");
        return data = [].concat(data), wm.toMIDIChannels(channel).forEach(function() {
            that._selectNonRegisteredParameter(parameter, channel, options.time), that._setCurrentRegisteredParameter(data, channel, options.time), that._deselectRegisteredParameter(channel, options.time);
        }), this;
    }, Output.prototype.incrementRegisteredParameter = function(parameter, channel, options) {
        var that = this;
        if (options = options || {}, !Array.isArray(parameter)) {
            if (!wm.MIDI_REGISTERED_PARAMETER[parameter]) throw new Error("The specified parameter is not available.");
            parameter = wm.MIDI_REGISTERED_PARAMETER[parameter];
        }
        return wm.toMIDIChannels(channel).forEach(function() {
            that._selectRegisteredParameter(parameter, channel, options.time), that.sendControlChange(96, 0, channel, {
                time: options.time
            }), that._deselectRegisteredParameter(channel, options.time);
        }), this;
    }, Output.prototype.decrementRegisteredParameter = function(parameter, channel, options) {
        if (options = options || {}, !Array.isArray(parameter)) {
            if (!wm.MIDI_REGISTERED_PARAMETER[parameter]) throw new TypeError("The specified parameter is not available.");
            parameter = wm.MIDI_REGISTERED_PARAMETER[parameter];
        }
        return wm.toMIDIChannels(channel).forEach((function() {
            this._selectRegisteredParameter(parameter, channel, options.time), this.sendControlChange(97, 0, channel, {
                time: options.time
            }), this._deselectRegisteredParameter(channel, options.time);
        }).bind(this)), this;
    }, Output.prototype.setPitchBendRange = function(semitones, cents, channel, options) {
        var that = this;
        if (options = options || {}, !(0 <= (semitones = Math.floor(semitones) || 0) && semitones <= 127)) throw new RangeError("The semitones value must be between 0 and 127");
        if (!(0 <= (cents = Math.floor(cents) || 0) && cents <= 127)) throw new RangeError("The cents value must be between 0 and 127");
        return wm.toMIDIChannels(channel).forEach(function() {
            that.setRegisteredParameter("pitchbendrange", [
                semitones,
                cents
            ], channel, {
                time: options.time
            });
        }), this;
    }, Output.prototype.setModulationRange = function(semitones, cents, channel, options) {
        var that = this;
        if (options = options || {}, !(0 <= (semitones = Math.floor(semitones) || 0) && semitones <= 127)) throw new RangeError("The semitones value must be between 0 and 127");
        if (!(0 <= (cents = Math.floor(cents) || 0) && cents <= 127)) throw new RangeError("The cents value must be between 0 and 127");
        return wm.toMIDIChannels(channel).forEach(function() {
            that.setRegisteredParameter("modulationrange", [
                semitones,
                cents
            ], channel, {
                time: options.time
            });
        }), this;
    }, Output.prototype.setMasterTuning = function(value, channel, options) {
        var that = this;
        if (options = options || {}, (value = parseFloat(value) || 0) <= -65 || 64 <= value) throw new RangeError("The value must be a decimal number larger than -65 and smaller than 64.");
        var coarse = Math.floor(value) + 64, fine = value - Math.floor(value), msb = (fine = Math.round((fine + 1) / 2 * 16383)) >> 7 & 127, lsb = 127 & fine;
        return wm.toMIDIChannels(channel).forEach(function() {
            that.setRegisteredParameter("channelcoarsetuning", coarse, channel, {
                time: options.time
            }), that.setRegisteredParameter("channelfinetuning", [
                msb,
                lsb
            ], channel, {
                time: options.time
            });
        }), this;
    }, Output.prototype.setTuningProgram = function(value, channel, options) {
        var that = this;
        if (options = options || {}, !(0 <= (value = Math.floor(value)) && value <= 127)) throw new RangeError("The program value must be between 0 and 127");
        return wm.toMIDIChannels(channel).forEach(function() {
            that.setRegisteredParameter("tuningprogram", value, channel, {
                time: options.time
            });
        }), this;
    }, Output.prototype.setTuningBank = function(value, channel, options) {
        var that = this;
        if (options = options || {}, !(0 <= (value = Math.floor(value) || 0) && value <= 127)) throw new RangeError("The bank value must be between 0 and 127");
        return wm.toMIDIChannels(channel).forEach(function() {
            that.setRegisteredParameter("tuningbank", value, channel, {
                time: options.time
            });
        }), this;
    }, Output.prototype.sendChannelMode = function(command, value, channel, options) {
        if (options = options || {}, "string" == typeof command) {
            if (!(command = wm.MIDI_CHANNEL_MODE_MESSAGES[command])) throw new TypeError("Invalid channel mode message name.");
        } else if (!(120 <= (command = Math.floor(command)) && command <= 127)) throw new RangeError("Channel mode numerical identifiers must be between 120 and 127.");
        if ((value = Math.floor(value) || 0) < 0 || 127 < value) throw new RangeError("Value must be an integer between 0 and 127.");
        return wm.toMIDIChannels(channel).forEach((function(ch) {
            this.send((wm.MIDI_CHANNEL_MESSAGES.channelmode << 4) + (ch - 1), [
                command,
                value
            ], this._parseTimeParameter(options.time));
        }).bind(this)), this;
    }, Output.prototype.sendProgramChange = function(program, channel, options) {
        var that = this;
        if (options = options || {}, program = Math.floor(program), isNaN(program) || program < 0 || 127 < program) throw new RangeError("Program numbers must be between 0 and 127.");
        return wm.toMIDIChannels(channel).forEach(function(ch) {
            that.send((wm.MIDI_CHANNEL_MESSAGES.programchange << 4) + (ch - 1), [
                program
            ], that._parseTimeParameter(options.time));
        }), this;
    }, Output.prototype.sendChannelAftertouch = function(pressure, channel, options) {
        var that = this;
        options = options || {}, pressure = parseFloat(pressure), (isNaN(pressure) || pressure < 0 || 1 < pressure) && (pressure = .5);
        var nPressure = Math.round(127 * pressure);
        return wm.toMIDIChannels(channel).forEach(function(ch) {
            that.send((wm.MIDI_CHANNEL_MESSAGES.channelaftertouch << 4) + (ch - 1), [
                nPressure
            ], that._parseTimeParameter(options.time));
        }), this;
    }, Output.prototype.sendPitchBend = function(bend, channel, options) {
        var that = this;
        if (options = options || {}, isNaN(bend) || bend < -1 || 1 < bend) throw new RangeError("Pitch bend value must be between -1 and 1.");
        var nLevel = Math.round((bend + 1) / 2 * 16383), msb = nLevel >> 7 & 127, lsb = 127 & nLevel;
        return wm.toMIDIChannels(channel).forEach(function(ch) {
            that.send((wm.MIDI_CHANNEL_MESSAGES.pitchbend << 4) + (ch - 1), [
                lsb,
                msb
            ], that._parseTimeParameter(options.time));
        }), this;
    }, Output.prototype._parseTimeParameter = function(time) {
        var value, parsed = parseFloat(time);
        return "string" == typeof time && "+" === time.substring(0, 1) ? parsed && 0 < parsed && (value = wm.time + parsed) : parsed > wm.time && (value = parsed), value;
    }, Output.prototype._convertNoteToArray = function(note) {
        var notes = [];
        return Array.isArray(note) || (note = [
            note
        ]), note.forEach(function(item) {
            notes.push(wm.guessNoteNumber(item));
        }), notes;
    }, "function" == typeof define && "object" == typeof define.amd ? define([], function() {
        return wm;
    }) : $812879cc09ac4815$exports ? $812879cc09ac4815$exports = wm : scope.WebMidi || (scope.WebMidi = wm);
}($812879cc09ac4815$exports);


var $ba996592197f9ed9$exports = {};
/*!
* screenfull
* v5.2.0 - 2021-11-03
* (c) Sindre Sorhus; MIT License
*/ (function() {
    'use strict';
    var document = typeof window !== 'undefined' && typeof window.document !== 'undefined' ? window.document : {};
    var isCommonjs = $ba996592197f9ed9$exports;
    var fn = function() {
        var val;
        var fnMap = [
            [
                'requestFullscreen',
                'exitFullscreen',
                'fullscreenElement',
                'fullscreenEnabled',
                'fullscreenchange',
                'fullscreenerror'
            ],
            // New WebKit
            [
                'webkitRequestFullscreen',
                'webkitExitFullscreen',
                'webkitFullscreenElement',
                'webkitFullscreenEnabled',
                'webkitfullscreenchange',
                'webkitfullscreenerror'
            ],
            // Old WebKit
            [
                'webkitRequestFullScreen',
                'webkitCancelFullScreen',
                'webkitCurrentFullScreenElement',
                'webkitCancelFullScreen',
                'webkitfullscreenchange',
                'webkitfullscreenerror'
            ],
            [
                'mozRequestFullScreen',
                'mozCancelFullScreen',
                'mozFullScreenElement',
                'mozFullScreenEnabled',
                'mozfullscreenchange',
                'mozfullscreenerror'
            ],
            [
                'msRequestFullscreen',
                'msExitFullscreen',
                'msFullscreenElement',
                'msFullscreenEnabled',
                'MSFullscreenChange',
                'MSFullscreenError'
            ]
        ];
        var i = 0;
        var l = fnMap.length;
        var ret = {};
        for(; i < l; i++){
            val = fnMap[i];
            if (val && val[1] in document) {
                for(i = 0; i < val.length; i++)ret[fnMap[0][i]] = val[i];
                return ret;
            }
        }
        return false;
    }();
    var eventNameMap = {
        change: fn.fullscreenchange,
        error: fn.fullscreenerror
    };
    var screenfull = {
        request: function(element, options) {
            return new Promise((function(resolve, reject) {
                var onFullScreenEntered = (function() {
                    this.off('change', onFullScreenEntered);
                    resolve();
                }).bind(this);
                this.on('change', onFullScreenEntered);
                element = element || document.documentElement;
                var returnPromise = element[fn.requestFullscreen](options);
                if (returnPromise instanceof Promise) returnPromise.then(onFullScreenEntered).catch(reject);
            }).bind(this));
        },
        exit: function() {
            return new Promise((function(resolve, reject) {
                if (!this.isFullscreen) {
                    resolve();
                    return;
                }
                var onFullScreenExit = (function() {
                    this.off('change', onFullScreenExit);
                    resolve();
                }).bind(this);
                this.on('change', onFullScreenExit);
                var returnPromise = document[fn.exitFullscreen]();
                if (returnPromise instanceof Promise) returnPromise.then(onFullScreenExit).catch(reject);
            }).bind(this));
        },
        toggle: function(element, options) {
            return this.isFullscreen ? this.exit() : this.request(element, options);
        },
        onchange: function(callback) {
            this.on('change', callback);
        },
        onerror: function(callback) {
            this.on('error', callback);
        },
        on: function(event, callback) {
            var eventName = eventNameMap[event];
            if (eventName) document.addEventListener(eventName, callback, false);
        },
        off: function(event, callback) {
            var eventName = eventNameMap[event];
            if (eventName) document.removeEventListener(eventName, callback, false);
        },
        raw: fn
    };
    if (!fn) {
        if (isCommonjs) $ba996592197f9ed9$exports = {
            isEnabled: false
        };
        else window.screenfull = {
            isEnabled: false
        };
        return;
    }
    Object.defineProperties(screenfull, {
        isFullscreen: {
            get: function() {
                return Boolean(document[fn.fullscreenElement]);
            }
        },
        element: {
            enumerable: true,
            get: function() {
                return document[fn.fullscreenElement];
            }
        },
        isEnabled: {
            enumerable: true,
            get: function() {
                // Coerce to boolean in case of old WebKit
                return Boolean(document[fn.fullscreenEnabled]);
            }
        }
    });
    if (isCommonjs) $ba996592197f9ed9$exports = screenfull;
    else window.screenfull = screenfull;
})();



var $b073ace211e07ca5$exports = {};
$b073ace211e07ca5$exports = "precision highp float;\n#define GLSLIFY 1\n\nattribute vec2 aPosition;\nvarying vec2 vUv;\nvarying vec2 vL;\nvarying vec2 vR;\nvarying vec2 vT;\nvarying vec2 vB;\nuniform vec2 texelSize;\n\nvoid main () {\n    vUv = aPosition * 0.5 + 0.5;\n    vL = vUv - vec2(texelSize.x, 0.0);\n    vR = vUv + vec2(texelSize.x, 0.0);\n    vT = vUv + vec2(0.0, texelSize.y);\n    vB = vUv - vec2(0.0, texelSize.y);\n    gl_Position = vec4(aPosition, 0.0, 1.0);\n}\n";


var $af22a45ee2cf3058$exports = {};
$af22a45ee2cf3058$exports = "precision highp float;\n#define GLSLIFY 1\n\nattribute vec2 aPosition;\nvarying vec2 vUv;\nvarying vec2 vL;\nvarying vec2 vR;\nuniform vec2 texelSize;\n\nvoid main () {\n    vUv = aPosition * 0.5 + 0.5;\n    float offset = 1.33333333;\n    vL = vUv - texelSize * offset;\n    vR = vUv + texelSize * offset;\n    gl_Position = vec4(aPosition, 0.0, 1.0);\n}\n";


var $9fe15e68bee46b24$exports = {};
$9fe15e68bee46b24$exports = "precision mediump float;\nprecision mediump sampler2D;\n#define GLSLIFY 1\n\nvarying vec2 vUv;\nvarying vec2 vL;\nvarying vec2 vR;\nuniform sampler2D uTexture;\n\nvoid main () {\n    vec4 sum = texture2D(uTexture, vUv) * 0.29411764;\n    sum += texture2D(uTexture, vL) * 0.35294117;\n    sum += texture2D(uTexture, vR) * 0.35294117;\n    gl_FragColor = sum;\n}\n";


var $b2937d4c01081df9$exports = {};
$b2937d4c01081df9$exports = "precision mediump float;\nprecision mediump sampler2D;\n#define GLSLIFY 1\n\nvarying highp vec2 vUv;\nuniform sampler2D uTexture;\n\nvoid main () {\n    gl_FragColor = texture2D(uTexture, vUv);\n}\n";


var $719ba1830217732e$exports = {};
$719ba1830217732e$exports = "precision mediump float;\nprecision mediump sampler2D;\n#define GLSLIFY 1\n\nvarying highp vec2 vUv;\nuniform sampler2D uTexture;\nuniform float value;\n\nvoid main () {\n    gl_FragColor = value * texture2D(uTexture, vUv);\n}\n";


var $73744113a8abb7e1$exports = {};
$73744113a8abb7e1$exports = "precision mediump float;\n#define GLSLIFY 1\n\nuniform vec4 color;\n\nvoid main () {\n    gl_FragColor = color;\n}\n";


var $abb988efd69fa6f6$exports = {};
$abb988efd69fa6f6$exports = "precision highp float;\nprecision highp sampler2D;\n#define GLSLIFY 1\n\nvarying vec2 vUv;\nuniform sampler2D uTexture;\nuniform float aspectRatio;\n\n#define SCALE 25.0\n\nvoid main () {\n    vec2 uv = floor(vUv * SCALE * vec2(aspectRatio, 1.0));\n    float v = mod(uv.x + uv.y, 2.0);\n    v = v * 0.1 + 0.8;\n    gl_FragColor = vec4(vec3(v), 1.0);\n}\n";


var $91e81c3e9c7f71c0$exports = {};
$91e81c3e9c7f71c0$exports = "precision highp float;\nprecision highp sampler2D;\n#define GLSLIFY 1\n\nvarying vec2 vUv;\nvarying vec2 vL;\nvarying vec2 vR;\nvarying vec2 vT;\nvarying vec2 vB;\nuniform sampler2D uTexture;\nuniform sampler2D uBloom;\nuniform sampler2D uSunrays;\nuniform sampler2D uDithering;\nuniform vec2 ditherScale;\nuniform vec2 texelSize;\n\nvec3 linearToGamma (vec3 color) {\n    color = max(color, vec3(0));\n    return max(1.055 * pow(color, vec3(0.416666667)) - 0.055, vec3(0));\n}\n\nvoid main () {\n    vec3 c = texture2D(uTexture, vUv).rgb;\n\n    #ifdef SHADING\n    vec3 lc = texture2D(uTexture, vL).rgb;\n    vec3 rc = texture2D(uTexture, vR).rgb;\n    vec3 tc = texture2D(uTexture, vT).rgb;\n    vec3 bc = texture2D(uTexture, vB).rgb;\n\n    float dx = length(rc) - length(lc);\n    float dy = length(tc) - length(bc);\n\n    vec3 n = normalize(vec3(dx, dy, length(texelSize)));\n    vec3 l = vec3(0.0, 0.0, 1.0);\n\n    float diffuse = clamp(dot(n, l) + 0.7, 0.7, 1.0);\n    c *= diffuse;\n    #endif\n\n    #ifdef BLOOM\n    vec3 bloom = texture2D(uBloom, vUv).rgb;\n    #endif\n\n    #ifdef SUNRAYS\n    float sunrays = texture2D(uSunrays, vUv).r;\n    c *= sunrays;\n    #ifdef BLOOM\n    bloom *= sunrays;\n    #endif\n    #endif\n\n    #ifdef BLOOM\n    float noise = texture2D(uDithering, vUv * ditherScale).r;\n    noise = noise * 2.0 - 1.0;\n    bloom += noise / 255.0;\n    bloom = linearToGamma(bloom);\n    c += bloom;\n    #endif\n\n    float a = max(c.r, max(c.g, c.b));\n    gl_FragColor = vec4(c, a);\n}\n";


var $8f5fcad1063be82d$exports = {};
$8f5fcad1063be82d$exports = "precision mediump float;\nprecision mediump sampler2D;\n#define GLSLIFY 1\n\nvarying vec2 vUv;\nuniform sampler2D uTexture;\nuniform vec3 curve;\nuniform float threshold;\n\nvoid main () {\n    vec3 c = texture2D(uTexture, vUv).rgb;\n    float br = max(c.r, max(c.g, c.b));\n    float rq = clamp(br - curve.x, 0.0, curve.y);\n    rq = curve.z * rq * rq;\n    c *= max(rq, br - threshold) / max(br, 0.0001);\n    gl_FragColor = vec4(c, 0.0);\n}\n";


var $a5ada04d393fb5d7$exports = {};
$a5ada04d393fb5d7$exports = "precision mediump float;\nprecision mediump sampler2D;\n#define GLSLIFY 1\n\nvarying vec2 vL;\nvarying vec2 vR;\nvarying vec2 vT;\nvarying vec2 vB;\nuniform sampler2D uTexture;\n\nvoid main () {\n    vec4 sum = vec4(0.0);\n    sum += texture2D(uTexture, vL);\n    sum += texture2D(uTexture, vR);\n    sum += texture2D(uTexture, vT);\n    sum += texture2D(uTexture, vB);\n    sum *= 0.25;\n    gl_FragColor = sum;\n}\n";


var $1ef0e73bcc342f97$exports = {};
$1ef0e73bcc342f97$exports = "precision mediump float;\nprecision mediump sampler2D;\n#define GLSLIFY 1\n\nvarying vec2 vL;\nvarying vec2 vR;\nvarying vec2 vT;\nvarying vec2 vB;\nuniform sampler2D uTexture;\nuniform float intensity;\n\nvoid main () {\n    vec4 sum = vec4(0.0);\n    sum += texture2D(uTexture, vL);\n    sum += texture2D(uTexture, vR);\n    sum += texture2D(uTexture, vT);\n    sum += texture2D(uTexture, vB);\n    sum *= 0.25;\n    gl_FragColor = sum * intensity;\n}\n";


var $7a5947680249ab33$exports = {};
$7a5947680249ab33$exports = "precision highp float;\nprecision highp sampler2D;\n#define GLSLIFY 1\n\nvarying vec2 vUv;\nuniform sampler2D uTexture;\n\nvoid main () {\n    vec4 c = texture2D(uTexture, vUv);\n    float br = max(c.r, max(c.g, c.b));\n    c.a = 1.0 - min(max(br * 20.0, 0.0), 0.8);\n    gl_FragColor = c;\n}\n";


var $4f387349a228c2dd$exports = {};
$4f387349a228c2dd$exports = "precision highp float;\nprecision highp sampler2D;\n#define GLSLIFY 1\n\nvarying vec2 vUv;\nuniform sampler2D uTexture;\nuniform float weight;\n\n#define ITERATIONS 16\n\nvoid main () {\n    float Density = 0.3;\n    float Decay = 0.95;\n    float Exposure = 0.7;\n\n    vec2 coord = vUv;\n    vec2 dir = vUv - 0.5;\n\n    dir *= 1.0 / float(ITERATIONS) * Density;\n    float illuminationDecay = 1.0;\n\n    float color = texture2D(uTexture, vUv).a;\n\n    for (int i = 0; i < ITERATIONS; i++)\n    {\n        coord -= dir;\n        float col = texture2D(uTexture, coord).a;\n        color += col * illuminationDecay * weight;\n        illuminationDecay *= Decay;\n    }\n\n    gl_FragColor = vec4(color * Exposure, 0.0, 0.0, 1.0);\n}\n";


var $3efa16d047bc35ee$exports = {};
$3efa16d047bc35ee$exports = "precision highp float;\nprecision highp sampler2D;\n#define GLSLIFY 1\n\nvarying vec2 vUv;\nuniform sampler2D uTarget;\nuniform float aspectRatio;\nuniform vec3 color;\nuniform vec2 point;\nuniform float radius;\n\nvoid main () {\n    vec2 p = vUv - point.xy;\n    p.x *= aspectRatio;\n    vec3 splat = exp(-dot(p, p) / radius) * color;\n    vec3 base = texture2D(uTarget, vUv).xyz;\n    gl_FragColor = vec4(base + splat, 1.0);\n}\n";


var $993d5df17bfe8036$exports = {};
$993d5df17bfe8036$exports = "precision highp float;\nprecision highp sampler2D;\n#define GLSLIFY 1\n\nvarying vec2 vUv;\nuniform sampler2D uVelocity;\nuniform sampler2D uSource;\nuniform vec2 texelSize;\nuniform vec2 dyeTexelSize;\nuniform float dt;\nuniform float dissipation;\n\nvec4 bilerp (sampler2D sam, vec2 uv, vec2 tsize) {\n    vec2 st = uv / tsize - 0.5;\n\n    vec2 iuv = floor(st);\n    vec2 fuv = fract(st);\n\n    vec4 a = texture2D(sam, (iuv + vec2(0.5, 0.5)) * tsize);\n    vec4 b = texture2D(sam, (iuv + vec2(1.5, 0.5)) * tsize);\n    vec4 c = texture2D(sam, (iuv + vec2(0.5, 1.5)) * tsize);\n    vec4 d = texture2D(sam, (iuv + vec2(1.5, 1.5)) * tsize);\n\n    return mix(mix(a, b, fuv.x), mix(c, d, fuv.x), fuv.y);\n}\n\nvoid main () {\n    #ifdef MANUAL_FILTERING\n    vec2 coord = vUv - dt * bilerp(uVelocity, vUv, texelSize).xy * texelSize;\n    vec4 result = bilerp(uSource, coord, dyeTexelSize);\n    #else\n    vec2 coord = vUv - dt * texture2D(uVelocity, vUv).xy * texelSize;\n    vec4 result = texture2D(uSource, coord);\n    #endif\n    float decay = 1.0 + dissipation * dt;\n    gl_FragColor = result / decay;\n}\n";


var $d9cebc9ec9011904$exports = {};
$d9cebc9ec9011904$exports = "precision mediump float;\nprecision mediump sampler2D;\n#define GLSLIFY 1\n\nvarying highp vec2 vUv;\nvarying highp vec2 vL;\nvarying highp vec2 vR;\nvarying highp vec2 vT;\nvarying highp vec2 vB;\nuniform sampler2D uVelocity;\n\nvoid main () {\n    float L = texture2D(uVelocity, vL).x;\n    float R = texture2D(uVelocity, vR).x;\n    float T = texture2D(uVelocity, vT).y;\n    float B = texture2D(uVelocity, vB).y;\n\n    vec2 C = texture2D(uVelocity, vUv).xy;\n    if (vL.x < 0.0) { L = -C.x; }\n    if (vR.x > 1.0) { R = -C.x; }\n    if (vT.y > 1.0) { T = -C.y; }\n    if (vB.y < 0.0) { B = -C.y; }\n\n    float div = 0.5 * (R - L + T - B);\n    gl_FragColor = vec4(div, 0.0, 0.0, 1.0);\n}\n";


var $7c890988bafebabf$exports = {};
$7c890988bafebabf$exports = "precision mediump float;\nprecision mediump sampler2D;\n#define GLSLIFY 1\n\nvarying highp vec2 vUv;\nvarying highp vec2 vL;\nvarying highp vec2 vR;\nvarying highp vec2 vT;\nvarying highp vec2 vB;\nuniform sampler2D uVelocity;\n\nvoid main () {\n    float L = texture2D(uVelocity, vL).y;\n    float R = texture2D(uVelocity, vR).y;\n    float T = texture2D(uVelocity, vT).x;\n    float B = texture2D(uVelocity, vB).x;\n    float vorticity = R - L - T + B;\n    gl_FragColor = vec4(0.5 * vorticity, 0.0, 0.0, 1.0);\n}\n";


var $70acace40d332cd0$exports = {};
$70acace40d332cd0$exports = "precision highp float;\nprecision highp sampler2D;\n#define GLSLIFY 1\n\nvarying vec2 vUv;\nvarying vec2 vL;\nvarying vec2 vR;\nvarying vec2 vT;\nvarying vec2 vB;\nuniform sampler2D uVelocity;\nuniform sampler2D uCurl;\nuniform float curl;\nuniform float dt;\n\nvoid main () {\n    float L = texture2D(uCurl, vL).x;\n    float R = texture2D(uCurl, vR).x;\n    float T = texture2D(uCurl, vT).x;\n    float B = texture2D(uCurl, vB).x;\n    float C = texture2D(uCurl, vUv).x;\n\n    vec2 force = 0.5 * vec2(abs(T) - abs(B), abs(R) - abs(L));\n    force /= length(force) + 0.0001;\n    force *= curl * C;\n    force.y *= -1.0;\n\n    vec2 vel = texture2D(uVelocity, vUv).xy;\n    gl_FragColor = vec4(vel + force * dt, 0.0, 1.0);\n}\n";


var $6cca967b18c9fc9f$exports = {};
$6cca967b18c9fc9f$exports = "precision mediump float;\nprecision mediump sampler2D;\n#define GLSLIFY 1\n\nvarying highp vec2 vUv;\nvarying highp vec2 vL;\nvarying highp vec2 vR;\nvarying highp vec2 vT;\nvarying highp vec2 vB;\nuniform sampler2D uPressure;\nuniform sampler2D uDivergence;\n\nvoid main () {\n    float L = texture2D(uPressure, vL).x;\n    float R = texture2D(uPressure, vR).x;\n    float T = texture2D(uPressure, vT).x;\n    float B = texture2D(uPressure, vB).x;\n    float C = texture2D(uPressure, vUv).x;\n    float divergence = texture2D(uDivergence, vUv).x;\n    float pressure = (L + R + B + T - divergence) * 0.25;\n    gl_FragColor = vec4(pressure, 0.0, 0.0, 1.0);\n}\n";


var $08cd69f8f5a4a380$exports = {};
$08cd69f8f5a4a380$exports = "precision mediump float;\nprecision mediump sampler2D;\n#define GLSLIFY 1\n\nvarying highp vec2 vUv;\nvarying highp vec2 vL;\nvarying highp vec2 vR;\nvarying highp vec2 vT;\nvarying highp vec2 vB;\nuniform sampler2D uPressure;\nuniform sampler2D uVelocity;\n\nvoid main () {\n    float L = texture2D(uPressure, vL).x;\n    float R = texture2D(uPressure, vR).x;\n    float T = texture2D(uPressure, vT).x;\n    float B = texture2D(uPressure, vB).x;\n    vec2 velocity = texture2D(uVelocity, vUv).xy;\n    velocity.xy -= vec2(R - L, T - B);\n    gl_FragColor = vec4(velocity, 0.0, 1.0);\n}\n";


var $bd5624bc48e5cdda$exports = {};

$parcel$export($bd5624bc48e5cdda$exports, "name", () => $bd5624bc48e5cdda$export$a8ff84c12d48cfa6);
$parcel$export($bd5624bc48e5cdda$exports, "isSupportedDevice", () => $bd5624bc48e5cdda$export$4067a3e42f64a634);
$parcel$export($bd5624bc48e5cdda$exports, "midiInControlChange", () => $bd5624bc48e5cdda$export$b192a6bb3da44c96);
$parcel$export($bd5624bc48e5cdda$exports, "midiSplatHandler", () => $bd5624bc48e5cdda$export$23ccdb72f86533c);
const $bd5624bc48e5cdda$export$a8ff84c12d48cfa6 = "nanoKontrol2";
const $bd5624bc48e5cdda$var$nanoKontrol2_button_PARAM1_SOLO = 32;
const $bd5624bc48e5cdda$var$nanoKontrol2_button_PARAM2_SOLO = 33;
const $bd5624bc48e5cdda$var$nanoKontrol2_button_PARAM3_SOLO = 34;
const $bd5624bc48e5cdda$var$nanoKontrol2_button_PARAM4_SOLO = 35;
const $bd5624bc48e5cdda$var$nanoKontrol2_button_PARAM5_SOLO = 36;
const $bd5624bc48e5cdda$var$nanoKontrol2_button_PARAM6_SOLO = 37;
const $bd5624bc48e5cdda$var$nanoKontrol2_button_PARAM7_SOLO = 38;
const $bd5624bc48e5cdda$var$nanoKontrol2_button_PARAM8_SOLO = 39;
const $bd5624bc48e5cdda$var$nanoKontrol2_button_PARAM1_MUTE = 48;
const $bd5624bc48e5cdda$var$nanoKontrol2_button_PARAM2_MUTE = 49;
const $bd5624bc48e5cdda$var$nanoKontrol2_button_PARAM3_MUTE = 50;
const $bd5624bc48e5cdda$var$nanoKontrol2_button_PARAM4_MUTE = 51;
const $bd5624bc48e5cdda$var$nanoKontrol2_button_PARAM5_MUTE = 52;
const $bd5624bc48e5cdda$var$nanoKontrol2_button_PARAM6_MUTE = 53;
const $bd5624bc48e5cdda$var$nanoKontrol2_button_PARAM7_MUTE = 54;
const $bd5624bc48e5cdda$var$nanoKontrol2_button_PARAM8_MUTE = 55;
const $bd5624bc48e5cdda$var$nanoKontrol2_button_PARAM1_RECORD = 64;
const $bd5624bc48e5cdda$var$nanoKontrol2_button_PARAM2_RECORD = 65;
const $bd5624bc48e5cdda$var$nanoKontrol2_button_PARAM3_RECORD = 66;
const $bd5624bc48e5cdda$var$nanoKontrol2_button_PARAM4_RECORD = 67;
const $bd5624bc48e5cdda$var$nanoKontrol2_button_PARAM5_RECORD = 68;
const $bd5624bc48e5cdda$var$nanoKontrol2_button_PARAM6_RECORD = 69;
const $bd5624bc48e5cdda$var$nanoKontrol2_button_PARAM7_RECORD = 70;
const $bd5624bc48e5cdda$var$nanoKontrol2_button_PARAM8_RECORD = 71;
const $bd5624bc48e5cdda$var$nanoKontrol2_slidersGroupButtons = [
    [
        $bd5624bc48e5cdda$var$nanoKontrol2_button_PARAM1_SOLO,
        $bd5624bc48e5cdda$var$nanoKontrol2_button_PARAM2_SOLO,
        $bd5624bc48e5cdda$var$nanoKontrol2_button_PARAM3_SOLO,
        $bd5624bc48e5cdda$var$nanoKontrol2_button_PARAM4_SOLO,
        $bd5624bc48e5cdda$var$nanoKontrol2_button_PARAM5_SOLO,
        $bd5624bc48e5cdda$var$nanoKontrol2_button_PARAM6_SOLO,
        $bd5624bc48e5cdda$var$nanoKontrol2_button_PARAM7_SOLO,
        $bd5624bc48e5cdda$var$nanoKontrol2_button_PARAM8_SOLO
    ],
    [
        $bd5624bc48e5cdda$var$nanoKontrol2_button_PARAM1_MUTE,
        $bd5624bc48e5cdda$var$nanoKontrol2_button_PARAM2_MUTE,
        $bd5624bc48e5cdda$var$nanoKontrol2_button_PARAM3_MUTE,
        $bd5624bc48e5cdda$var$nanoKontrol2_button_PARAM4_MUTE,
        $bd5624bc48e5cdda$var$nanoKontrol2_button_PARAM5_MUTE,
        $bd5624bc48e5cdda$var$nanoKontrol2_button_PARAM6_MUTE,
        $bd5624bc48e5cdda$var$nanoKontrol2_button_PARAM7_MUTE,
        $bd5624bc48e5cdda$var$nanoKontrol2_button_PARAM8_MUTE
    ],
    [
        $bd5624bc48e5cdda$var$nanoKontrol2_button_PARAM1_RECORD,
        $bd5624bc48e5cdda$var$nanoKontrol2_button_PARAM2_RECORD,
        $bd5624bc48e5cdda$var$nanoKontrol2_button_PARAM3_RECORD,
        $bd5624bc48e5cdda$var$nanoKontrol2_button_PARAM4_RECORD,
        $bd5624bc48e5cdda$var$nanoKontrol2_button_PARAM5_RECORD,
        $bd5624bc48e5cdda$var$nanoKontrol2_button_PARAM6_RECORD,
        $bd5624bc48e5cdda$var$nanoKontrol2_button_PARAM7_RECORD,
        $bd5624bc48e5cdda$var$nanoKontrol2_button_PARAM8_RECORD
    ]
];
function $bd5624bc48e5cdda$export$4067a3e42f64a634(manufacturer, name) {
    if (!name) return false;
    return name.toLowerCase().includes("nanokontrol");
}
function $bd5624bc48e5cdda$export$b192a6bb3da44c96(event, config, logger) {
    let understood = false;
    if (event.controller.number === 0) {
        config.SPLAT_FORCE = Math.floor(event.value / 127 * 10000);
        if (config.SPLAT_FORCE === 0) config.SPLAT_FORCE = 0.01;
        logger("SPLAT_FORCE", config.SPLAT_FORCE);
        understood = true;
    }
    if (event.controller.number === 1) {
        config.SPLAT_RADIUS = event.value / 127;
        if (config.SPLAT_RADIUS === 0) config.SPLAT_RADIUS = 0.01;
        logger("SPLAT_RADIUS", config.SPLAT_RADIUS);
        understood = true;
    }
    if (event.controller.number === 2) {
        config.DYE_RESOLUTION = 32 + event.value / 127 * 1024;
        logger("DYE_RESOLUTION", config.DYE_RESOLUTION);
        config.doReinitFramebuffers = true;
        understood = true;
    }
    if (event.controller.number === 3) {
        config.SIM_RESOLUTION = 32 + event.value / 127 * 1024;
        logger("SIM_RESOLUTION", config.SIM_RESOLUTION);
        config.doReinitFramebuffers = true;
        understood = true;
    }
    if (event.controller.number === 4) {
        config.CURL = event.value / 127 * 50;
        logger("CURL", config.CURL);
        understood = true;
    }
    if (event.controller.number === 7) {
        config.PRESSURE = event.value / 127;
        logger("PRESSURE", config.PRESSURE);
        understood = true;
    }
    if (event.controller.number === 16) {
        config.DENSITY_DISSIPATION = (event.value / 127 - 0.5) * 4;
        logger("DENSITY_DISSIPATION", config.DENSITY_DISSIPATION);
        understood = true;
    }
    if (event.controller.number === 17) {
        config.VELOCITY_DISSIPATION = (event.value / 127 - 0.5) * 4;
        logger("VELOCITY_DISSIPATION", config.VELOCITY_DISSIPATION);
        understood = true;
    }
    if (!understood) logger(`Unknown MIDI CC: ${event.controller.number}/${event.value} on '${event.target.name}'`);
    return understood;
}
function $bd5624bc48e5cdda$export$23ccdb72f86533c(port) {
    // reset all the leds to off initially
    $bd5624bc48e5cdda$var$nanoKontrol2_slidersGroupButtons.forEach((rows)=>{
        rows.forEach((button)=>{
            port.sendControlChange(button, 0);
        });
    });
    // return the handler that's invoked on splats
    let splatHook = (x, y, dx, dy, realColor)=>{
        // x goes from 0.00 to 1.00 (left to right)
        let buttonX = Math.ceil((x + 0.00) * 8);
        buttonX = buttonX < 1 ? 1 : buttonX;
        // y goes from 1.00 to 0.00 (top to bottom)
        let buttonY = Math.ceil((1.00 - y) * 3);
        buttonY = buttonY < 1 ? 1 : buttonY;
        // now find the button for that x, y
        let theButton = $bd5624bc48e5cdda$var$nanoKontrol2_slidersGroupButtons[buttonY - 1][buttonX - 1];
        port.sendControlChange(theButton, 127, "all");
        port.sendControlChange(theButton, 0, "all", {
            time: "+500"
        });
    };
    return splatHook;
}


var $6b44a3520a6435e8$exports = {};

$parcel$export($6b44a3520a6435e8$exports, "name", () => $6b44a3520a6435e8$export$a8ff84c12d48cfa6);
$parcel$export($6b44a3520a6435e8$exports, "isSupportedDevice", () => $6b44a3520a6435e8$export$4067a3e42f64a634);
$parcel$export($6b44a3520a6435e8$exports, "midiInNoteOn", () => $6b44a3520a6435e8$export$e00075188492435b);
$parcel$export($6b44a3520a6435e8$exports, "midiInControlChange", () => $6b44a3520a6435e8$export$b192a6bb3da44c96);
const $6b44a3520a6435e8$export$a8ff84c12d48cfa6 = "Traktor";
function $6b44a3520a6435e8$export$4067a3e42f64a634(manufacturer, name) {
    if (!name) return false;
    return name.toLowerCase().includes("traktor");
}
function $6b44a3520a6435e8$export$e00075188492435b(event, config, logger, randomSplatsNow) {
    logger(`Traktor MIDI Note: ${event.note.name} (${event.note.number}) channel ${event.channel} on '${event.target.name}'`);
    let numRandomSplats = event.note.number % 10;
    randomSplatsNow(numRandomSplats > 0 ? numRandomSplats : 1);
    return false; // do not broadcast config change.
}
function $6b44a3520a6435e8$export$b192a6bb3da44c96(event, config, logger) {
    let understood = false;
    if (event.controller.number === 42 && event.channel === 2) {
        config.SPLAT_FORCE = Math.floor(event.value / 127 * 10000);
        if (config.SPLAT_FORCE === 0) config.SPLAT_FORCE = 0.01;
        logger("SPLAT_FORCE", config.SPLAT_FORCE);
        understood = true;
    }
    if (event.controller.number === 1 && event.channel === 6) {
        config.SPLAT_RADIUS = event.value / 127;
        if (config.SPLAT_RADIUS === 0) config.SPLAT_RADIUS = 0.01;
        logger("SPLAT_RADIUS", config.SPLAT_RADIUS);
        understood = true;
    }
    if (event.controller.number === 1 && event.channel === 7) {
        config.DYE_RESOLUTION = 32 + event.value / 127 * 1024;
        logger("DYE_RESOLUTION", config.DYE_RESOLUTION);
        config.doReinitFramebuffers = true;
        understood = true;
    }
    if (event.controller.number === 1 && event.channel === 8) {
        config.SIM_RESOLUTION = 32 + event.value / 127 * 1024;
        logger("SIM_RESOLUTION", config.SIM_RESOLUTION);
        config.doReinitFramebuffers = true;
        understood = true;
    }
    if (event.controller.number === 3 && event.channel === 6) {
        config.CURL = event.value / 127 * 50;
        logger("CURL", config.CURL);
        understood = true;
    }
    if (event.controller.number === 3 && event.channel === 7) {
        config.PRESSURE = event.value / 127;
        logger("PRESSURE", config.PRESSURE);
        understood = true;
    }
    if (event.controller.number === 2 && event.channel === 6) {
        config.DENSITY_DISSIPATION = (event.value / 127 - 0.5) * 4;
        logger("DENSITY_DISSIPATION", config.DENSITY_DISSIPATION);
        understood = true;
    }
    if (event.controller.number === 2 && event.channel === 7) {
        config.VELOCITY_DISSIPATION = (event.value / 127 - 0.5) * 4;
        logger("VELOCITY_DISSIPATION", config.VELOCITY_DISSIPATION);
        understood = true;
    }
    if (!understood) logger(`MIDI CC: ${event.controller.number}/${event.value} channel ${event.channel} on '${event.target.name}'`);
    return understood;
} /**
 * @param port{Output}
 * @returns {splatHook}
 */  /*
export function midiSplatHandler (port) {
    // @TODO: who knows what messages light up the leds on the traktor?
    for (let i = 1; i < 120; i++) {
        port.sendControlChange(i, 127, "all");
    }
}
*/ 


var $7a5d8027f40c18e1$exports = {};

$parcel$export($7a5d8027f40c18e1$exports, "name", () => $7a5d8027f40c18e1$export$a8ff84c12d48cfa6);
$parcel$export($7a5d8027f40c18e1$exports, "isSupportedDevice", () => $7a5d8027f40c18e1$export$4067a3e42f64a634);
$parcel$export($7a5d8027f40c18e1$exports, "midiInNoteOn", () => $7a5d8027f40c18e1$export$e00075188492435b);
$parcel$export($7a5d8027f40c18e1$exports, "midiInControlChange", () => $7a5d8027f40c18e1$export$b192a6bb3da44c96);
const $7a5d8027f40c18e1$export$a8ff84c12d48cfa6 = "Generic";
function $7a5d8027f40c18e1$export$4067a3e42f64a634(manufacturer, name) {
    if (!name) return false;
    return true; // (generic!)
}
function $7a5d8027f40c18e1$export$e00075188492435b(event, config, logger, randomSplatsNow) {
    logger(`Generic MIDI Note: ${event.note.name} (${event.note.number}) channel ${event.channel} on '${event.target.name}'`);
    let numRandomSplats = event.note.number % 10;
    randomSplatsNow(numRandomSplats > 0 ? numRandomSplats : 1);
    return false; // do not broadcast config change.
}
function $7a5d8027f40c18e1$export$b192a6bb3da44c96(event, config, logger) {
    config.SPLAT_RADIUS = event.value / 127;
    if (config.SPLAT_RADIUS === 0) config.SPLAT_RADIUS = 0.01;
    logger(`SPLAT_RADIUS: ${config.SPLAT_RADIUS} - Generic MIDI CC: ${event.controller.number}/${event.value} channel ${event.channel} on '${event.target.name}'`);
    return true;
}


// ordered midi modules
const $9f3b2ca04e3d8775$var$midiModules = [
    $bd5624bc48e5cdda$exports,
    $6b44a3520a6435e8$exports,
    $7a5d8027f40c18e1$exports
];
// <START SIGNALR CONNECTION>
const $9f3b2ca04e3d8775$var$connection = new $cccc8edc49e3facc$export$afccb10c24910b13().configureLogging($5f3832d7be2e7d2f$export$243e62d78d3b544d.Information).withUrl("/fluidhub", {
    transport: $dfd8c9cbca816579$export$789ba40ee1a75f0.WebSockets,
    skipNegotiation: true
}).withAutomaticReconnect().build();
$9f3b2ca04e3d8775$var$connection.on('broadcastMessage', (message)=>{
    console.log("broadcastMessage", message);
    $9f3b2ca04e3d8775$var$canvasLog(message);
});
$9f3b2ca04e3d8775$var$connection.start();
// </START SIGNALR CONNECTION>
let $9f3b2ca04e3d8775$var$splatHook = null;
let $9f3b2ca04e3d8775$var$config = {
    MOBILE_DYE_RESOLUTION: 128,
    MOBILE_SIM_RESOLUTION: 64,
    SIM_RESOLUTION: 241.63779527559055,
    DYE_RESOLUTION: 1024,
    DENSITY_DISSIPATION: 0.8661417322834644,
    VELOCITY_DISSIPATION: 1.0866141732283463,
    PRESSURE: 0.7244094488188977,
    PRESSURE_ITERATIONS: 3,
    CURL: 32.677165354330704,
    SPLAT_RADIUS: 0.07086614173228346,
    SPLAT_FORCE: 6000,
    SHADING: true,
    COLORFUL: false,
    COLOR_UPDATE_SPEED: 1,
    PAUSED: false,
    BACK_COLOR: {
        r: 0,
        g: 0,
        b: 0
    },
    TRANSPARENT: false,
    BLOOM: true,
    BLOOM_ITERATIONS: 8,
    BLOOM_RESOLUTION: 256,
    BLOOM_INTENSITY: 0.8,
    BLOOM_THRESHOLD: 0.6,
    BLOOM_SOFT_KNEE: 0.7,
    SUNRAYS: true,
    SUNRAYS_RESOLUTION: 784,
    SUNRAYS_WEIGHT: 1,
    doReinitFramebuffers: false
};
if ($9f3b2ca04e3d8775$var$queryStringContains("transparent")) $9f3b2ca04e3d8775$var$config.TRANSPARENT = true;
// <MIDI INIT>
function $9f3b2ca04e3d8775$var$startupMidiSupport() {
    (0, (/*@__PURE__*/$parcel$interopDefault($812879cc09ac4815$exports))).enable(function(err) {
        if (err) console.error("WebMidi could not be enabled.", err);
        else {
            console.log("WebMidi enabled!");
            // Reacting when a new device becomes available.
            (0, (/*@__PURE__*/$parcel$interopDefault($812879cc09ac4815$exports))).addListener("connected", function(e) {
                for (const module of $9f3b2ca04e3d8775$var$midiModules)if (module.isSupportedDevice(e.port.manufacturer, e.port.name)) {
                    console.log(`Module '${module.name}' supports '${e.port.name}'!`);
                    $9f3b2ca04e3d8775$var$canvasLog(`Module '${module.name}' supports '${e.port.name}'!`);
                    if (e.port.type === "input") {
                        if (module.midiInControlChange) e.port.addListener("controlchange", "all", (e)=>{
                            if (module.midiInControlChange(e, $9f3b2ca04e3d8775$var$config, $9f3b2ca04e3d8775$var$canvasLog, $9f3b2ca04e3d8775$var$randomSplatsNow)) $9f3b2ca04e3d8775$var$connection.invoke('config', JSON.stringify($9f3b2ca04e3d8775$var$config));
                        });
                        if (module.midiInNoteOn) e.port.addListener("noteon", "all", (e)=>{
                            if (module.midiInNoteOn(e, $9f3b2ca04e3d8775$var$config, $9f3b2ca04e3d8775$var$canvasLog, $9f3b2ca04e3d8775$var$randomSplatsNow)) $9f3b2ca04e3d8775$var$connection.invoke('config', JSON.stringify($9f3b2ca04e3d8775$var$config));
                        });
                    } else if (e.port.type === "output") // @TODO: if more than one module/output only the last one will get it.
                    {
                        if (module.midiSplatHandler) $9f3b2ca04e3d8775$var$splatHook = module.midiSplatHandler(e.port);
                    }
                    break; // first module to support will "get it"; generic always supports
                }
            });
        }
    });
}
$9f3b2ca04e3d8775$var$startupMidiSupport();
// </MIDI INIT>
const $9f3b2ca04e3d8775$var$canvas = document.getElementsByTagName('canvas')[0];
const $9f3b2ca04e3d8775$var$msgElement = document.getElementById("msg");
let $9f3b2ca04e3d8775$var$isMsgVisible = false;
let $9f3b2ca04e3d8775$var$msgTimeout = null;
// Hook up user event to make it fullscreen when it is clicked.
if ($9f3b2ca04e3d8775$var$queryStringContains("fullscreen")) {
    let makeFullScreen = ()=>{
        if ((0, (/*@__PURE__*/$parcel$interopDefault($ba996592197f9ed9$exports))).isEnabled) {
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($ba996592197f9ed9$exports))).isFullscreen) (0, (/*@__PURE__*/$parcel$interopDefault($ba996592197f9ed9$exports))).request().then((value1)=>{
                $9f3b2ca04e3d8775$var$resizeCanvas();
                console.log("Yeah, full screen", value1);
            });
        } else console.warn("screenfull NOT ENABLED!");
    };
    $9f3b2ca04e3d8775$var$canvas.addEventListener('click', makeFullScreen);
    $9f3b2ca04e3d8775$var$canvas.addEventListener('touchstart', makeFullScreen);
}
$9f3b2ca04e3d8775$var$resizeCanvas();
function $9f3b2ca04e3d8775$var$canvasLog(...log) {
    if ($9f3b2ca04e3d8775$var$msgElement) {
        if (!$9f3b2ca04e3d8775$var$isMsgVisible) {
            $9f3b2ca04e3d8775$var$msgElement.style.display = "block";
            $9f3b2ca04e3d8775$var$isMsgVisible = true;
        }
        $9f3b2ca04e3d8775$var$msgElement.innerText = log.join(" ");
        // cancel the last timeout if it's there already
        if ($9f3b2ca04e3d8775$var$msgTimeout) clearTimeout($9f3b2ca04e3d8775$var$msgTimeout);
        // Now set a timeout to hide it again after a while
        $9f3b2ca04e3d8775$var$msgTimeout = setTimeout(()=>{
            $9f3b2ca04e3d8775$var$msgElement.style.display = "none";
            $9f3b2ca04e3d8775$var$isMsgVisible = false;
        }, 1000);
    }
}
function $9f3b2ca04e3d8775$var$pointerPrototype() {
    this.id = -1;
    this.texcoordX = 0;
    this.texcoordY = 0;
    this.deltaX = 0;
    this.deltaY = 0;
    this.down = false;
    this.color = [
        30,
        0,
        300
    ];
}
let $9f3b2ca04e3d8775$var$pointers = [];
let $9f3b2ca04e3d8775$var$splatStack = [];
$9f3b2ca04e3d8775$var$pointers.push(new $9f3b2ca04e3d8775$var$pointerPrototype());
const { gl: $9f3b2ca04e3d8775$var$gl, ext: $9f3b2ca04e3d8775$var$ext } = $9f3b2ca04e3d8775$var$getWebGLContext($9f3b2ca04e3d8775$var$canvas);
if ($9f3b2ca04e3d8775$var$isMobile()) {
    $9f3b2ca04e3d8775$var$config.DYE_RESOLUTION = $9f3b2ca04e3d8775$var$config.MOBILE_DYE_RESOLUTION;
    $9f3b2ca04e3d8775$var$config.SIM_RESOLUTION = $9f3b2ca04e3d8775$var$config.MOBILE_SIM_RESOLUTION;
}
if (!$9f3b2ca04e3d8775$var$ext.supportLinearFiltering) {
    $9f3b2ca04e3d8775$var$config.DYE_RESOLUTION = $9f3b2ca04e3d8775$var$config.MOBILE_DYE_RESOLUTION;
    $9f3b2ca04e3d8775$var$config.SIM_RESOLUTION = $9f3b2ca04e3d8775$var$config.MOBILE_SIM_RESOLUTION;
    $9f3b2ca04e3d8775$var$config.SHADING = false;
    $9f3b2ca04e3d8775$var$config.BLOOM = false;
    $9f3b2ca04e3d8775$var$config.SUNRAYS = false;
}
function $9f3b2ca04e3d8775$var$getWebGLContext(canvas) {
    const params = {
        alpha: true,
        depth: false,
        stencil: false,
        antialias: false,
        preserveDrawingBuffer: false
    };
    let gl = canvas.getContext('webgl2', params);
    const isWebGL2 = !!gl;
    if (!isWebGL2) gl = canvas.getContext('webgl', params) || canvas.getContext('experimental-webgl', params);
    let halfFloat;
    let supportLinearFiltering;
    if (isWebGL2) {
        gl.getExtension('EXT_color_buffer_float');
        supportLinearFiltering = gl.getExtension('OES_texture_float_linear');
    } else {
        halfFloat = gl.getExtension('OES_texture_half_float');
        supportLinearFiltering = gl.getExtension('OES_texture_half_float_linear');
    }
    gl.clearColor(0.0, 0.0, 0.0, 1.0);
    const halfFloatTexType = isWebGL2 ? gl.HALF_FLOAT : halfFloat.HALF_FLOAT_OES;
    let formatRGBA;
    let formatRG;
    let formatR;
    if (isWebGL2) {
        formatRGBA = $9f3b2ca04e3d8775$var$getSupportedFormat(gl, gl.RGBA16F, gl.RGBA, halfFloatTexType);
        formatRG = $9f3b2ca04e3d8775$var$getSupportedFormat(gl, gl.RG16F, gl.RG, halfFloatTexType);
        formatR = $9f3b2ca04e3d8775$var$getSupportedFormat(gl, gl.R16F, gl.RED, halfFloatTexType);
    } else {
        formatRGBA = $9f3b2ca04e3d8775$var$getSupportedFormat(gl, gl.RGBA, gl.RGBA, halfFloatTexType);
        formatRG = $9f3b2ca04e3d8775$var$getSupportedFormat(gl, gl.RGBA, gl.RGBA, halfFloatTexType);
        formatR = $9f3b2ca04e3d8775$var$getSupportedFormat(gl, gl.RGBA, gl.RGBA, halfFloatTexType);
    }
    return {
        gl: gl,
        ext: {
            formatRGBA: formatRGBA,
            formatRG: formatRG,
            formatR: formatR,
            halfFloatTexType: halfFloatTexType,
            supportLinearFiltering: supportLinearFiltering
        }
    };
}
function $9f3b2ca04e3d8775$var$getSupportedFormat(gl, internalFormat, format, type) {
    if (!$9f3b2ca04e3d8775$var$supportRenderTextureFormat(gl, internalFormat, format, type)) switch(internalFormat){
        case gl.R16F:
            return $9f3b2ca04e3d8775$var$getSupportedFormat(gl, gl.RG16F, gl.RG, type);
        case gl.RG16F:
            return $9f3b2ca04e3d8775$var$getSupportedFormat(gl, gl.RGBA16F, gl.RGBA, type);
        default:
            return null;
    }
    return {
        internalFormat: internalFormat,
        format: format
    };
}
function $9f3b2ca04e3d8775$var$supportRenderTextureFormat(gl, internalFormat, format, type) {
    let texture = gl.createTexture();
    gl.bindTexture(gl.TEXTURE_2D, texture);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
    gl.texImage2D(gl.TEXTURE_2D, 0, internalFormat, 4, 4, 0, format, type, null);
    let fbo = gl.createFramebuffer();
    gl.bindFramebuffer(gl.FRAMEBUFFER, fbo);
    gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, texture, 0);
    const status = gl.checkFramebufferStatus(gl.FRAMEBUFFER);
    return status == gl.FRAMEBUFFER_COMPLETE;
}
function $9f3b2ca04e3d8775$var$isMobile() {
    return false; // @TODO
}
class $9f3b2ca04e3d8775$var$Material {
    constructor(vertexShader, fragmentShaderSource){
        this.vertexShader = vertexShader;
        this.fragmentShaderSource = fragmentShaderSource;
        this.programs = [];
        this.activeProgram = null;
        this.uniforms = [];
    }
    setKeywords(keywords) {
        let hash = 0;
        for(let i = 0; i < keywords.length; i++)hash += $9f3b2ca04e3d8775$var$hashCode(keywords[i]);
        let program = this.programs[hash];
        if (program == null) {
            let fragmentShader = $9f3b2ca04e3d8775$var$compileShader($9f3b2ca04e3d8775$var$gl.FRAGMENT_SHADER, this.fragmentShaderSource, keywords);
            program = $9f3b2ca04e3d8775$var$createProgram(this.vertexShader, fragmentShader);
            this.programs[hash] = program;
        }
        if (program == this.activeProgram) return;
        this.uniforms = $9f3b2ca04e3d8775$var$getUniforms(program);
        this.activeProgram = program;
    }
    bind() {
        $9f3b2ca04e3d8775$var$gl.useProgram(this.activeProgram);
    }
}
class $9f3b2ca04e3d8775$var$Program {
    constructor(vertexShader, fragmentShader){
        this.uniforms = {};
        this.program = $9f3b2ca04e3d8775$var$createProgram(vertexShader, fragmentShader);
        this.uniforms = $9f3b2ca04e3d8775$var$getUniforms(this.program);
    }
    bind() {
        $9f3b2ca04e3d8775$var$gl.useProgram(this.program);
    }
}
function $9f3b2ca04e3d8775$var$createProgram(vertexShader, fragmentShader) {
    let program = $9f3b2ca04e3d8775$var$gl.createProgram();
    $9f3b2ca04e3d8775$var$gl.attachShader(program, vertexShader);
    $9f3b2ca04e3d8775$var$gl.attachShader(program, fragmentShader);
    $9f3b2ca04e3d8775$var$gl.linkProgram(program);
    if (!$9f3b2ca04e3d8775$var$gl.getProgramParameter(program, $9f3b2ca04e3d8775$var$gl.LINK_STATUS)) throw $9f3b2ca04e3d8775$var$gl.getProgramInfoLog(program);
    return program;
}
function $9f3b2ca04e3d8775$var$getUniforms(program) {
    let uniforms = [];
    let uniformCount = $9f3b2ca04e3d8775$var$gl.getProgramParameter(program, $9f3b2ca04e3d8775$var$gl.ACTIVE_UNIFORMS);
    for(let i = 0; i < uniformCount; i++){
        let uniformName = $9f3b2ca04e3d8775$var$gl.getActiveUniform(program, i).name;
        uniforms[uniformName] = $9f3b2ca04e3d8775$var$gl.getUniformLocation(program, uniformName);
    }
    return uniforms;
}
function $9f3b2ca04e3d8775$var$compileShader(type, source, keywords) {
    source = $9f3b2ca04e3d8775$var$addKeywords(source, keywords);
    const shader = $9f3b2ca04e3d8775$var$gl.createShader(type);
    $9f3b2ca04e3d8775$var$gl.shaderSource(shader, source);
    $9f3b2ca04e3d8775$var$gl.compileShader(shader);
    if (!$9f3b2ca04e3d8775$var$gl.getShaderParameter(shader, $9f3b2ca04e3d8775$var$gl.COMPILE_STATUS)) throw $9f3b2ca04e3d8775$var$gl.getShaderInfoLog(shader);
    return shader;
}
function $9f3b2ca04e3d8775$var$addKeywords(source, keywords) {
    if (keywords == null) return source;
    let keywordsString = '';
    keywords.forEach((keyword)=>{
        keywordsString += '#define ' + keyword + '\n';
    });
    return keywordsString + source;
}
const $9f3b2ca04e3d8775$var$baseVertexShader = $9f3b2ca04e3d8775$var$compileShader($9f3b2ca04e3d8775$var$gl.VERTEX_SHADER, (0, (/*@__PURE__*/$parcel$interopDefault($b073ace211e07ca5$exports))));
const $9f3b2ca04e3d8775$var$blurVertexShader = $9f3b2ca04e3d8775$var$compileShader($9f3b2ca04e3d8775$var$gl.VERTEX_SHADER, (0, (/*@__PURE__*/$parcel$interopDefault($af22a45ee2cf3058$exports))));
const $9f3b2ca04e3d8775$var$blurShader = $9f3b2ca04e3d8775$var$compileShader($9f3b2ca04e3d8775$var$gl.FRAGMENT_SHADER, (0, (/*@__PURE__*/$parcel$interopDefault($9fe15e68bee46b24$exports))));
const $9f3b2ca04e3d8775$var$copyShader = $9f3b2ca04e3d8775$var$compileShader($9f3b2ca04e3d8775$var$gl.FRAGMENT_SHADER, (0, (/*@__PURE__*/$parcel$interopDefault($b2937d4c01081df9$exports))));
const $9f3b2ca04e3d8775$var$clearShader = $9f3b2ca04e3d8775$var$compileShader($9f3b2ca04e3d8775$var$gl.FRAGMENT_SHADER, (0, (/*@__PURE__*/$parcel$interopDefault($719ba1830217732e$exports))));
const $9f3b2ca04e3d8775$var$colorShader = $9f3b2ca04e3d8775$var$compileShader($9f3b2ca04e3d8775$var$gl.FRAGMENT_SHADER, (0, (/*@__PURE__*/$parcel$interopDefault($73744113a8abb7e1$exports))));
const $9f3b2ca04e3d8775$var$checkerboardShader = $9f3b2ca04e3d8775$var$compileShader($9f3b2ca04e3d8775$var$gl.FRAGMENT_SHADER, (0, (/*@__PURE__*/$parcel$interopDefault($abb988efd69fa6f6$exports))));
const $9f3b2ca04e3d8775$var$bloomPrefilterShader = $9f3b2ca04e3d8775$var$compileShader($9f3b2ca04e3d8775$var$gl.FRAGMENT_SHADER, (0, (/*@__PURE__*/$parcel$interopDefault($8f5fcad1063be82d$exports))));
const $9f3b2ca04e3d8775$var$bloomBlurShader = $9f3b2ca04e3d8775$var$compileShader($9f3b2ca04e3d8775$var$gl.FRAGMENT_SHADER, (0, (/*@__PURE__*/$parcel$interopDefault($a5ada04d393fb5d7$exports))));
const $9f3b2ca04e3d8775$var$bloomFinalShader = $9f3b2ca04e3d8775$var$compileShader($9f3b2ca04e3d8775$var$gl.FRAGMENT_SHADER, (0, (/*@__PURE__*/$parcel$interopDefault($1ef0e73bcc342f97$exports))));
const $9f3b2ca04e3d8775$var$sunraysMaskShader = $9f3b2ca04e3d8775$var$compileShader($9f3b2ca04e3d8775$var$gl.FRAGMENT_SHADER, (0, (/*@__PURE__*/$parcel$interopDefault($7a5947680249ab33$exports))));
const $9f3b2ca04e3d8775$var$sunraysShader = $9f3b2ca04e3d8775$var$compileShader($9f3b2ca04e3d8775$var$gl.FRAGMENT_SHADER, (0, (/*@__PURE__*/$parcel$interopDefault($4f387349a228c2dd$exports))));
const $9f3b2ca04e3d8775$var$splatShader = $9f3b2ca04e3d8775$var$compileShader($9f3b2ca04e3d8775$var$gl.FRAGMENT_SHADER, (0, (/*@__PURE__*/$parcel$interopDefault($3efa16d047bc35ee$exports))));
const $9f3b2ca04e3d8775$var$advectionShader = $9f3b2ca04e3d8775$var$compileShader($9f3b2ca04e3d8775$var$gl.FRAGMENT_SHADER, (0, (/*@__PURE__*/$parcel$interopDefault($993d5df17bfe8036$exports))), $9f3b2ca04e3d8775$var$ext.supportLinearFiltering ? null : [
    'MANUAL_FILTERING'
]);
const $9f3b2ca04e3d8775$var$divergenceShader = $9f3b2ca04e3d8775$var$compileShader($9f3b2ca04e3d8775$var$gl.FRAGMENT_SHADER, (0, (/*@__PURE__*/$parcel$interopDefault($d9cebc9ec9011904$exports))));
const $9f3b2ca04e3d8775$var$curlShader = $9f3b2ca04e3d8775$var$compileShader($9f3b2ca04e3d8775$var$gl.FRAGMENT_SHADER, (0, (/*@__PURE__*/$parcel$interopDefault($7c890988bafebabf$exports))));
const $9f3b2ca04e3d8775$var$vorticityShader = $9f3b2ca04e3d8775$var$compileShader($9f3b2ca04e3d8775$var$gl.FRAGMENT_SHADER, (0, (/*@__PURE__*/$parcel$interopDefault($70acace40d332cd0$exports))));
const $9f3b2ca04e3d8775$var$pressureShader = $9f3b2ca04e3d8775$var$compileShader($9f3b2ca04e3d8775$var$gl.FRAGMENT_SHADER, (0, (/*@__PURE__*/$parcel$interopDefault($6cca967b18c9fc9f$exports))));
const $9f3b2ca04e3d8775$var$gradientSubtractShader = $9f3b2ca04e3d8775$var$compileShader($9f3b2ca04e3d8775$var$gl.FRAGMENT_SHADER, (0, (/*@__PURE__*/$parcel$interopDefault($08cd69f8f5a4a380$exports))));
const $9f3b2ca04e3d8775$var$blit = (()=>{
    $9f3b2ca04e3d8775$var$gl.bindBuffer($9f3b2ca04e3d8775$var$gl.ARRAY_BUFFER, $9f3b2ca04e3d8775$var$gl.createBuffer());
    $9f3b2ca04e3d8775$var$gl.bufferData($9f3b2ca04e3d8775$var$gl.ARRAY_BUFFER, new Float32Array([
        -1,
        -1,
        -1,
        1,
        1,
        1,
        1,
        -1
    ]), $9f3b2ca04e3d8775$var$gl.STATIC_DRAW);
    $9f3b2ca04e3d8775$var$gl.bindBuffer($9f3b2ca04e3d8775$var$gl.ELEMENT_ARRAY_BUFFER, $9f3b2ca04e3d8775$var$gl.createBuffer());
    $9f3b2ca04e3d8775$var$gl.bufferData($9f3b2ca04e3d8775$var$gl.ELEMENT_ARRAY_BUFFER, new Uint16Array([
        0,
        1,
        2,
        0,
        2,
        3
    ]), $9f3b2ca04e3d8775$var$gl.STATIC_DRAW);
    $9f3b2ca04e3d8775$var$gl.vertexAttribPointer(0, 2, $9f3b2ca04e3d8775$var$gl.FLOAT, false, 0, 0);
    $9f3b2ca04e3d8775$var$gl.enableVertexAttribArray(0);
    return (destination)=>{
        $9f3b2ca04e3d8775$var$gl.bindFramebuffer($9f3b2ca04e3d8775$var$gl.FRAMEBUFFER, destination);
        $9f3b2ca04e3d8775$var$gl.drawElements($9f3b2ca04e3d8775$var$gl.TRIANGLES, 6, $9f3b2ca04e3d8775$var$gl.UNSIGNED_SHORT, 0);
    };
})();
let $9f3b2ca04e3d8775$var$dye;
let $9f3b2ca04e3d8775$var$velocity;
let $9f3b2ca04e3d8775$var$divergence;
let $9f3b2ca04e3d8775$var$curl;
let $9f3b2ca04e3d8775$var$pressure;
let $9f3b2ca04e3d8775$var$bloom;
let $9f3b2ca04e3d8775$var$bloomFramebuffers = [];
let $9f3b2ca04e3d8775$var$sunrays;
let $9f3b2ca04e3d8775$var$sunraysTemp;
let $9f3b2ca04e3d8775$var$ditheringTexture = $9f3b2ca04e3d8775$var$createTextureAsync((0, {}));
const $9f3b2ca04e3d8775$var$blurProgram = new $9f3b2ca04e3d8775$var$Program($9f3b2ca04e3d8775$var$blurVertexShader, $9f3b2ca04e3d8775$var$blurShader);
const $9f3b2ca04e3d8775$var$copyProgram = new $9f3b2ca04e3d8775$var$Program($9f3b2ca04e3d8775$var$baseVertexShader, $9f3b2ca04e3d8775$var$copyShader);
const $9f3b2ca04e3d8775$var$clearProgram = new $9f3b2ca04e3d8775$var$Program($9f3b2ca04e3d8775$var$baseVertexShader, $9f3b2ca04e3d8775$var$clearShader);
const $9f3b2ca04e3d8775$var$colorProgram = new $9f3b2ca04e3d8775$var$Program($9f3b2ca04e3d8775$var$baseVertexShader, $9f3b2ca04e3d8775$var$colorShader);
const $9f3b2ca04e3d8775$var$checkerboardProgram = new $9f3b2ca04e3d8775$var$Program($9f3b2ca04e3d8775$var$baseVertexShader, $9f3b2ca04e3d8775$var$checkerboardShader);
const $9f3b2ca04e3d8775$var$bloomPrefilterProgram = new $9f3b2ca04e3d8775$var$Program($9f3b2ca04e3d8775$var$baseVertexShader, $9f3b2ca04e3d8775$var$bloomPrefilterShader);
const $9f3b2ca04e3d8775$var$bloomBlurProgram = new $9f3b2ca04e3d8775$var$Program($9f3b2ca04e3d8775$var$baseVertexShader, $9f3b2ca04e3d8775$var$bloomBlurShader);
const $9f3b2ca04e3d8775$var$bloomFinalProgram = new $9f3b2ca04e3d8775$var$Program($9f3b2ca04e3d8775$var$baseVertexShader, $9f3b2ca04e3d8775$var$bloomFinalShader);
const $9f3b2ca04e3d8775$var$sunraysMaskProgram = new $9f3b2ca04e3d8775$var$Program($9f3b2ca04e3d8775$var$baseVertexShader, $9f3b2ca04e3d8775$var$sunraysMaskShader);
const $9f3b2ca04e3d8775$var$sunraysProgram = new $9f3b2ca04e3d8775$var$Program($9f3b2ca04e3d8775$var$baseVertexShader, $9f3b2ca04e3d8775$var$sunraysShader);
const $9f3b2ca04e3d8775$var$splatProgram = new $9f3b2ca04e3d8775$var$Program($9f3b2ca04e3d8775$var$baseVertexShader, $9f3b2ca04e3d8775$var$splatShader);
const $9f3b2ca04e3d8775$var$advectionProgram = new $9f3b2ca04e3d8775$var$Program($9f3b2ca04e3d8775$var$baseVertexShader, $9f3b2ca04e3d8775$var$advectionShader);
const $9f3b2ca04e3d8775$var$divergenceProgram = new $9f3b2ca04e3d8775$var$Program($9f3b2ca04e3d8775$var$baseVertexShader, $9f3b2ca04e3d8775$var$divergenceShader);
const $9f3b2ca04e3d8775$var$curlProgram = new $9f3b2ca04e3d8775$var$Program($9f3b2ca04e3d8775$var$baseVertexShader, $9f3b2ca04e3d8775$var$curlShader);
const $9f3b2ca04e3d8775$var$vorticityProgram = new $9f3b2ca04e3d8775$var$Program($9f3b2ca04e3d8775$var$baseVertexShader, $9f3b2ca04e3d8775$var$vorticityShader);
const $9f3b2ca04e3d8775$var$pressureProgram = new $9f3b2ca04e3d8775$var$Program($9f3b2ca04e3d8775$var$baseVertexShader, $9f3b2ca04e3d8775$var$pressureShader);
const $9f3b2ca04e3d8775$var$gradienSubtractProgram = new $9f3b2ca04e3d8775$var$Program($9f3b2ca04e3d8775$var$baseVertexShader, $9f3b2ca04e3d8775$var$gradientSubtractShader);
const $9f3b2ca04e3d8775$var$displayMaterial = new $9f3b2ca04e3d8775$var$Material($9f3b2ca04e3d8775$var$baseVertexShader, (0, (/*@__PURE__*/$parcel$interopDefault($91e81c3e9c7f71c0$exports))));
function $9f3b2ca04e3d8775$var$initFramebuffers() {
    let simRes = $9f3b2ca04e3d8775$var$getResolution($9f3b2ca04e3d8775$var$config.SIM_RESOLUTION);
    let dyeRes = $9f3b2ca04e3d8775$var$getResolution($9f3b2ca04e3d8775$var$config.DYE_RESOLUTION);
    const texType = $9f3b2ca04e3d8775$var$ext.halfFloatTexType;
    const rgba = $9f3b2ca04e3d8775$var$ext.formatRGBA;
    const rg = $9f3b2ca04e3d8775$var$ext.formatRG;
    const r = $9f3b2ca04e3d8775$var$ext.formatR;
    const filtering = $9f3b2ca04e3d8775$var$ext.supportLinearFiltering ? $9f3b2ca04e3d8775$var$gl.LINEAR : $9f3b2ca04e3d8775$var$gl.NEAREST;
    if ($9f3b2ca04e3d8775$var$dye == null) $9f3b2ca04e3d8775$var$dye = $9f3b2ca04e3d8775$var$createDoubleFBO(dyeRes.width, dyeRes.height, rgba.internalFormat, rgba.format, texType, filtering);
    else $9f3b2ca04e3d8775$var$dye = $9f3b2ca04e3d8775$var$resizeDoubleFBO($9f3b2ca04e3d8775$var$dye, dyeRes.width, dyeRes.height, rgba.internalFormat, rgba.format, texType, filtering);
    if ($9f3b2ca04e3d8775$var$velocity == null) $9f3b2ca04e3d8775$var$velocity = $9f3b2ca04e3d8775$var$createDoubleFBO(simRes.width, simRes.height, rg.internalFormat, rg.format, texType, filtering);
    else $9f3b2ca04e3d8775$var$velocity = $9f3b2ca04e3d8775$var$resizeDoubleFBO($9f3b2ca04e3d8775$var$velocity, simRes.width, simRes.height, rg.internalFormat, rg.format, texType, filtering);
    $9f3b2ca04e3d8775$var$divergence = $9f3b2ca04e3d8775$var$createFBO(simRes.width, simRes.height, r.internalFormat, r.format, texType, $9f3b2ca04e3d8775$var$gl.NEAREST);
    $9f3b2ca04e3d8775$var$curl = $9f3b2ca04e3d8775$var$createFBO(simRes.width, simRes.height, r.internalFormat, r.format, texType, $9f3b2ca04e3d8775$var$gl.NEAREST);
    $9f3b2ca04e3d8775$var$pressure = $9f3b2ca04e3d8775$var$createDoubleFBO(simRes.width, simRes.height, r.internalFormat, r.format, texType, $9f3b2ca04e3d8775$var$gl.NEAREST);
    $9f3b2ca04e3d8775$var$initBloomFramebuffers();
    $9f3b2ca04e3d8775$var$initSunraysFramebuffers();
}
function $9f3b2ca04e3d8775$var$initBloomFramebuffers() {
    let res = $9f3b2ca04e3d8775$var$getResolution($9f3b2ca04e3d8775$var$config.BLOOM_RESOLUTION);
    const texType = $9f3b2ca04e3d8775$var$ext.halfFloatTexType;
    const rgba = $9f3b2ca04e3d8775$var$ext.formatRGBA;
    const filtering = $9f3b2ca04e3d8775$var$ext.supportLinearFiltering ? $9f3b2ca04e3d8775$var$gl.LINEAR : $9f3b2ca04e3d8775$var$gl.NEAREST;
    $9f3b2ca04e3d8775$var$bloom = $9f3b2ca04e3d8775$var$createFBO(res.width, res.height, rgba.internalFormat, rgba.format, texType, filtering);
    $9f3b2ca04e3d8775$var$bloomFramebuffers.length = 0;
    for(let i = 0; i < $9f3b2ca04e3d8775$var$config.BLOOM_ITERATIONS; i++){
        let width = res.width >> i + 1;
        let height = res.height >> i + 1;
        if (width < 2 || height < 2) break;
        let fbo = $9f3b2ca04e3d8775$var$createFBO(width, height, rgba.internalFormat, rgba.format, texType, filtering);
        $9f3b2ca04e3d8775$var$bloomFramebuffers.push(fbo);
    }
}
function $9f3b2ca04e3d8775$var$initSunraysFramebuffers() {
    let res = $9f3b2ca04e3d8775$var$getResolution($9f3b2ca04e3d8775$var$config.SUNRAYS_RESOLUTION);
    const texType = $9f3b2ca04e3d8775$var$ext.halfFloatTexType;
    const r = $9f3b2ca04e3d8775$var$ext.formatR;
    const filtering = $9f3b2ca04e3d8775$var$ext.supportLinearFiltering ? $9f3b2ca04e3d8775$var$gl.LINEAR : $9f3b2ca04e3d8775$var$gl.NEAREST;
    $9f3b2ca04e3d8775$var$sunrays = $9f3b2ca04e3d8775$var$createFBO(res.width, res.height, r.internalFormat, r.format, texType, filtering);
    $9f3b2ca04e3d8775$var$sunraysTemp = $9f3b2ca04e3d8775$var$createFBO(res.width, res.height, r.internalFormat, r.format, texType, filtering);
}
function $9f3b2ca04e3d8775$var$createFBO(w, h, internalFormat, format, type, param) {
    $9f3b2ca04e3d8775$var$gl.activeTexture($9f3b2ca04e3d8775$var$gl.TEXTURE0);
    let texture = $9f3b2ca04e3d8775$var$gl.createTexture();
    $9f3b2ca04e3d8775$var$gl.bindTexture($9f3b2ca04e3d8775$var$gl.TEXTURE_2D, texture);
    $9f3b2ca04e3d8775$var$gl.texParameteri($9f3b2ca04e3d8775$var$gl.TEXTURE_2D, $9f3b2ca04e3d8775$var$gl.TEXTURE_MIN_FILTER, param);
    $9f3b2ca04e3d8775$var$gl.texParameteri($9f3b2ca04e3d8775$var$gl.TEXTURE_2D, $9f3b2ca04e3d8775$var$gl.TEXTURE_MAG_FILTER, param);
    $9f3b2ca04e3d8775$var$gl.texParameteri($9f3b2ca04e3d8775$var$gl.TEXTURE_2D, $9f3b2ca04e3d8775$var$gl.TEXTURE_WRAP_S, $9f3b2ca04e3d8775$var$gl.CLAMP_TO_EDGE);
    $9f3b2ca04e3d8775$var$gl.texParameteri($9f3b2ca04e3d8775$var$gl.TEXTURE_2D, $9f3b2ca04e3d8775$var$gl.TEXTURE_WRAP_T, $9f3b2ca04e3d8775$var$gl.CLAMP_TO_EDGE);
    $9f3b2ca04e3d8775$var$gl.texImage2D($9f3b2ca04e3d8775$var$gl.TEXTURE_2D, 0, internalFormat, w, h, 0, format, type, null);
    let fbo = $9f3b2ca04e3d8775$var$gl.createFramebuffer();
    $9f3b2ca04e3d8775$var$gl.bindFramebuffer($9f3b2ca04e3d8775$var$gl.FRAMEBUFFER, fbo);
    $9f3b2ca04e3d8775$var$gl.framebufferTexture2D($9f3b2ca04e3d8775$var$gl.FRAMEBUFFER, $9f3b2ca04e3d8775$var$gl.COLOR_ATTACHMENT0, $9f3b2ca04e3d8775$var$gl.TEXTURE_2D, texture, 0);
    $9f3b2ca04e3d8775$var$gl.viewport(0, 0, w, h);
    $9f3b2ca04e3d8775$var$gl.clear($9f3b2ca04e3d8775$var$gl.COLOR_BUFFER_BIT);
    let texelSizeX = 1.0 / w;
    let texelSizeY = 1.0 / h;
    return {
        texture: texture,
        fbo: fbo,
        width: w,
        height: h,
        texelSizeX: texelSizeX,
        texelSizeY: texelSizeY,
        attach (id) {
            $9f3b2ca04e3d8775$var$gl.activeTexture($9f3b2ca04e3d8775$var$gl.TEXTURE0 + id);
            $9f3b2ca04e3d8775$var$gl.bindTexture($9f3b2ca04e3d8775$var$gl.TEXTURE_2D, texture);
            return id;
        }
    };
}
function $9f3b2ca04e3d8775$var$createDoubleFBO(w, h, internalFormat, format, type, param) {
    let fbo1 = $9f3b2ca04e3d8775$var$createFBO(w, h, internalFormat, format, type, param);
    let fbo2 = $9f3b2ca04e3d8775$var$createFBO(w, h, internalFormat, format, type, param);
    return {
        width: w,
        height: h,
        texelSizeX: fbo1.texelSizeX,
        texelSizeY: fbo1.texelSizeY,
        get read () {
            return fbo1;
        },
        set read (value){
            fbo1 = value;
        },
        get write () {
            return fbo2;
        },
        set write (value){
            fbo2 = value;
        },
        swap () {
            let temp = fbo1;
            fbo1 = fbo2;
            fbo2 = temp;
        }
    };
}
function $9f3b2ca04e3d8775$var$resizeFBO(target, w, h, internalFormat, format, type, param) {
    let newFBO = $9f3b2ca04e3d8775$var$createFBO(w, h, internalFormat, format, type, param);
    $9f3b2ca04e3d8775$var$copyProgram.bind();
    $9f3b2ca04e3d8775$var$gl.uniform1i($9f3b2ca04e3d8775$var$copyProgram.uniforms.uTexture, target.attach(0));
    $9f3b2ca04e3d8775$var$blit(newFBO.fbo);
    return newFBO;
}
function $9f3b2ca04e3d8775$var$resizeDoubleFBO(target, w, h, internalFormat, format, type, param) {
    if (target.width == w && target.height == h) return target;
    target.read = $9f3b2ca04e3d8775$var$resizeFBO(target.read, w, h, internalFormat, format, type, param);
    target.write = $9f3b2ca04e3d8775$var$createFBO(w, h, internalFormat, format, type, param);
    target.width = w;
    target.height = h;
    target.texelSizeX = 1.0 / w;
    target.texelSizeY = 1.0 / h;
    return target;
}
function $9f3b2ca04e3d8775$var$createTextureAsync(url) {
    let texture = $9f3b2ca04e3d8775$var$gl.createTexture();
    $9f3b2ca04e3d8775$var$gl.bindTexture($9f3b2ca04e3d8775$var$gl.TEXTURE_2D, texture);
    $9f3b2ca04e3d8775$var$gl.texParameteri($9f3b2ca04e3d8775$var$gl.TEXTURE_2D, $9f3b2ca04e3d8775$var$gl.TEXTURE_MIN_FILTER, $9f3b2ca04e3d8775$var$gl.LINEAR);
    $9f3b2ca04e3d8775$var$gl.texParameteri($9f3b2ca04e3d8775$var$gl.TEXTURE_2D, $9f3b2ca04e3d8775$var$gl.TEXTURE_MAG_FILTER, $9f3b2ca04e3d8775$var$gl.LINEAR);
    $9f3b2ca04e3d8775$var$gl.texParameteri($9f3b2ca04e3d8775$var$gl.TEXTURE_2D, $9f3b2ca04e3d8775$var$gl.TEXTURE_WRAP_S, $9f3b2ca04e3d8775$var$gl.REPEAT);
    $9f3b2ca04e3d8775$var$gl.texParameteri($9f3b2ca04e3d8775$var$gl.TEXTURE_2D, $9f3b2ca04e3d8775$var$gl.TEXTURE_WRAP_T, $9f3b2ca04e3d8775$var$gl.REPEAT);
    $9f3b2ca04e3d8775$var$gl.texImage2D($9f3b2ca04e3d8775$var$gl.TEXTURE_2D, 0, $9f3b2ca04e3d8775$var$gl.RGB, 1, 1, 0, $9f3b2ca04e3d8775$var$gl.RGB, $9f3b2ca04e3d8775$var$gl.UNSIGNED_BYTE, new Uint8Array([
        255,
        255,
        255
    ]));
    let obj = {
        texture: texture,
        width: 1,
        height: 1,
        attach (id) {
            $9f3b2ca04e3d8775$var$gl.activeTexture($9f3b2ca04e3d8775$var$gl.TEXTURE0 + id);
            $9f3b2ca04e3d8775$var$gl.bindTexture($9f3b2ca04e3d8775$var$gl.TEXTURE_2D, texture);
            return id;
        }
    };
    let image = new Image();
    image.onload = ()=>{
        obj.width = image.width;
        obj.height = image.height;
        $9f3b2ca04e3d8775$var$gl.bindTexture($9f3b2ca04e3d8775$var$gl.TEXTURE_2D, texture);
        $9f3b2ca04e3d8775$var$gl.texImage2D($9f3b2ca04e3d8775$var$gl.TEXTURE_2D, 0, $9f3b2ca04e3d8775$var$gl.RGB, $9f3b2ca04e3d8775$var$gl.RGB, $9f3b2ca04e3d8775$var$gl.UNSIGNED_BYTE, image);
    };
    image.src = url;
    return obj;
}
function $9f3b2ca04e3d8775$var$updateKeywords() {
    let displayKeywords = [];
    if ($9f3b2ca04e3d8775$var$config.SHADING) displayKeywords.push("SHADING");
    if ($9f3b2ca04e3d8775$var$config.BLOOM) displayKeywords.push("BLOOM");
    if ($9f3b2ca04e3d8775$var$config.SUNRAYS) displayKeywords.push("SUNRAYS");
    $9f3b2ca04e3d8775$var$displayMaterial.setKeywords(displayKeywords);
}
$9f3b2ca04e3d8775$var$updateKeywords();
$9f3b2ca04e3d8775$var$initFramebuffers();
//multipleSplats(parseInt(Math.random() * 20) + 5);
let $9f3b2ca04e3d8775$var$lastUpdateTime = Date.now();
let $9f3b2ca04e3d8775$var$colorUpdateTimer = 0.0;
window.fluidHasStarted = false;
function $9f3b2ca04e3d8775$var$randomSplatsNow(num) {
    $9f3b2ca04e3d8775$var$multipleSplats(Math.floor(num));
}
function $9f3b2ca04e3d8775$var$startFluid() {
    if (window.fluidHasStarted) return;
    else window.fluidHasStarted = true;
    $9f3b2ca04e3d8775$var$initFramebuffers();
    $9f3b2ca04e3d8775$var$lastUpdateTime = Date.now();
    $9f3b2ca04e3d8775$var$colorUpdateTimer = 0.0;
    $9f3b2ca04e3d8775$var$update();
}
$9f3b2ca04e3d8775$var$startFluid();
function $9f3b2ca04e3d8775$var$update() {
    const dt = $9f3b2ca04e3d8775$var$calcDeltaTime();
    if ($9f3b2ca04e3d8775$var$resizeCanvas() || $9f3b2ca04e3d8775$var$config.doReinitFramebuffers) {
        $9f3b2ca04e3d8775$var$config.doReinitFramebuffers = false;
        $9f3b2ca04e3d8775$var$initFramebuffers();
    }
    $9f3b2ca04e3d8775$var$updateColors(dt);
    $9f3b2ca04e3d8775$var$applyInputs();
    if (!$9f3b2ca04e3d8775$var$config.PAUSED) $9f3b2ca04e3d8775$var$step(dt);
    $9f3b2ca04e3d8775$var$render(null);
    requestAnimationFrame($9f3b2ca04e3d8775$var$update);
}
function $9f3b2ca04e3d8775$var$calcDeltaTime() {
    let now = Date.now();
    let dt = (now - $9f3b2ca04e3d8775$var$lastUpdateTime) / 1000;
    dt = Math.min(dt, 0.016666);
    $9f3b2ca04e3d8775$var$lastUpdateTime = now;
    return dt;
}
function $9f3b2ca04e3d8775$var$resizeCanvas() {
    //console.log("Resizing canvas, ", canvas.clientWidth, canvas.clientHeight);
    let width = $9f3b2ca04e3d8775$var$scaleByPixelRatio($9f3b2ca04e3d8775$var$canvas.clientWidth);
    let height = $9f3b2ca04e3d8775$var$scaleByPixelRatio($9f3b2ca04e3d8775$var$canvas.clientHeight);
    //console.log("Resized canvas, ", width, height);
    if ($9f3b2ca04e3d8775$var$canvas.width != width || $9f3b2ca04e3d8775$var$canvas.height != height) {
        $9f3b2ca04e3d8775$var$canvas.width = width;
        $9f3b2ca04e3d8775$var$canvas.height = height;
        return true;
    }
    return false;
}
function $9f3b2ca04e3d8775$var$updateColors(dt) {
    if (!$9f3b2ca04e3d8775$var$config.COLORFUL) return;
    $9f3b2ca04e3d8775$var$colorUpdateTimer += dt * $9f3b2ca04e3d8775$var$config.COLOR_UPDATE_SPEED;
    if ($9f3b2ca04e3d8775$var$colorUpdateTimer >= 1) {
        $9f3b2ca04e3d8775$var$colorUpdateTimer = $9f3b2ca04e3d8775$var$wrap($9f3b2ca04e3d8775$var$colorUpdateTimer, 0, 1);
        $9f3b2ca04e3d8775$var$pointers.forEach((p)=>{
            p.color = $9f3b2ca04e3d8775$var$generateColor();
        });
    }
}
function $9f3b2ca04e3d8775$var$applyInputs() {
    if ($9f3b2ca04e3d8775$var$splatStack.length > 0) $9f3b2ca04e3d8775$var$multipleSplats($9f3b2ca04e3d8775$var$splatStack.pop());
    $9f3b2ca04e3d8775$var$pointers.forEach((p)=>{
        if (p.moved) {
            p.moved = false;
            $9f3b2ca04e3d8775$var$send_splatPointer(p);
        }
    });
}
function $9f3b2ca04e3d8775$var$step(dt) {
    $9f3b2ca04e3d8775$var$gl.disable($9f3b2ca04e3d8775$var$gl.BLEND);
    $9f3b2ca04e3d8775$var$gl.viewport(0, 0, $9f3b2ca04e3d8775$var$velocity.width, $9f3b2ca04e3d8775$var$velocity.height);
    $9f3b2ca04e3d8775$var$curlProgram.bind();
    $9f3b2ca04e3d8775$var$gl.uniform2f($9f3b2ca04e3d8775$var$curlProgram.uniforms.texelSize, $9f3b2ca04e3d8775$var$velocity.texelSizeX, $9f3b2ca04e3d8775$var$velocity.texelSizeY);
    $9f3b2ca04e3d8775$var$gl.uniform1i($9f3b2ca04e3d8775$var$curlProgram.uniforms.uVelocity, $9f3b2ca04e3d8775$var$velocity.read.attach(0));
    $9f3b2ca04e3d8775$var$blit($9f3b2ca04e3d8775$var$curl.fbo);
    $9f3b2ca04e3d8775$var$vorticityProgram.bind();
    $9f3b2ca04e3d8775$var$gl.uniform2f($9f3b2ca04e3d8775$var$vorticityProgram.uniforms.texelSize, $9f3b2ca04e3d8775$var$velocity.texelSizeX, $9f3b2ca04e3d8775$var$velocity.texelSizeY);
    $9f3b2ca04e3d8775$var$gl.uniform1i($9f3b2ca04e3d8775$var$vorticityProgram.uniforms.uVelocity, $9f3b2ca04e3d8775$var$velocity.read.attach(0));
    $9f3b2ca04e3d8775$var$gl.uniform1i($9f3b2ca04e3d8775$var$vorticityProgram.uniforms.uCurl, $9f3b2ca04e3d8775$var$curl.attach(1));
    $9f3b2ca04e3d8775$var$gl.uniform1f($9f3b2ca04e3d8775$var$vorticityProgram.uniforms.curl, $9f3b2ca04e3d8775$var$config.CURL);
    $9f3b2ca04e3d8775$var$gl.uniform1f($9f3b2ca04e3d8775$var$vorticityProgram.uniforms.dt, dt);
    $9f3b2ca04e3d8775$var$blit($9f3b2ca04e3d8775$var$velocity.write.fbo);
    $9f3b2ca04e3d8775$var$velocity.swap();
    $9f3b2ca04e3d8775$var$divergenceProgram.bind();
    $9f3b2ca04e3d8775$var$gl.uniform2f($9f3b2ca04e3d8775$var$divergenceProgram.uniforms.texelSize, $9f3b2ca04e3d8775$var$velocity.texelSizeX, $9f3b2ca04e3d8775$var$velocity.texelSizeY);
    $9f3b2ca04e3d8775$var$gl.uniform1i($9f3b2ca04e3d8775$var$divergenceProgram.uniforms.uVelocity, $9f3b2ca04e3d8775$var$velocity.read.attach(0));
    $9f3b2ca04e3d8775$var$blit($9f3b2ca04e3d8775$var$divergence.fbo);
    $9f3b2ca04e3d8775$var$clearProgram.bind();
    $9f3b2ca04e3d8775$var$gl.uniform1i($9f3b2ca04e3d8775$var$clearProgram.uniforms.uTexture, $9f3b2ca04e3d8775$var$pressure.read.attach(0));
    $9f3b2ca04e3d8775$var$gl.uniform1f($9f3b2ca04e3d8775$var$clearProgram.uniforms.value, $9f3b2ca04e3d8775$var$config.PRESSURE);
    $9f3b2ca04e3d8775$var$blit($9f3b2ca04e3d8775$var$pressure.write.fbo);
    $9f3b2ca04e3d8775$var$pressure.swap();
    $9f3b2ca04e3d8775$var$pressureProgram.bind();
    $9f3b2ca04e3d8775$var$gl.uniform2f($9f3b2ca04e3d8775$var$pressureProgram.uniforms.texelSize, $9f3b2ca04e3d8775$var$velocity.texelSizeX, $9f3b2ca04e3d8775$var$velocity.texelSizeY);
    $9f3b2ca04e3d8775$var$gl.uniform1i($9f3b2ca04e3d8775$var$pressureProgram.uniforms.uDivergence, $9f3b2ca04e3d8775$var$divergence.attach(0));
    for(let i = 0; i < $9f3b2ca04e3d8775$var$config.PRESSURE_ITERATIONS; i++){
        $9f3b2ca04e3d8775$var$gl.uniform1i($9f3b2ca04e3d8775$var$pressureProgram.uniforms.uPressure, $9f3b2ca04e3d8775$var$pressure.read.attach(1));
        $9f3b2ca04e3d8775$var$blit($9f3b2ca04e3d8775$var$pressure.write.fbo);
        $9f3b2ca04e3d8775$var$pressure.swap();
    }
    $9f3b2ca04e3d8775$var$gradienSubtractProgram.bind();
    $9f3b2ca04e3d8775$var$gl.uniform2f($9f3b2ca04e3d8775$var$gradienSubtractProgram.uniforms.texelSize, $9f3b2ca04e3d8775$var$velocity.texelSizeX, $9f3b2ca04e3d8775$var$velocity.texelSizeY);
    $9f3b2ca04e3d8775$var$gl.uniform1i($9f3b2ca04e3d8775$var$gradienSubtractProgram.uniforms.uPressure, $9f3b2ca04e3d8775$var$pressure.read.attach(0));
    $9f3b2ca04e3d8775$var$gl.uniform1i($9f3b2ca04e3d8775$var$gradienSubtractProgram.uniforms.uVelocity, $9f3b2ca04e3d8775$var$velocity.read.attach(1));
    $9f3b2ca04e3d8775$var$blit($9f3b2ca04e3d8775$var$velocity.write.fbo);
    $9f3b2ca04e3d8775$var$velocity.swap();
    $9f3b2ca04e3d8775$var$advectionProgram.bind();
    $9f3b2ca04e3d8775$var$gl.uniform2f($9f3b2ca04e3d8775$var$advectionProgram.uniforms.texelSize, $9f3b2ca04e3d8775$var$velocity.texelSizeX, $9f3b2ca04e3d8775$var$velocity.texelSizeY);
    if (!$9f3b2ca04e3d8775$var$ext.supportLinearFiltering) $9f3b2ca04e3d8775$var$gl.uniform2f($9f3b2ca04e3d8775$var$advectionProgram.uniforms.dyeTexelSize, $9f3b2ca04e3d8775$var$velocity.texelSizeX, $9f3b2ca04e3d8775$var$velocity.texelSizeY);
    let velocityId = $9f3b2ca04e3d8775$var$velocity.read.attach(0);
    $9f3b2ca04e3d8775$var$gl.uniform1i($9f3b2ca04e3d8775$var$advectionProgram.uniforms.uVelocity, velocityId);
    $9f3b2ca04e3d8775$var$gl.uniform1i($9f3b2ca04e3d8775$var$advectionProgram.uniforms.uSource, velocityId);
    $9f3b2ca04e3d8775$var$gl.uniform1f($9f3b2ca04e3d8775$var$advectionProgram.uniforms.dt, dt);
    $9f3b2ca04e3d8775$var$gl.uniform1f($9f3b2ca04e3d8775$var$advectionProgram.uniforms.dissipation, $9f3b2ca04e3d8775$var$config.VELOCITY_DISSIPATION);
    $9f3b2ca04e3d8775$var$blit($9f3b2ca04e3d8775$var$velocity.write.fbo);
    $9f3b2ca04e3d8775$var$velocity.swap();
    $9f3b2ca04e3d8775$var$gl.viewport(0, 0, $9f3b2ca04e3d8775$var$dye.width, $9f3b2ca04e3d8775$var$dye.height);
    if (!$9f3b2ca04e3d8775$var$ext.supportLinearFiltering) $9f3b2ca04e3d8775$var$gl.uniform2f($9f3b2ca04e3d8775$var$advectionProgram.uniforms.dyeTexelSize, $9f3b2ca04e3d8775$var$dye.texelSizeX, $9f3b2ca04e3d8775$var$dye.texelSizeY);
    $9f3b2ca04e3d8775$var$gl.uniform1i($9f3b2ca04e3d8775$var$advectionProgram.uniforms.uVelocity, $9f3b2ca04e3d8775$var$velocity.read.attach(0));
    $9f3b2ca04e3d8775$var$gl.uniform1i($9f3b2ca04e3d8775$var$advectionProgram.uniforms.uSource, $9f3b2ca04e3d8775$var$dye.read.attach(1));
    $9f3b2ca04e3d8775$var$gl.uniform1f($9f3b2ca04e3d8775$var$advectionProgram.uniforms.dissipation, $9f3b2ca04e3d8775$var$config.DENSITY_DISSIPATION);
    $9f3b2ca04e3d8775$var$blit($9f3b2ca04e3d8775$var$dye.write.fbo);
    $9f3b2ca04e3d8775$var$dye.swap();
}
function $9f3b2ca04e3d8775$var$render(target) {
    if ($9f3b2ca04e3d8775$var$config.BLOOM) $9f3b2ca04e3d8775$var$applyBloom($9f3b2ca04e3d8775$var$dye.read, $9f3b2ca04e3d8775$var$bloom);
    if ($9f3b2ca04e3d8775$var$config.SUNRAYS) {
        $9f3b2ca04e3d8775$var$applySunrays($9f3b2ca04e3d8775$var$dye.read, $9f3b2ca04e3d8775$var$dye.write, $9f3b2ca04e3d8775$var$sunrays);
        $9f3b2ca04e3d8775$var$blur($9f3b2ca04e3d8775$var$sunrays, $9f3b2ca04e3d8775$var$sunraysTemp, 1);
    }
    if (target == null || !$9f3b2ca04e3d8775$var$config.TRANSPARENT) {
        $9f3b2ca04e3d8775$var$gl.blendFunc($9f3b2ca04e3d8775$var$gl.ONE, $9f3b2ca04e3d8775$var$gl.ONE_MINUS_SRC_ALPHA);
        $9f3b2ca04e3d8775$var$gl.enable($9f3b2ca04e3d8775$var$gl.BLEND);
    } else $9f3b2ca04e3d8775$var$gl.disable($9f3b2ca04e3d8775$var$gl.BLEND);
    let width = target == null ? $9f3b2ca04e3d8775$var$gl.drawingBufferWidth : target.width;
    let height = target == null ? $9f3b2ca04e3d8775$var$gl.drawingBufferHeight : target.height;
    $9f3b2ca04e3d8775$var$gl.viewport(0, 0, width, height);
    let fbo = target == null ? null : target.fbo;
    if (!$9f3b2ca04e3d8775$var$config.TRANSPARENT) $9f3b2ca04e3d8775$var$drawColor(fbo, $9f3b2ca04e3d8775$var$normalizeColor($9f3b2ca04e3d8775$var$config.BACK_COLOR));
    //if (target == null && config.TRANSPARENT)
    //    drawCheckerboard(fbo);
    $9f3b2ca04e3d8775$var$drawDisplay(fbo, width, height);
}
function $9f3b2ca04e3d8775$var$drawColor(fbo, color) {
    $9f3b2ca04e3d8775$var$colorProgram.bind();
    $9f3b2ca04e3d8775$var$gl.uniform4f($9f3b2ca04e3d8775$var$colorProgram.uniforms.color, color.r, color.g, color.b, 1);
    $9f3b2ca04e3d8775$var$blit(fbo);
}
function $9f3b2ca04e3d8775$var$drawCheckerboard(fbo) {
    $9f3b2ca04e3d8775$var$checkerboardProgram.bind();
    $9f3b2ca04e3d8775$var$gl.uniform1f($9f3b2ca04e3d8775$var$checkerboardProgram.uniforms.aspectRatio, $9f3b2ca04e3d8775$var$canvas.width / $9f3b2ca04e3d8775$var$canvas.height);
    $9f3b2ca04e3d8775$var$blit(fbo);
}
function $9f3b2ca04e3d8775$var$drawDisplay(fbo, width, height) {
    $9f3b2ca04e3d8775$var$displayMaterial.bind();
    if ($9f3b2ca04e3d8775$var$config.SHADING) $9f3b2ca04e3d8775$var$gl.uniform2f($9f3b2ca04e3d8775$var$displayMaterial.uniforms.texelSize, 1.0 / width, 1.0 / height);
    $9f3b2ca04e3d8775$var$gl.uniform1i($9f3b2ca04e3d8775$var$displayMaterial.uniforms.uTexture, $9f3b2ca04e3d8775$var$dye.read.attach(0));
    if ($9f3b2ca04e3d8775$var$config.BLOOM) {
        $9f3b2ca04e3d8775$var$gl.uniform1i($9f3b2ca04e3d8775$var$displayMaterial.uniforms.uBloom, $9f3b2ca04e3d8775$var$bloom.attach(1));
        $9f3b2ca04e3d8775$var$gl.uniform1i($9f3b2ca04e3d8775$var$displayMaterial.uniforms.uDithering, $9f3b2ca04e3d8775$var$ditheringTexture.attach(2));
        let scale = $9f3b2ca04e3d8775$var$getTextureScale($9f3b2ca04e3d8775$var$ditheringTexture, width, height);
        $9f3b2ca04e3d8775$var$gl.uniform2f($9f3b2ca04e3d8775$var$displayMaterial.uniforms.ditherScale, scale.x, scale.y);
    }
    if ($9f3b2ca04e3d8775$var$config.SUNRAYS) $9f3b2ca04e3d8775$var$gl.uniform1i($9f3b2ca04e3d8775$var$displayMaterial.uniforms.uSunrays, $9f3b2ca04e3d8775$var$sunrays.attach(3));
    $9f3b2ca04e3d8775$var$blit(fbo);
}
function $9f3b2ca04e3d8775$var$applyBloom(source, destination) {
    if ($9f3b2ca04e3d8775$var$bloomFramebuffers.length < 2) return;
    let last = destination;
    $9f3b2ca04e3d8775$var$gl.disable($9f3b2ca04e3d8775$var$gl.BLEND);
    $9f3b2ca04e3d8775$var$bloomPrefilterProgram.bind();
    let knee = $9f3b2ca04e3d8775$var$config.BLOOM_THRESHOLD * $9f3b2ca04e3d8775$var$config.BLOOM_SOFT_KNEE + 0.0001;
    let curve0 = $9f3b2ca04e3d8775$var$config.BLOOM_THRESHOLD - knee;
    let curve1 = knee * 2;
    let curve2 = 0.25 / knee;
    $9f3b2ca04e3d8775$var$gl.uniform3f($9f3b2ca04e3d8775$var$bloomPrefilterProgram.uniforms.curve, curve0, curve1, curve2);
    $9f3b2ca04e3d8775$var$gl.uniform1f($9f3b2ca04e3d8775$var$bloomPrefilterProgram.uniforms.threshold, $9f3b2ca04e3d8775$var$config.BLOOM_THRESHOLD);
    $9f3b2ca04e3d8775$var$gl.uniform1i($9f3b2ca04e3d8775$var$bloomPrefilterProgram.uniforms.uTexture, source.attach(0));
    $9f3b2ca04e3d8775$var$gl.viewport(0, 0, last.width, last.height);
    $9f3b2ca04e3d8775$var$blit(last.fbo);
    $9f3b2ca04e3d8775$var$bloomBlurProgram.bind();
    for(let i = 0; i < $9f3b2ca04e3d8775$var$bloomFramebuffers.length; i++){
        let dest = $9f3b2ca04e3d8775$var$bloomFramebuffers[i];
        $9f3b2ca04e3d8775$var$gl.uniform2f($9f3b2ca04e3d8775$var$bloomBlurProgram.uniforms.texelSize, last.texelSizeX, last.texelSizeY);
        $9f3b2ca04e3d8775$var$gl.uniform1i($9f3b2ca04e3d8775$var$bloomBlurProgram.uniforms.uTexture, last.attach(0));
        $9f3b2ca04e3d8775$var$gl.viewport(0, 0, dest.width, dest.height);
        $9f3b2ca04e3d8775$var$blit(dest.fbo);
        last = dest;
    }
    $9f3b2ca04e3d8775$var$gl.blendFunc($9f3b2ca04e3d8775$var$gl.ONE, $9f3b2ca04e3d8775$var$gl.ONE);
    $9f3b2ca04e3d8775$var$gl.enable($9f3b2ca04e3d8775$var$gl.BLEND);
    for(let i = $9f3b2ca04e3d8775$var$bloomFramebuffers.length - 2; i >= 0; i--){
        let baseTex = $9f3b2ca04e3d8775$var$bloomFramebuffers[i];
        $9f3b2ca04e3d8775$var$gl.uniform2f($9f3b2ca04e3d8775$var$bloomBlurProgram.uniforms.texelSize, last.texelSizeX, last.texelSizeY);
        $9f3b2ca04e3d8775$var$gl.uniform1i($9f3b2ca04e3d8775$var$bloomBlurProgram.uniforms.uTexture, last.attach(0));
        $9f3b2ca04e3d8775$var$gl.viewport(0, 0, baseTex.width, baseTex.height);
        $9f3b2ca04e3d8775$var$blit(baseTex.fbo);
        last = baseTex;
    }
    $9f3b2ca04e3d8775$var$gl.disable($9f3b2ca04e3d8775$var$gl.BLEND);
    $9f3b2ca04e3d8775$var$bloomFinalProgram.bind();
    $9f3b2ca04e3d8775$var$gl.uniform2f($9f3b2ca04e3d8775$var$bloomFinalProgram.uniforms.texelSize, last.texelSizeX, last.texelSizeY);
    $9f3b2ca04e3d8775$var$gl.uniform1i($9f3b2ca04e3d8775$var$bloomFinalProgram.uniforms.uTexture, last.attach(0));
    $9f3b2ca04e3d8775$var$gl.uniform1f($9f3b2ca04e3d8775$var$bloomFinalProgram.uniforms.intensity, $9f3b2ca04e3d8775$var$config.BLOOM_INTENSITY);
    $9f3b2ca04e3d8775$var$gl.viewport(0, 0, destination.width, destination.height);
    $9f3b2ca04e3d8775$var$blit(destination.fbo);
}
function $9f3b2ca04e3d8775$var$applySunrays(source, mask, destination) {
    $9f3b2ca04e3d8775$var$gl.disable($9f3b2ca04e3d8775$var$gl.BLEND);
    $9f3b2ca04e3d8775$var$sunraysMaskProgram.bind();
    $9f3b2ca04e3d8775$var$gl.uniform1i($9f3b2ca04e3d8775$var$sunraysMaskProgram.uniforms.uTexture, source.attach(0));
    $9f3b2ca04e3d8775$var$gl.viewport(0, 0, mask.width, mask.height);
    $9f3b2ca04e3d8775$var$blit(mask.fbo);
    $9f3b2ca04e3d8775$var$sunraysProgram.bind();
    $9f3b2ca04e3d8775$var$gl.uniform1f($9f3b2ca04e3d8775$var$sunraysProgram.uniforms.weight, $9f3b2ca04e3d8775$var$config.SUNRAYS_WEIGHT);
    $9f3b2ca04e3d8775$var$gl.uniform1i($9f3b2ca04e3d8775$var$sunraysProgram.uniforms.uTexture, mask.attach(0));
    $9f3b2ca04e3d8775$var$gl.viewport(0, 0, destination.width, destination.height);
    $9f3b2ca04e3d8775$var$blit(destination.fbo);
}
function $9f3b2ca04e3d8775$var$blur(target, temp, iterations) {
    $9f3b2ca04e3d8775$var$blurProgram.bind();
    for(let i = 0; i < iterations; i++){
        $9f3b2ca04e3d8775$var$gl.uniform2f($9f3b2ca04e3d8775$var$blurProgram.uniforms.texelSize, target.texelSizeX, 0.0);
        $9f3b2ca04e3d8775$var$gl.uniform1i($9f3b2ca04e3d8775$var$blurProgram.uniforms.uTexture, target.attach(0));
        $9f3b2ca04e3d8775$var$blit(temp.fbo);
        $9f3b2ca04e3d8775$var$gl.uniform2f($9f3b2ca04e3d8775$var$blurProgram.uniforms.texelSize, 0.0, target.texelSizeY);
        $9f3b2ca04e3d8775$var$gl.uniform1i($9f3b2ca04e3d8775$var$blurProgram.uniforms.uTexture, temp.attach(0));
        $9f3b2ca04e3d8775$var$blit(target.fbo);
    }
}
function $9f3b2ca04e3d8775$var$send_splatPointer(pointer) {
    let dx = pointer.deltaX * $9f3b2ca04e3d8775$var$config.SPLAT_FORCE;
    let dy = pointer.deltaY * $9f3b2ca04e3d8775$var$config.SPLAT_FORCE;
    $9f3b2ca04e3d8775$var$send_splat(pointer.texcoordX, pointer.texcoordY, dx, dy, pointer.color);
}
function $9f3b2ca04e3d8775$var$multipleSplats(amount) {
    for(let i = 0; i < amount; i++){
        const color = $9f3b2ca04e3d8775$var$generateColor();
        color.r *= 10.0;
        color.g *= 10.0;
        color.b *= 10.0;
        const x = Math.random();
        const y = Math.random();
        const dx = 1000 * (Math.random() - 0.5);
        const dy = 1000 * (Math.random() - 0.5);
        $9f3b2ca04e3d8775$var$send_splat(x, y, dx, dy, color);
    }
}
function $9f3b2ca04e3d8775$var$send_splat(x, y, dx, dy, color) {
    $9f3b2ca04e3d8775$var$connection.invoke('splat', x, y, dx, dy, JSON.stringify(color));
}
$9f3b2ca04e3d8775$var$connection.on('broadSplat', (x, y, dx, dy, color)=>{
    let realColor = JSON.parse(color);
    //console.log("broadSplat", x, y, dx, dy, realColor);
    if ($9f3b2ca04e3d8775$var$splatHook) $9f3b2ca04e3d8775$var$splatHook(x, y, dx, dy, realColor);
    $9f3b2ca04e3d8775$var$splat(x, y, dx, dy, realColor);
});
$9f3b2ca04e3d8775$var$connection.on('broadConfig', (jsonConfig)=>{
    let realConfig = JSON.parse(jsonConfig);
    //console.log("broadConfig", realConfig);
    if ($9f3b2ca04e3d8775$var$queryStringContains("transparent")) realConfig.TRANSPARENT = true;
    $9f3b2ca04e3d8775$var$config = realConfig;
});
function $9f3b2ca04e3d8775$var$queryStringContains(txt) {
    return window.location.search && window.location.search.includes(txt);
}
function $9f3b2ca04e3d8775$var$splat(x, y, dx, dy, color) {
    $9f3b2ca04e3d8775$var$gl.viewport(0, 0, $9f3b2ca04e3d8775$var$velocity.width, $9f3b2ca04e3d8775$var$velocity.height);
    $9f3b2ca04e3d8775$var$splatProgram.bind();
    $9f3b2ca04e3d8775$var$gl.uniform1i($9f3b2ca04e3d8775$var$splatProgram.uniforms.uTarget, $9f3b2ca04e3d8775$var$velocity.read.attach(0));
    $9f3b2ca04e3d8775$var$gl.uniform1f($9f3b2ca04e3d8775$var$splatProgram.uniforms.aspectRatio, $9f3b2ca04e3d8775$var$canvas.width / $9f3b2ca04e3d8775$var$canvas.height);
    $9f3b2ca04e3d8775$var$gl.uniform2f($9f3b2ca04e3d8775$var$splatProgram.uniforms.point, x, y);
    $9f3b2ca04e3d8775$var$gl.uniform3f($9f3b2ca04e3d8775$var$splatProgram.uniforms.color, dx, dy, 0.0);
    $9f3b2ca04e3d8775$var$gl.uniform1f($9f3b2ca04e3d8775$var$splatProgram.uniforms.radius, $9f3b2ca04e3d8775$var$correctRadius($9f3b2ca04e3d8775$var$config.SPLAT_RADIUS / 100.0));
    $9f3b2ca04e3d8775$var$blit($9f3b2ca04e3d8775$var$velocity.write.fbo);
    $9f3b2ca04e3d8775$var$velocity.swap();
    $9f3b2ca04e3d8775$var$gl.viewport(0, 0, $9f3b2ca04e3d8775$var$dye.width, $9f3b2ca04e3d8775$var$dye.height);
    $9f3b2ca04e3d8775$var$gl.uniform1i($9f3b2ca04e3d8775$var$splatProgram.uniforms.uTarget, $9f3b2ca04e3d8775$var$dye.read.attach(0));
    $9f3b2ca04e3d8775$var$gl.uniform3f($9f3b2ca04e3d8775$var$splatProgram.uniforms.color, color.r, color.g, color.b);
    $9f3b2ca04e3d8775$var$blit($9f3b2ca04e3d8775$var$dye.write.fbo);
    $9f3b2ca04e3d8775$var$dye.swap();
}
function $9f3b2ca04e3d8775$var$correctRadius(radius) {
    let aspectRatio = $9f3b2ca04e3d8775$var$canvas.width / $9f3b2ca04e3d8775$var$canvas.height;
    if (aspectRatio > 1) radius *= aspectRatio;
    return radius;
}
$9f3b2ca04e3d8775$var$canvas.addEventListener('mousedown', (e)=>{
    let posX = $9f3b2ca04e3d8775$var$scaleByPixelRatio(e.offsetX);
    let posY = $9f3b2ca04e3d8775$var$scaleByPixelRatio(e.offsetY);
    let pointer = $9f3b2ca04e3d8775$var$pointers.find((p)=>p.id == -1);
    if (pointer == null) pointer = new $9f3b2ca04e3d8775$var$pointerPrototype();
    $9f3b2ca04e3d8775$var$updatePointerDownData(pointer, -1, posX, posY);
});
$9f3b2ca04e3d8775$var$canvas.addEventListener('mousemove', (e)=>{
    let pointer = $9f3b2ca04e3d8775$var$pointers[0];
    if (!pointer.down) return;
    let posX = $9f3b2ca04e3d8775$var$scaleByPixelRatio(e.offsetX);
    let posY = $9f3b2ca04e3d8775$var$scaleByPixelRatio(e.offsetY);
    $9f3b2ca04e3d8775$var$updatePointerMoveData(pointer, posX, posY);
});
window.addEventListener('mouseup', ()=>{
    $9f3b2ca04e3d8775$var$updatePointerUpData($9f3b2ca04e3d8775$var$pointers[0]);
});
$9f3b2ca04e3d8775$var$canvas.addEventListener('touchstart', (e)=>{
    e.preventDefault();
    const touches = e.targetTouches;
    while(touches.length >= $9f3b2ca04e3d8775$var$pointers.length)$9f3b2ca04e3d8775$var$pointers.push(new $9f3b2ca04e3d8775$var$pointerPrototype());
    for(let i = 0; i < touches.length; i++){
        let posX = $9f3b2ca04e3d8775$var$scaleByPixelRatio(touches[i].pageX);
        let posY = $9f3b2ca04e3d8775$var$scaleByPixelRatio(touches[i].pageY);
        $9f3b2ca04e3d8775$var$updatePointerDownData($9f3b2ca04e3d8775$var$pointers[i + 1], touches[i].identifier, posX, posY);
    }
});
$9f3b2ca04e3d8775$var$canvas.addEventListener('touchmove', (e)=>{
    e.preventDefault();
    const touches = e.targetTouches;
    for(let i = 0; i < touches.length; i++){
        let pointer = $9f3b2ca04e3d8775$var$pointers[i + 1];
        if (!pointer.down) continue;
        let posX = $9f3b2ca04e3d8775$var$scaleByPixelRatio(touches[i].pageX);
        let posY = $9f3b2ca04e3d8775$var$scaleByPixelRatio(touches[i].pageY);
        $9f3b2ca04e3d8775$var$updatePointerMoveData(pointer, posX, posY);
    }
}, false);
window.addEventListener('touchend', (e)=>{
    const touches = e.changedTouches;
    for(let i = 0; i < touches.length; i++){
        let pointer = $9f3b2ca04e3d8775$var$pointers.find((p)=>p.id == touches[i].identifier);
        if (pointer == null) continue;
        $9f3b2ca04e3d8775$var$updatePointerUpData(pointer);
    }
});
window.addEventListener('keydown', (e)=>{
    if (e.code === 'KeyP') $9f3b2ca04e3d8775$var$config.PAUSED = !$9f3b2ca04e3d8775$var$config.PAUSED;
    if (e.code === 'KeyJ') console.log(JSON.stringify($9f3b2ca04e3d8775$var$config, null, "\t"));
    if (e.key === ' ') $9f3b2ca04e3d8775$var$randomSplatsNow(parseInt(Math.random() * 20) + 5);
});
function $9f3b2ca04e3d8775$var$updatePointerDownData(pointer, id, posX, posY) {
    pointer.id = id;
    pointer.down = true;
    pointer.moved = false;
    pointer.texcoordX = posX / $9f3b2ca04e3d8775$var$canvas.width;
    pointer.texcoordY = 1.0 - posY / $9f3b2ca04e3d8775$var$canvas.height;
    pointer.prevTexcoordX = pointer.texcoordX;
    pointer.prevTexcoordY = pointer.texcoordY;
    pointer.deltaX = 0;
    pointer.deltaY = 0;
    pointer.color = $9f3b2ca04e3d8775$var$generateColor();
}
function $9f3b2ca04e3d8775$var$updatePointerMoveData(pointer, posX, posY) {
    pointer.prevTexcoordX = pointer.texcoordX;
    pointer.prevTexcoordY = pointer.texcoordY;
    pointer.texcoordX = posX / $9f3b2ca04e3d8775$var$canvas.width;
    pointer.texcoordY = 1.0 - posY / $9f3b2ca04e3d8775$var$canvas.height;
    pointer.deltaX = $9f3b2ca04e3d8775$var$correctDeltaX(pointer.texcoordX - pointer.prevTexcoordX);
    pointer.deltaY = $9f3b2ca04e3d8775$var$correctDeltaY(pointer.texcoordY - pointer.prevTexcoordY);
    pointer.moved = Math.abs(pointer.deltaX) > 0 || Math.abs(pointer.deltaY) > 0;
}
function $9f3b2ca04e3d8775$var$updatePointerUpData(pointer) {
    pointer.down = false;
}
function $9f3b2ca04e3d8775$var$correctDeltaX(delta) {
    let aspectRatio = $9f3b2ca04e3d8775$var$canvas.width / $9f3b2ca04e3d8775$var$canvas.height;
    if (aspectRatio < 1) delta *= aspectRatio;
    return delta;
}
function $9f3b2ca04e3d8775$var$correctDeltaY(delta) {
    let aspectRatio = $9f3b2ca04e3d8775$var$canvas.width / $9f3b2ca04e3d8775$var$canvas.height;
    if (aspectRatio > 1) delta /= aspectRatio;
    return delta;
}
function $9f3b2ca04e3d8775$var$generateColor() {
    let c = $9f3b2ca04e3d8775$var$HSVtoRGB(Math.random(), 1.0, 1.0);
    c.r *= 0.15;
    c.g *= 0.15;
    c.b *= 0.15;
    return c;
}
function $9f3b2ca04e3d8775$var$HSVtoRGB(h, s, v) {
    let r, g, b, i, f, p, q, t;
    i = Math.floor(h * 6);
    f = h * 6 - i;
    p = v * (1 - s);
    q = v * (1 - f * s);
    t = v * (1 - (1 - f) * s);
    switch(i % 6){
        case 0:
            r = v, g = t, b = p;
            break;
        case 1:
            r = q, g = v, b = p;
            break;
        case 2:
            r = p, g = v, b = t;
            break;
        case 3:
            r = p, g = q, b = v;
            break;
        case 4:
            r = t, g = p, b = v;
            break;
        case 5:
            r = v, g = p, b = q;
            break;
    }
    return {
        r: r,
        g: g,
        b: b
    };
}
function $9f3b2ca04e3d8775$var$normalizeColor(input) {
    let output = {
        r: input.r / 255,
        g: input.g / 255,
        b: input.b / 255
    };
    return output;
}
function $9f3b2ca04e3d8775$var$wrap(value1, min, max) {
    let range = max - min;
    if (range == 0) return min;
    return (value1 - min) % range + min;
}
function $9f3b2ca04e3d8775$var$getResolution(resolution) {
    let aspectRatio = $9f3b2ca04e3d8775$var$gl.drawingBufferWidth / $9f3b2ca04e3d8775$var$gl.drawingBufferHeight;
    if (aspectRatio < 1) aspectRatio = 1.0 / aspectRatio;
    let min = Math.round(resolution);
    let max = Math.round(resolution * aspectRatio);
    if ($9f3b2ca04e3d8775$var$gl.drawingBufferWidth > $9f3b2ca04e3d8775$var$gl.drawingBufferHeight) return {
        width: max,
        height: min
    };
    else return {
        width: min,
        height: max
    };
}
function $9f3b2ca04e3d8775$var$getTextureScale(texture, width, height) {
    return {
        x: width / texture.width,
        y: height / texture.height
    };
}
function $9f3b2ca04e3d8775$var$scaleByPixelRatio(input) {
    let pixelRatio = window.devicePixelRatio || 1;
    return Math.floor(input * pixelRatio);
}
function $9f3b2ca04e3d8775$var$hashCode(s) {
    if (s.length == 0) return 0;
    let hash = 0;
    for(let i = 0; i < s.length; i++){
        hash = (hash << 5) - hash + s.charCodeAt(i);
        hash |= 0; // Convert to 32bit integer
    }
    return hash;
}


//# sourceMappingURL=js.0edc2681.js.map
